export function generateCustomObjects(joint){
  //IIFE to load shape importing functions
  //Shape library below with functions bound to 'this' to expose them as public functions
  //stencil Tooltip


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Template for markup/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd = joint.shapes.pfd || {};
  joint.shapes.pfd.TemplateObject = joint.dia.Element.define('pfd.TemplateObject', {
    ports: {
      groups: {
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
        'out': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
      },
      items: []
    },
    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 6
      }
    }]
  }, {
    markup: [{
      tagName: 'path',
      selector: 'body',
      className: 'elementBody'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject',
      className: 'foreignObjectclass',
      style: {
        'height': '400px',
        'width': '400px',
        'overflow': 'visible',
        'pointer-events': 'none',
        'display': 'none'
      },
      children: [{
        tagName: 'div',
        selector: 'shapename',
        className: 'shapename',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        attributes: {
          'content-editable': 'true',
          'overflow': 'visible',
          'id': 'placeHolderQuillId',
          'name': 'shapename',
        },
        style: {
          position: 'absolute',
          width: '60px',
          zIndex: 100,
          overflow: 'visible',
          height: '30px',
          backgroundColor: 'transparent',
          textAlign: 'center',
          fontSize: 12,
          fontFamily: 'Arial',
          cursor: 'move',
          boxSizing: 'border-box',
          pointerEvents: 'auto',
        }
      }]
    }]
  }
    , {
      attributes: {
        innerHTML: {
          set: function (html, _, node) {
            if ('innerHTML' in node) {
              node.innerHTML = html;
            }
          }
        },
        style: {
          display: {
            set: function (styleDisplay, _, node) {
              if ('display' in node) {
                node.style.display = styleDisplay;
              }
            }
          },
          top: {
            set: function (styleTop, _, node) {
              if ('top' in node) {
                node.style.top = styleTop;
              }
            }
          },
          left: {
            set: function (styleLeft, _, node) {
              if ('left' in node) {
                node.style.left = styleLeft;
              }
            }
          },
          width: {
            set: function (styleWidth, _, node) {
              if ('width' in node) {
                node.style.width = styleWidth;
              }
            }
          },
          height: {
            set: function (styleHeight, _, node) {
              if ('height' in node) {
                node.style.height = styleHeight;
              }
            }
          }
        }
      }
    });
    joint.shapes.pfd.TemplateObjectView = joint.dia.ElementView.extend({
      events: {
          'input .ql-editor': 'onQuillInput',
          'keyup .ql-editor': 'onQuillKeyUp',
          'mouseover div': 'onQuillEdit',
          'mousemove div': 'onQuillDrag',
      },
  
      initialize: function() {
          joint.dia.ElementView.prototype.initialize.apply(this, arguments);
          
          this.lastSaveContent = null;
          this.saveTimeout = null;
          
          this.debouncedSave = _.debounce((content) => {
              this.lastSaveContent = content;
              
              if (this.saveTimeout) {
                  clearTimeout(this.saveTimeout);
              }
              
              this.saveTimeout = setTimeout(() => {
                  if (!(this.lastSaveContent.includes('viewBox') || this.lastSaveContent === '')) {
                      this.model.attr('shapename/innerHTML', this.lastSaveContent);
                  }
                  this.saveTimeout = null;
                  this.lastSaveContent = null;
              }, 0);
          }, 1000);
      },

      cleanup: function() {
        if (this.debouncedSave && this.debouncedSave.cancel) {
            this.debouncedSave.cancel();
        }
        
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
            this.saveTimeout = null;
        }
        
        if (this.lastSaveContent && 
            !(this.lastSaveContent.includes('viewBox') || this.lastSaveContent === '')) {
            this.model.attr('shapename/innerHTML', this.lastSaveContent);
        }
        
        this.lastSaveContent = null;
      },

  
      onQuillInput: function(evt) {
          this.debouncedSave(evt.target.innerHTML);
          evt.target.style.height = `${evt.target.scrollHeight}px`;
      },

      onQuillKeyUp: function(evt) {
          if (evt.key === 'Backspace' || evt.key === 'Delete') {
              this.debouncedSave(evt.target.innerHTML);
          }
      },

      onQuillEdit: function(evt) {
          this.model.toFront();
      },

      onQuillDrag: function(evt) {
          if ((evt.target.parentNode) && evt.target.parentNode.id.includes('QuillDiv')) {
              this.model.attr('shapename/style', {
                  top: evt.target.parentNode.style.top,
                  left: evt.target.parentNode.style.left,
                  width: evt.target.parentNode.style.width,
                  height: evt.target.parentNode.style.height
              });
          }
      },
  
      remove: function() {
          this.cleanup();
          joint.dia.ElementView.prototype.remove.apply(this, arguments);
      }
  });

  //
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/PumpObject/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.PumpObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.PumpObject',
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '47%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '12%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 3 0 A 1 1 0 0 0 3 6 M 3 0 L 7.25 0 L 7.25 2 L 5.83 2 C 6.5 4.1 5 6 3 6 M 1 5.25 L 0 6.5 L 3 6.5 L 6 6.5 L 5 5.25 Q 4.1 6 3 6 M 3 2 A 1 1 0 0 0 3 4 M 3 2 A 1 1 0 0 1 3 4',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: '0%',
          refY: '120%'
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.PumpObjectView = joint.shapes.pfd.TemplateObjectView

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Circle~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.CircleObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.CircleObject',
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 A 1 1 0 0 0 4 0 A 1 1 0 0 0 0 0',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: '0%',
          refY: '120%'
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });

  joint.shapes.pfd.CircleObjectView= joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Feed/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.FeedObject = joint.dia.Element.define('pfd.FeedObject', {
    size: { width: 10, height: 4 },
    ports: {
      groups: {
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
        'out': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
      },

      items: [
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 6
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],

    attrs: {
      body: {
        refD: 'M 0 0 L 9 0 L 10 1.5 L 9 3 L 0 3 L 0 0 Z',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject1: {
        refWidth: '100%',
        refHeight: '100%',
        ref: 'body',
        refX: '-2%',
        refY: '15%'
      },
      foreignObject: {
        refWidth: '1%',
        refHeight: '1%',
        ref: 'body',
        refX: -15,
        refY: 40
      }
    }
  }, {
    markup: [{
      tagName: 'path',
      selector: 'body',
      className: 'elementBody'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject1',
      className: 'foreignObjectclass',
      style: {
        'overflow': 'visible',
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'transparent',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
        },
        /*
        children:[{
          tagName: 'input',
          selector: 'tagInput',
          attributes: {
            'name': 'tagInput',
            'overflow': 'visible',

          },
          style: {
            position: 'relative',
            border: '0px solid #000',
            backgroundColor: 'transparent',
            fontSize: '10px',
            textAlign: 'left',
            width: '70%',
            overflow: 'visible'
          
    }]}*/
  }]},{
      tagName: 'foreignObject',
      selector: 'foreignObject',
      className: 'foreignObjectclass',
      style: {
        'height': '400px',
        'width': '400px',
        'overflow': 'visible',
        'pointer-events': 'none',
        'display':'none'
      },
      children: [{
        tagName: 'div',
        selector: 'shapename',
        className: 'shapename',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        attributes: {
          'content-editable': 'true',
          'overflow': 'visible',
          'id': 'placeHolderQuillId'
        },
        style: {
          position: 'absolute',
          width: '60px',
          zIndex: 100,
          overflow: 'visible',
          height: '20px',
          backgroundColor: 'transparent',
          textAlign: 'center',
          fontSize: 12,
          fontFamily: 'Arial',
          cursor: 'move',
          boxSizing: 'border-box',
          pointerEvents: 'auto',
          left: '20px',
          top: '-30px'
        }
      }]
    }]
  }
  , {
    attributes: {
      innerHTML: {
        set: function (html, _, node) {
          if ('innerHTML' in node) {
            node.innerHTML = html;
          }
        }
      },
      value: {
        set: function (text, _, node) {
          if ('value' in node) {
            node.value = text;
          }
        }
      },
      style: {
        display: {
          set: function (styleDisplay, _, node) {
            if ('display' in node) {
              node.style.display = styleDisplay;
            }
          }
        },
        top: {
          set: function (styleTop, _, node) {
            if ('top' in node) {
              node.style.top = styleTop;
            }
          }
        },
        left: {
          set: function (styleLeft, _, node) {
            if ('left' in node) {
              node.style.left = styleLeft;
            }
          }
        },
        width: {
          set: function (styleWidth, _, node) {
            if ('width' in node) {
              node.style.width = styleWidth;
            }
          }
        },
        height: {
          set: function (styleHeight, _, node) {
            if ('height' in node) {
              node.style.height = styleHeight;
            }
          }
        }
      }
    }
  });

  joint.shapes.pfd.FeedObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Link Tools/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.linkTools.InfoButton = joint.linkTools.Button.extend({
    name: 'info-button',
    options: {
      focusOpacity: 0.5,
      distance: 60,
      offset: 0,
      action: function (evt) {
        if (this.model.prop('CustomName') != '')
        {stream_Property_Popup(this.model.id)}
        else{
          alert('To add properties to this segment, please provide a unique label (double click).\nAlternatively, you could find a segment of this stream that already has a label, and can add properties there.')
        }
      },
      markup: [{
        tagName: 'circle',
        selector: 'button',
        attributes: {
          'r': 10,
          'fill': '#ffffff',
          'cursor': 'pointer',
          'stroke': '#696B8A'
        }
      }, {
        tagName: 'path',
        selector: 'icon',
        attributes: {
          'd': 'M -2 4 2 4 M 0 3 0 0 M -2 -1 1 -1 M -1 -4 1 -4',
          'fill': 'none',
          'stroke': '#696B8A',
          'stroke-width': 2,
          'pointer-events': 'none'
        }
      }]
    }
  });


  joint.linkTools.SplitButton = joint.linkTools.Button.extend({
    name: 'split-button',
    options: {
      focusOpacity: 0.5,
      distance: 60,
      offset: 0,
      rotate: true,
      action: function (evt) {
        connect_Pipework_Shape(this.model)
        return;
      },
      markup: [{
        tagName: 'circle',
        selector: 'button',
        attributes: {
          'r': 10,
          'fill': '#FFFFFF',
          'cursor': 'pointer',
          'stroke': '#696B8A'
        }
      }, {
        tagName: 'path',
        selector: 'icon',
        attributes: {
          'd': 'M 0 5 L 0 -5 M -5 0 L 5 0',
          'fill': 'none',
          'stroke': '#696B8A',
          'stroke-width': 2,
          'pointer-events': 'none'
        }
      }]
    }
  });

  joint.linkTools.ValveButton = joint.linkTools.Button.extend({
    name: 'valve-button',
    options: {
      focusOpacity: 0.5,
      distance: 60,
      offset: 22,
      rotate: true,
      action: function (evt) {
        connect_Valve_Shape(this.model)
        return;
      },
      markup: [{
        tagName: 'circle',
        selector: 'button',
        attributes: {
          'r': 10,
          'fill': '#FFFFFF',
          'cursor': 'pointer',
          'stroke': '#696B8A'
        }
      }, {
        tagName: 'path',
        selector: 'icon',
        attributes: {
          'd': 'M -6 -4 L 6 4 L 6 -4 L -6 4 Z',
          'fill': '#696B8A',
          'stroke': '#696B8A',
          'stroke-width': 1,
          'pointer-events': 'none'
        }
      }]
    }
  });

  joint.linkTools.SensorButton = joint.linkTools.Button.extend({
    name: 'sensor-button',
    options: {
      focusOpacity: 0.5,
      distance: 60,
      offset: -22,
      rotate: false,
      action: function (evt) {
        connect_Sensor_Shape(this.model)
        return;
      },
      markup: [{
        tagName: 'circle',
        selector: 'button',
        attributes: {
          'r': 10,
          'fill': '#FFFFFF',
          'cursor': 'pointer',
          'stroke': '#696B8A'
        }
      }, {
        tagName: 'path',
        selector: 'icon',
        attributes: {
          'd': 'M 2.4 -2.4 L 1.6 -3.2 C 0.8 -4 -0.8 -4 -1.6 -3.2 C -2.4 -2.4 -2.4 -1.6 -1.6 -0.8 C 0 0 1.6 0.8 1.6 0.8 C 2.4 1.6 2.4 2.4 1.6 3.2 C 0.8 4 -0.8 4 -1.6 3.2 L -2.4 2.4',
          'fill': '#FFFFFF',
          'stroke': '#696B8A',
          'stroke-width': 2,
          'pointer-events': 'none'
        }
      }]
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/TP Object/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pid = joint.shapes.pid || {};
  joint.shapes.pid.TPObject = joint.dia.Element.define('pid.TPObject', {
    size: { width: 7, height: 7 },
    ports: {
      groups: {
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
        'out': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
      },

      items: [
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 3
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],
    attrs: {
      body: {
        refD: 'M 0 6 A 1 1 0 0 0 0 0 A 1 1 0 0 0 0 6 M -3 3 L 3 3',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject1: {
        refWidth: '80%',
        refHeight: '100%',
        ref: 'body',
        refX: '10%',
        refY: '10%'
      }
    }
  }, {
    markup: [{
      tagName: 'path',
      selector: 'body',
      className: 'elementBody'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject1',
      className: 'foreignObjectclass',
      style: {
        'overflow': 'visible',
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'transparent',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
        },
        children:[
          {
          tagName: 'input',
          selector: 'tagInput',
          attributes: {
            'name': 'tagInput',
            'overflow': 'visible',

          },
          style: {
            position: 'relative',
            border: '0px solid #000',
            backgroundColor: 'transparent',
            fontSize: '10px',
            textAlign: 'center',
            width: '80%',
            overflow: 'visible'
          }
    },
          {
          tagName: 'input',
          selector: 'tagInput2',
          attributes: {
            'name': 'tagInput2',
            'overflow': 'visible',

          },
          style: {
            position: 'relative',
            backgroundColor: 'transparent',
            border: '0px solid #000',
            fontSize: '10px',
            textAlign: 'center',
            width: '80%',
            overflow: 'visible',
            //top: '5px'

          }
    }
  ]
  }]}]
  }
    , {
      attributes: {
        value: {
          set: function (text, _, node) {
            if ('value' in node) {
              node.value = text;
            }
          }
        }
      }
    });

    joint.shapes.pid.TPObjectView = joint.shapes.pfd.TemplateObjectView.extend({
      events: _.extend({}, joint.shapes.pfd.TemplateObjectView.prototype.events, {
          'mouseover div': 'onQuillEdit',
          'change input': 'onTagInput'
      }),
      onQuillInput: function(evt) {
        this.debouncedSave(evt.target.innerHTML);
      },
      onQuillEdit: function(evt) {
          this.model.toFront();
      },
      onTagInput: function(evt) {
          var input = evt.target;
          this.model.attr(input.name + '/value', input.value);
      }
    });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Controller Object/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  joint.shapes.pid.ControllerObject = joint.dia.Element.define('pid.ControllerObject', {
    size: { width: 7, height: 7 },
    ports: {
      groups: {
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
        'out': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
      },

      items: [
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 3
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],
    attrs: {
      body: {
        refD: 'M 0 6 A 1 1 0 0 0 0 0 A 1 1 0 0 0 0 6 M -3 3 L 3 3 M -3 0 L 3 0 L 3 6 L -3 6 Z',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject1: {
        refWidth: '80%',
        refHeight: '100%',
        ref: 'body',
        refX: '10%',
        refY: '10%'
      }
    }
  }, {
    markup: [{
      tagName: 'path',
      selector: 'body',
      className: 'elementBody'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject1',
      className: 'foreignObjectclass',
      style: {
        'overflow': 'visible',
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'transparent',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
        },
        children:[
          {
          tagName: 'input',
          selector: 'tagInput',
          attributes: {
            'name': 'tagInput',
            'overflow': 'visible',

          },
          style: {
            position: 'relative',
            border: '0px solid #000',
            backgroundColor: 'transparent',
            fontSize: '10px',
            textAlign: 'center',
            width: '80%',
            overflow: 'visible'
          }
    },
          {
          tagName: 'input',
          selector: 'tagInput2',
          attributes: {
            'name': 'tagInput2',
            'overflow': 'visible',

          },
          style: {
            position: 'relative',
            backgroundColor: 'transparent',
            border: '0px solid #000',
            fontSize: '10px',
            textAlign: 'center',
            width: '80%',
            overflow: 'visible',
            //top: '5px'

          }
    }
  ]
  }]}]
  }
    , {
      attributes: {
        value: {
          set: function (text, _, node) {
            if ('value' in node) {
              node.value = text;
            }
          }
        }
      }
    });

    joint.shapes.pid.ControllerObjectView = joint.shapes.pfd.TemplateObjectView.extend({
      events: _.extend({}, joint.shapes.pfd.TemplateObjectView.prototype.events, {
          'mouseover div': 'onQuillEdit',
          'change input': 'onTagInput'
      }),
      onQuillEdit: function(evt) {
          this.model.toFront();
      },
      onTagInput: function(evt) {
          var input = evt.target;
          this.model.attr(input.name + '/value', input.value);
      },
      onQuillInput: function(evt) {
        this.debouncedSave(evt.target.innerHTML);
    }
    });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Mixer/Splitter~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pipework = joint.shapes.pipework || {}
  joint.shapes.pipework.MixerSplitterObject = joint.dia.Element.define('pipework.MixerSplitterObject', {
    size: { width: 60, height: 60 },
    ports: {
      groups: {

        'out': {
          position: {
            name: 'absolute',
            args: {}
          },

        },
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        }
      },

      items: [

        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        // needs to be less than the others for the others to preferentially slide
        r: 5
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],
    attrs: {
      body: {
        d: 'M 0 0 L 0 60 L 60 60 L 60 0 Z',
        stroke: 'none',
        fill: 'white',
      },
      crosshairs: {
        d: 'M 30 0 L 30 30 M 30 30 L 60 30 M 30 30 L 30 60 M 30 30 L 0 30',
        stroke: 'black',
        strokeWidth: '1px'
      },
      topline: {
        d: 'M 30 0 L 30 30',
        stroke: 'none',
        fill: 'none'
      },
      toplinearrow: {
        d: 'M 30 30 L 18 5 L 42 5 Z',
        stroke: 'none',
        fill: 'none'
      },
      rightline: {
        d: 'M 30 30 L 60 30',
        stroke: 'none',
        fill: 'none'
      },
      rightlinearrow: {
        d: 'M 55 18 L 30 30 L 55 42 Z',
        stroke: 'none',
        fill: 'none'
      },
      bottomline: {
        d: 'M 30 30 L 30 60',
        stroke: 'none',
        fill: 'none'
      },
      bottomlinearrow: {
        d: 'M 18 55 L 30 30 L 42 55 Z',
        stroke: 'none',
        fill: 'none'
      },
      leftline: {
        d: 'M 30 30 L 0 30',
        stroke: 'none',
        fill: 'none'
      },
      leftlinearrow: {
        d: 'M 5 18 L 30 30 L 5 42 Z',
        stroke: 'none',
        fill: 'none'
      }
     }
    ,
    markup: [{
      tagName: 'g',
      selector: 'scalable',
      className: 'scalable',
      children: [{
        tagName: 'path',
        type: 'path',
        selector: 'body',
        className: 'elementBody'
      },
      {
        tagName: 'path',
        type: 'path',
        className: 'pipework-crosshairs',
        selector: 'crosshairs'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'topline'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'rightline'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'bottomline'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'leftline'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'toplinearrow'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'rightlinearrow'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'bottomlinearrow'
      },
      {
        tagName: 'path',
        type: 'path',
        selector: 'leftlinearrow'
      },
      ]
    }]
  });

  joint.shapes.pipework.HorizValveObject = joint.dia.Element.define('pipework.HorizValveObject', {
    size: { width: 56, height: 35 },
    ports: {
      groups: {

        'out': {
          position: {
            name: 'absolute',
            args: {}
          },

        },
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        }
      },

      items: [

        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '68%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '68%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '68%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '68%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 6
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],
    attrs: {
      body: {
        d: 'M 0 3.5 L 12 9.5 L 12 3.5 L 0 9.5 Z M 6 6.5 L 6 1.5 M 10 1.5 C 9 -0.5 3 -0.5 2 1.5 Z',
        stroke: 'black',
        fill: 'white',
      },

    }
    ,
    markup: [{
      tagName: 'g',
      selector: 'scalable',
      className: 'scalable',
      children: [{
        tagName: 'path',
        type: 'path',
        selector: 'body',
        className: 'elementBody'
          }]
    }]
  });
  joint.shapes.pipework.VertValveObject = joint.dia.Element.define('pipework.VertValveObject', {
    size: { width: 35, height: 56 },
    ports: {
      groups: {

        'out': {
          position: {
            name: 'absolute',
            args: {}
          },

        },
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        }
      },

      items: [

        { group: 'in', args: { x: '32%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '32%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '32%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '32%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '68%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 6
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],
    attrs: {
      body: {
        d: 'M 6 0 L 0 12 L 6 12 L 0 0 Z M 3 6 L 8 6 M 8 10 C 10 9 10 3 8 2 Z',
        stroke: 'black',
        fill: 'white',
      },

    }
    ,
    markup: [{
      tagName: 'g',
      selector: 'scalable',
      className: 'scalable',
      children: [{
        tagName: 'path',
        type: 'path',
        selector: 'body',
        className: 'elementBody'
          }]
    }]
  });

  joint.shapes.pipework.SensorConnectorHorizObject = joint.dia.Element.define('pipework.SensorConnectorHorizObject', {
    size: { width: 30, height: 1 },
    ports: {
      groups: {

        'out': {
          position: {
            name: 'absolute',
            args: {}
          },

        },
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        }
      },

      items: [

        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 5
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],
    attrs: {
      body: {
        d: 'M 0 0 L 12 0 Z Z',
        stroke: 'black',
        fill: 'white',
      },

    }
    ,
    markup: [{
      tagName: 'g',
      selector: 'scalable',
      className: 'scalable',
      children: [{
        tagName: 'path',
        type: 'path',
        selector: 'body',
        className: 'elementBody'
          }]
    }]
  });
  joint.shapes.pipework.SensorConnectorVertObject = joint.dia.Element.define('pipework.SensorConnectorVertObject', {
    size: { width: 1, height: 30 },
    ports: {
      groups: {

        'out': {
          position: {
            name: 'absolute',
            args: {}
          },

        },
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        }
      },

      items: [

        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },

      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 5
        // If all the magnets are `true` / `passive` feel free to define
        // the magnet here in the default port markup or per a port group
        // 'magnet': true
      }
    }],
    attrs: {
      body: {
        d: 'M 0 0 L 0 12 Z Z',
        stroke: 'black',
        fill: 'white',
      },

    }
    ,
    markup: [{
      tagName: 'g',
      selector: 'scalable',
      className: 'scalable',
      children: [{
        tagName: 'path',
        type: 'path',
        selector: 'body',
        className: 'elementBody'
          }]
    }]
  });



  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~BFD Rectangle~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.bfd = joint.shapes.bfd || {};
  joint.shapes.bfd.RectangleQuillObject = joint.dia.Element.define('bfd.RectangleQuillObject', {
    size: { width: 20, height: 12 },
    ports: {
      groups: {
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
        'out': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
      },
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_8', attrs: { portBody: { magnet: 'true' } } }
      ]
    },
    portMarkup: [{
      tagName: 'circle',
      className: 'magnetTrial',
      selector: 'portBody',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 6
      }
    }],
    attrs: {
      body: {
        refD: 'M 0 0 L 8 0 L 8 4 L 0 4 Z',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        ref: 'body',
        refY: 6,
        refX: 6
      }
    }
  }, {
    markup: [{
      tagName: 'path',
      selector: 'body',
      className: 'elementBody'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject',
      className: 'foreignObjectclass',
      style: {
        'height': '400px',
        'width': '400px',
        'overflow': 'visible',
        'pointer-events': 'none',
        'display': 'none'
      },
      children: [{
        tagName: 'div',
        selector: 'shapename',
        className: 'blockbox',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        attributes: {
          'content-editable': 'true',
          'id': 'placeHolderQuillId'
        },
        style: {
          position: 'absolute',
          width: '80px',
          zIndex: 100,
          overflow: 'visible',
          height: '40px',
          backgroundColor: 'transparent',
          textAlign: 'center',
          fontSize: 12,
          fontFamily: 'Arial',
          cursor: 'move',
          boxSizing: 'border-box',
          pointerEvents: 'auto',
        }
      }]
    }]
  })
    , {
    attributes: {
      innerHTML: {
        set: function (html, _, node) {

          if ('innerHTML' in node) {
            node.innerHTML = html;
            console.log(node.id)
          }

        }
      },
      style: {
        top: {
          set: function (styleTop, _, node) {
            if ('top' in node) {
              node.style.top = styleTop;
              console.log(node.id)
            }

          }
        },
        left: {
          set: function (styleLeft, _, node) {
            if ('left' in node) {
              node.style.left = styleLeft;
              console.log(node.id)
            }

          }
        },
        width: {
          set: function (styleWidth, _, node) {
            if ('width' in node) {
              node.style.width = styleWidth;
              console.log(node.id)
            }

          }
        },
        height: {
          set: function (styleHeight, _, node) {
            if ('height' in node) {
              node.style.height = styleHeight;
              console.log(node.id)
            }

          }
        }
      }
    }
  };

  joint.shapes.bfd.RectangleQuillObjectView = joint.dia.ElementView.extend({

    events: {
      'blur div': 'onQuillInput',
      'mouseover div': 'onQuillEdit',
      'mousemove div': 'onQuillDrag'
    },
    onQuillInput: function (evt) {
      var contentEditableDiv = evt.target;
      //this.model.attr(contentEditableDiv.name + '/innerHTML', contentEditableDiv.innerHTML);
      //commandManager.initBatchCommand()
      //this.model.prop('innerHTML', contentEditableDiv.innerHTML);
      if (!(evt.target.innerHTML.includes('viewBox') || (evt.target.innerHTML == ''))) {
        //console.log(evt.target.innerHTML)
        this.model.attr('shapename/innerHTML', evt.target.innerHTML);
      }
    },
    onQuillEdit: function (evt) {
      this.model.toFront();
    },
    onQuillDrag: function (evt) {
      //console.log(evt.target.parentNode.id)
      //console.log(evt.target.parentNode.style.top)
      if ((evt.target.parentNode) && evt.target.parentNode.id.includes('QuillDiv')) {
        this.model.attr('shapename/style', {
          top: evt.target.parentNode.style.top,
          left: evt.target.parentNode.style.left,
          width: evt.target.parentNode.style.width,
          height: evt.target.parentNode.style.height
        })
      }

    }
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Textbox rectangle Quill~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.bfd.textBlockObject = joint.dia.Element.define('bfd.textBlockObject', {
    size: { width: 20, height: 12 },
    ports: {
      groups: {
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
        'out': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
      },
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_8', attrs: { portBody: { magnet: 'true' } } }
      ]
    },
    portMarkup: [{
      tagName: 'circle',
      className: 'magnetTrial',
      selector: 'portBody',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 6
      }
    }],
    attrs: {
      body: {
        refD: 'M 0 0 L 1 0 M 2 0 L 3 0 M 4 0 L 5 0 M 6 0 L 7 0 M 8 0 L 8 1 M 8 2 L 8 3 M 8 4 L 7 4 M 6 4 L 5 4 M 4 4 L 3 4 M 2 4 L 1 4 M 0 4 L 0 3 M 0 2 L 0 1',
        stroke: 'black',
        fill: 'transparent',
        'data-tooltip': 'Click to remove the object',
        'data-tooltip-class-name': 'small',
        'data-tooltip-position': 'right'
      },
      backBody: {
        refD: 'M 0 0 L 8 0 L 8 4 L 0 4 L 0 0',
        stroke: 'transparent',
        fill: 'transparent'
      },
      forBody: {
        refD: 'M 4.042 2.507 L 4.412 2.077 L 4.056 1.665 L 4.196 1.543 L 4.518 1.959 L 4.834 1.551 L 4.968 1.665 L 4.622 2.069 L 5.002 2.507 L 4.866 2.623 L 4.516 2.189 L 4.17 2.619 L 4.042 2.507 Z M 3.936 2.159 L 3.208 2.159 A 0.4818 0.4818 90 0 0 3.2308 2.2595 Q 3.2575 2.3358 3.31 2.387 Q 3.394 2.469 3.532 2.469 Q 3.622 2.469 3.694 2.45 Q 3.766 2.431 3.832 2.401 L 3.874 2.555 A 0.7081 0.7081 90 0 1 3.7776 2.5918 A 0.8853 0.8853 90 0 1 3.712 2.609 A 0.8142 0.8142 90 0 1 3.6102 2.6246 A 1.0921 1.0921 90 0 1 3.51 2.629 A 0.5836 0.5836 90 0 1 3.3941 2.6179 A 0.4722 0.4722 90 0 1 3.308 2.592 Q 3.218 2.555 3.155 2.486 A 0.4425 0.4425 90 0 1 3.0821 2.376 A 0.5515 0.5515 90 0 1 3.058 2.316 A 0.6316 0.6316 90 0 1 3.031 2.1969 A 0.8563 0.8563 90 0 1 3.024 2.085 A 0.6976 0.6976 90 0 1 3.0401 1.9331 A 0.6119 0.6119 90 0 1 3.058 1.869 A 0.554 0.554 90 0 1 3.1143 1.75 A 0.483 0.483 90 0 1 3.154 1.696 Q 3.216 1.623 3.302 1.582 Q 3.388 1.541 3.494 1.541 A 0.5582 0.5582 90 0 1 3.5921 1.5492 A 0.4124 0.4124 90 0 1 3.69 1.579 Q 3.774 1.617 3.83 1.683 Q 3.886 1.749 3.914 1.837 A 0.607 0.607 90 0 1 3.9419 2.0138 A 0.6811 0.6811 90 0 1 3.942 2.023 A 1.5041 1.5041 90 0 1 3.9362 2.1569 A 1.3885 1.3885 90 0 1 3.936 2.159 Z M 2.384 1.603 L 2.422 1.275 L 2.56 1.275 L 2.56 1.603 L 2.848 1.603 L 2.848 1.759 L 2.56 1.759 L 2.56 2.261 A 0.4335 0.4335 90 0 0 2.5618 2.302 Q 2.5637 2.322 2.5676 2.3393 A 0.2206 0.2206 90 0 0 2.573 2.359 Q 2.586 2.399 2.608 2.423 Q 2.63 2.447 2.661 2.458 Q 2.692 2.469 2.726 2.469 A 0.2779 0.2779 90 0 0 2.8033 2.4584 A 0.2574 0.2574 90 0 0 2.82 2.453 Q 2.864 2.437 2.904 2.415 L 2.954 2.559 A 0.3709 0.3709 90 0 1 2.9216 2.5761 Q 2.9056 2.5837 2.8867 2.5912 A 0.8673 0.8673 90 0 1 2.846 2.606 Q 2.778 2.629 2.704 2.629 A 0.37 0.37 90 0 1 2.6004 2.6152 A 0.279 0.279 90 0 1 2.467 2.531 A 0.3157 0.3157 90 0 1 2.4035 2.4165 Q 2.3881 2.3687 2.3828 2.3106 A 0.7008 0.7008 90 0 1 2.38 2.247 L 2.38 1.759 L 2.2 1.759 L 2.2 1.603 L 2.384 1.603 Z M 5.226 1.603 L 5.264 1.275 L 5.402 1.275 L 5.402 1.603 L 5.69 1.603 L 5.69 1.759 L 5.402 1.759 L 5.402 2.261 A 0.4335 0.4335 90 0 0 5.4038 2.302 Q 5.4057 2.322 5.4096 2.3393 A 0.2206 0.2206 90 0 0 5.415 2.359 Q 5.428 2.399 5.45 2.423 Q 5.472 2.447 5.503 2.458 Q 5.534 2.469 5.568 2.469 A 0.2779 0.2779 90 0 0 5.6453 2.4584 A 0.2574 0.2574 90 0 0 5.662 2.453 Q 5.706 2.437 5.746 2.415 L 5.796 2.559 A 0.3709 0.3709 90 0 1 5.7636 2.5761 Q 5.7476 2.5837 5.7287 2.5912 A 0.8673 0.8673 90 0 1 5.688 2.606 Q 5.62 2.629 5.546 2.629 A 0.37 0.37 90 0 1 5.4424 2.6152 A 0.279 0.279 90 0 1 5.309 2.531 A 0.3157 0.3157 90 0 1 5.2455 2.4165 Q 5.2301 2.3687 5.2248 2.3106 A 0.7008 0.7008 90 0 1 5.222 2.247 L 5.222 1.759 L 5.042 1.759 L 5.042 1.603 L 5.226 1.603 Z M 3.206 2.013 L 3.776 2.013 A 0.4871 0.4871 90 0 0 3.7679 1.9213 Q 3.758 1.8696 3.7359 1.8291 A 0.2484 0.2484 90 0 0 3.7 1.779 A 0.2498 0.2498 90 0 0 3.5608 1.7035 A 0.3679 0.3679 90 0 0 3.49 1.697 Q 3.372 1.697 3.297 1.777 A 0.2948 0.2948 90 0 0 3.2411 1.8651 Q 3.2246 1.9042 3.215 1.9522 A 0.6457 0.6457 90 0 0 3.206 2.013 Z M 0 0 L 1 0 M 2 0 L 3 0 M 4 0 L 5 0 M 6 0 L 7 0 M 8 0 L 8 1 M 8 2 L 8 3 M 7 4 L 8 4 M 6 4 L 5 4 M 4 4 L 3 4 M 2 4 L 1 4 M 0 4 L 0 3 M 0 2 L 0 1',
        stroke: 'black',
        fill: 'black'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        ref: 'body',
        refY: 6,
        refX: 6
      }
    }
  }, {
    markup: [{
      tagName: 'path',
      selector: 'body',
      className: 'elementBody'
    },
    {
      tagName: 'path',
      selector: 'forBody',
      className: 'elementforBody'
    },
    {
      tagName: 'path',
      selector: 'backBody',
      className: 'elementbackBody'
    },
    {
      tagName: 'foreignObject',
      selector: 'foreignObject',
      className: 'foreignObjectclass',
      style: {
        'height': '400px',
        'width': '400px',
        'overflow': 'visible',
        'pointer-events': 'none',
        'display': 'none'
      },
      children: [{
        tagName: 'div',
        selector: 'shapename',
        className: 'blockbox',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        attributes: {
          'content-editable': 'true',
          'overflow': 'visible',
          'id': 'placeHolderQuillId'
        },
        style: {
          position: 'absolute',
          width: '88px',
          zIndex: 100,
          overflow: 'visible',
          height: '38px',
          backgroundColor: 'transparent',
          textAlign: 'center',
          fontSize: 12,
          fontFamily: 'Arial',
          cursor: 'move',
          boxSizing: 'border-box',
          pointerEvents: 'auto'
        }
      }]
    }]
  })
    , {
    attributes: {
      innerHTML: {
        set: function (html, _, node) {

          if ('innerHTML' in node) {
            node.innerHTML = html;
            console.log(node.id)
          }

        }
      },
      style: {
        top: {
          set: function (styleTop, _, node) {
            if ('top' in node) {
              node.style.top = styleTop;
              console.log(node.id)
            }

          }
        },
        left: {
          set: function (styleLeft, _, node) {
            if ('left' in node) {
              node.style.left = styleLeft;
              console.log(node.id)
            }

          }
        },
        width: {
          set: function (styleWidth, _, node) {
            if ('width' in node) {
              node.style.width = styleWidth;
              console.log(node.id)
            }

          }
        },
        height: {
          set: function (styleHeight, _, node) {
            if ('height' in node) {
              node.style.height = styleHeight;
              console.log(node.id)
            }

          }
        }
      }
    }
  };

  joint.shapes.bfd.textBlockObjectView = joint.dia.ElementView.extend({

    events: {
      'blur div': 'onQuillInput',
      'mouseover div': 'onQuillEdit',
      'mousemove div': 'onQuillDrag'
    },
    onQuillInput: function (evt) {
      var contentEditableDiv = evt.target;
      //this.model.attr(contentEditableDiv.name + '/innerHTML', contentEditableDiv.innerHTML);
      //commandManager.initBatchCommand()
      //this.model.prop('innerHTML', contentEditableDiv.innerHTML);
      if (!(evt.target.innerHTML.includes('viewBox') || (evt.target.innerHTML == ''))) {
        //console.log(evt.target.innerHTML)
        this.model.attr('shapename/innerHTML', evt.target.innerHTML);
      }
    },
    onQuillEdit: function (evt) {
      this.model.toFront();
    },
    onQuillDrag: function (evt) {
      //console.log(evt.target.parentNode.id)
      //console.log(evt.target.parentNode.style.top)
      if ((evt.target.parentNode) && evt.target.parentNode.id.includes('QuillDiv')) {
        this.model.attr('shapename/style', {
          top: evt.target.parentNode.style.top,
          left: evt.target.parentNode.style.left,
          width: evt.target.parentNode.style.width,
          height: evt.target.parentNode.style.height
        })
      }

    }
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/crusher//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
joint.shapes.pfd.crusherObject = joint.shapes.pfd.TemplateObject.extend({
  defaults: joint.util.deepSupplement({
    type: 'pfd.crusherObject',
    size: { width: 30, height: 15 },
    ports: {
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
      ]
    },
    attrs: {
      body: {
        refD: 'M 0 0 L 60 0 L 48 30 L 12 30 L 0 0 M 12 30 L 12 0 M 48 30 L 48 0 Z M 18 9 L 42 25 M 42 9 L 18 25',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        refX: -15,
        ref: 'body',
        refY: 80
      }
    }
  }, joint.shapes.pfd.TemplateObject.prototype.defaults)
});

joint.shapes.pfd.crusherObjectView = joint.shapes.pfd.TemplateObjectView  

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/factory//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
joint.shapes.pfd.factoryObject = joint.shapes.pfd.TemplateObject.extend({
  defaults: joint.util.deepSupplement({
    type: 'pfd.factoryObject',
    size: { width: 15, height: 15.6 },
    ports: {
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
      ]
    },
    attrs: {
      body: {
        refD: 'M 0 0 L 0 -13 L 5 -18 L 5 -14 L 6 -14 L 11 -19 L 11 -14 L 12 -14 L 17 -20 L 17 0 L 0 0 M 16 -18.8 L 16 -28 L 12 -29 L 12 -14 M 14 -8 L 14 -10 L 12 -10 L 12 -8 L 14 -8 M 5 -8 L 5 -10 L 3 -10 L 3 -8 L 5 -8',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        refY: 170,
        refX: 30,
        ref: 'body',
      }
    }
  }, joint.shapes.pfd.TemplateObject.prototype.defaults)
});

joint.shapes.pfd.factoryObjectView = joint.shapes.pfd.TemplateObjectView  

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/comminution//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
joint.shapes.pfd.comminutionObject = joint.shapes.pfd.TemplateObject.extend({
  defaults: joint.util.deepSupplement({
    type: 'pfd.comminutionObject',
    size: { width: 25, height: 20 },
    ports: {
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
      ]
    },
    attrs: {
      body: {
        refD: 'M -5 -26 M 2 0 L -5 -26 L 28 -26 L 20 0 L 2 0 M -5 -26 M 4 -27 L 7 -29 L 10 -28 L 9 -25 L 6 -24 L 5 -26 L 4 -27 M 14 -27 L 16 -28 L 19 -26 L 19 -24 L 15 -23 L 13 -24 L 14 -27 M 7 -22 L 10 -21 L 10 -18 L 8 -18 L 6 -20 L 7 -22 M 12 -20 L 14 -19 L 13 -17 L 11 -16 L 11 -18 L 12 -20 M 10 -14 L 12 -15 L 13 -13 L 11 -10 L 9 -12 L 10 -14 M 5 -4 L 6 -5 L 7 -4 L 6 -3 L 5 -4 M 10 -5 L 11 -4 L 10 -3 L 9 -4 L 10 -5 M 14 -3 L 13 -4 L 14 -5 L 15 -4 L 14 -3 M 0 -22 A 1 1 0 0 0 0 -5 A 1 1 0 0 0 0 -22 M 22 -22 A 1 1 0 0 0 22 -5 A 1 1 0 0 0 22 -22 M 0 -10 A 1 1 0 0 0 0 -17 A 1 1 0 0 0 0 -10 M 22 -17 A 1 1 0 0 0 22 -10 A 1 1 0 0 0 22 -17',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        refX: 45,
        ref: 'body',
        refY: 175
      }
    }
  }, joint.shapes.pfd.TemplateObject.prototype.defaults)
});

joint.shapes.pfd.comminutionObjectView = joint.shapes.pfd.TemplateObjectView  

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/haulage//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.haulageObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.haulageObject',
      size: { width: 25, height: 20 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M264.02,1010.3C298.352,1010.3,328.243,991.8549999999999,344.99699999999996,964.4839999999999C361.751,991.8549999999999,391.64199999999994,1010.3,425.94999999999993,1010.3C473.80499999999995,1010.3,513.0709999999999,974.601,519.6569999999999,928.4369999999999L170.3669999999999,928.4330939999999C176.9333999999999,974.6090939999999,216.13699999999992,1010.3000939999998,264.0149999999999,1010.3000939999998Z M791.58,1010.3C825.889,1010.3,855.803,991.8549999999999,872.557,964.4839999999999C889.2950000000001,991.8549999999999,919.178,1010.3,953.534,1010.3C1001.366,1010.3,1040.581,974.612,1047.171,928.4369999999999L697.9010000000001,928.4330939999999C704.4674000000001,974.5970939999999,743.706,1010.3000939999998,791.585,1010.3000939999998Z M1163.6,863.39H1110.116L1110.119906,840.0029999999999L1188.010906,530.0029999999999V446.00299999999993H12.010905999999977V530.0029999999999L87.22590599999998,840.0029999999999V921.241H36.44490599999998V909.456L12.01090599999998,909.459906V948.975906H116.33090599999997V923.330906H138.73290599999996V908.869906H1079.6529059999998V951.014906H1110.0979059999997V891.123906H1163.5819059999997V911.7759060000001H1188.0119059999997V863.4049060000001L1163.5899059999997,863.4010000000001ZM667.0799999999999,611.66V634.953H532.9699999999999V611.66ZM532.9699999999999,588.355V565.062H667.0799999999999V588.355ZM667.0799999999999,658.253V681.546H532.9699999999999V658.253ZM667.0799999999999,704.839V728.1320000000001H532.9699999999999V704.839ZM667.0799999999999,751.437V774.73L532.9699999999999,774.726094V751.433094ZM667.0799999999999,798.0310000000001V821.3240000000001H532.9699999999999V798.0310000000001ZM406.0199999999999,517.7610000000001V494.4680000000001H794.02V541.0540000000001L771.028,541.0500940000001V517.757094H429.028V541.0500940000001H406.024Z M1051.2,346C1023.7080000000001,346,999.407,359.379,984.2510000000001,379.926C966.0520000000001,353.414,935.5600000000001,336.004,900.9620000000001,336.004C877.0600000000001,336.004,855.1220000000001,344.35560000000004,837.8170000000001,358.238C827.3910000000001,344.8,811.2620000000002,336.004,792.9500000000002,336.004C788.5359000000002,336.004,784.2859000000002,336.61728,780.1690000000002,337.56260000000003C776.3760000000002,315.12160000000006,756.9740000000002,298.0006,733.4540000000002,298.0006C719.2700000000002,298.0006,706.6810000000002,304.3483,697.9700000000001,314.21160000000003C688.8489000000002,311.5124,679.2120000000001,310.00070000000005,669.2040000000002,310.00070000000005C626.5670000000002,310.00070000000005,590.1490000000001,336.3987000000001,575.2310000000002,373.71970000000005C563.9030000000002,366.23140000000006,550.8600000000002,361.19270000000006,536.8440000000003,359.14170000000007C523.7030000000003,339.1967000000001,501.13300000000027,326.0087000000001,475.46500000000026,326.0087000000001C460.9450000000003,326.0087000000001,447.4450000000003,330.2704000000001,436.04300000000023,337.5397000000001C428.9258000000002,321.3407000000001,412.78500000000025,310.0007000000001,393.9570000000002,310.0007000000001C375.35500000000025,310.0007000000001,359.4340000000002,321.1027000000001,352.1840000000002,336.9887000000001C348.0863000000002,336.4105800000001,343.9457000000002,336.0043200000001,339.6960000000002,336.0043200000001C299.9540000000002,336.0043200000001,266.3760000000002,362.2743200000001,255.31300000000022,398.3913200000001C254.0278000000002,398.2585100000001,252.7700000000002,398.0085100000001,251.4497000000002,398.0085100000001C235.89870000000022,398.0085100000001,222.5547000000002,407.4773100000001,216.8797000000002,420.9655100000001C203.2347000000002,406.8285100000001,184.1337000000002,398.0085100000001,162.9497000000002,398.0085100000001C156.3013000000002,398.0085100000001,149.8947000000002,398.95773000000014,143.7507000000002,400.5749100000001C135.5788000000002,383.7269100000001,118.4537000000002,372.0049100000001,98.44970000000019,372.0049100000001C70.73070000000018,372.0049100000001,48.277700000000195,394.3489100000001,48.000700000000194,422.0089100000001H1134.1007000000002C1130.4327000000003,379.4349100000001,1094.7567000000001,346.00091000000015,1051.2297,346.00091000000015Z',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          refX: 45,
          ref: 'body',
          refY: 165
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  
  joint.shapes.pfd.haulageObjectView = joint.shapes.pfd.TemplateObjectView

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/ballmill//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      joint.shapes.pfd.ballMillObject = joint.shapes.pfd.TemplateObject.extend({
        defaults: joint.util.deepSupplement({
          type: 'pfd.ballMillObject',
          size: { width: 30, height: 30 },
          ports: {
            items: [
              { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
            ]
          },
          attrs: {
            body: {
              refD: 'M 0 0 A 1 1 0 0 0 0 -20 A 1 1 0 0 0 0 0 M 2 -0.2 A 1 1 0 0 0 1 -3 A 1 1 0 0 0 2 -0.2 M 5 -1.3 A 1 1 0 0 0 3.6 -4 A 1 1 0 0 0 5 -1.3 M -2 -0.2 A 1 1 0 0 0 -1 -3 A 1 1 0 0 0 -2 -0.2 M -5 -1.3 A 1 1 0 0 0 -3.6 -4 A 1 1 0 0 0 -5 -1.3',
              stroke: 'black',
              fill: 'transparent'
            },
            foreignObject: {
              refWidth: '100%',
              refHeight: '100%',
              refX: -15,
              ref: 'body',
              refY: 80
            }
          }
        }, joint.shapes.pfd.TemplateObject.prototype.defaults)
      });
  
    joint.shapes.pfd.ballMillObjectView = joint.shapes.pfd.TemplateObjectView  


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Truck/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.TruckObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.TruckObject',
      size: { width: 20, height: 12 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 4 L 10 4 M 2 4 A 1 1 0 0 0 2 6 A 1 1 0 0 0 2 4 M 8 4 A 1 1 0 0 0 8 6 A 1 1 0 0 0 8 4 M 0 4 L 0 0 L 10 0 L 10 4 L 10 4',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 70
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.TruckObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Filter~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.FilterObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.FilterObject',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 4 0 L 4 4 L 0 4 Z M 0 4 L 4 0',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.FilterObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Filter2~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.Filter2Object = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.Filter2Object',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 5 0 L 5 5 L 0 5 L 0 0 M 0 5 L 0.5 4.5 M 1 4 L 1.5 3.5 M 2 3 L 2.5 2.5 M 3 2 L 3.5 1.5 M 4 1 L 4.5 0.5',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.Filter2ObjectView = joint.shapes.pfd.TemplateObjectView
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Filter3~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    joint.shapes.pfd.Filter3Object = joint.shapes.pfd.TemplateObject.extend({
      defaults: joint.util.deepSupplement({
        type: 'pfd.Filter3Object',
        size: { width: 30, height: 30 },
        ports: {
          items: [
            { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
            { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
            { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
            { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
            { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
            { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
            { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
            { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
            { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
          ]
        },
        attrs: {
          body: {
            refD: 'M 0 0 L 0 5 L -5 5 L -5 0 L 0 0 M -5 0 L -4.5 0.5 M -4 1 L -3.5 1.5 M -3 2 L -2.5 2.5 M -2 3 L -1.5 3.5 M -1 4 L -0.5 4.5',
            stroke: 'black',
            fill: 'transparent'
          },
          foreignObject: {
            refWidth: '100%',
            refHeight: '100%',
            ref: 'body',
            refY: 60
          }
        }
      }, joint.shapes.pfd.TemplateObject.prototype.defaults)
    });
    joint.shapes.pfd.Filter3ObjectView = joint.shapes.pfd.TemplateObjectView
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Filter4~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.Filter4Object = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.Filter4Object',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 4 0 L 4 4 L 0 4 Z M 4 0 L 4 0 L 0 0 L 4 0 L 4 4 L 0 0',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.Filter4ObjectView = joint.shapes.pfd.TemplateObjectView
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Filter5~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
joint.shapes.pfd.Filter5Object = joint.shapes.pfd.TemplateObject.extend({
  defaults: joint.util.deepSupplement({
    type: 'pfd.Filter5Object',
    size: { width: 30, height: 30 },
    ports: {
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
      ]
    },
    attrs: {
      body: {
        refD: 'M 0 0 L 0 5 L 5 5 L 5 0 L 0 0 M 5 0 L 4.5 0.5 M 4 1 L 3.5 1.5 M 3 2 L 2.5 2.5 M 2 3 L 1.5 3.5 M 1 4 L 0.5 4.5',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        ref: 'body',
        refY: 60
      }
    }
  }, joint.shapes.pfd.TemplateObject.prototype.defaults)
});
joint.shapes.pfd.Filter5ObjectView = joint.shapes.pfd.TemplateObjectView

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Filter6~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
joint.shapes.pfd.Filter6Object = joint.shapes.pfd.TemplateObject.extend({
  defaults: joint.util.deepSupplement({
    type: 'pfd.Filter6Object',
    size: { width: 30, height: 30 },
    ports: {
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
      ]
    },
    attrs: {
      body: {
        refD: 'M 0 0 L 0 5 L 5 5 L 5 0 L 0 0  M 2.5 0.25 L 2.5 0.75 M 2.5 1.25 L 2.5 1.75 M 2.5 2.25 L 2.5 2.75 M 2.5 3.25 L 2.5 3.75 M 2.5 4.25 L 2.5 4.75',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        ref: 'body',
        refY: 60
      }
    }
  }, joint.shapes.pfd.TemplateObject.prototype.defaults)
});
joint.shapes.pfd.Filter6ObjectView = joint.shapes.pfd.TemplateObjectView

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Membrane~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
joint.shapes.pfd.membraneObject = joint.shapes.pfd.TemplateObject.extend({
  defaults: joint.util.deepSupplement({
    type: 'pfd.membraneObject',
    size: { width: 30, height: 20 },
    ports: {
      items: [
        { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
      ]
    },
    attrs: {
      body: {
        refD: 'M 0 0 L 5 -0 L 5 -4 L 0 -4 L 0 0 M 0 -2 L 5 -2',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        ref: 'body',
        refY: 60
      }
    }
  }, joint.shapes.pfd.TemplateObject.prototype.defaults)
});
joint.shapes.pfd.membraneObjectView = joint.shapes.pfd.TemplateObjectView


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Heat Exchanger/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.HeatXObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.HeatXObject',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 5 1 A 1 1 0 0 0 5 9 A 1 1 0 0 0 5 1 M 1 5 L 3 5 L 5 3 M 9 5 L 7 5 L 5 7 M 5 3 L 5 7',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.HeatXObjectView = joint.shapes.pfd.TemplateObjectView
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Vessel/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.VesselObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.VesselObject',
      size: { width: 20, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '45%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '20%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '70%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '20%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '45%' }, id: 'in_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '70%' }, id: 'in_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '20%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '45%' }, id: 'out_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '70%' }, id: 'out_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '20%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '45%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '70%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 1 L 0 10 Q 4 12 8 10 L 8 1 Q 4 -1 0 1 Z',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 97
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.VesselObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Agitated Vessel/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.agitatedVesselObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.agitatedVesselObject',
      size: { width: 20, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '45%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '20%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '70%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '20%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '45%' }, id: 'in_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '70%' }, id: 'in_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '20%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '45%' }, id: 'out_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '70%' }, id: 'out_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '20%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '45%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '70%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 -9 L 0 -1 Q 4 1 8 -1 L 8 -9 M 6.7362 -10.5175 L 4 -3 M 4 -3 A 0.8 0.3 20 1 0 2.4965 -3.5472 A 0.8 0.3 20 1 0 4 -3 M 4 -3 A 0.8 0.3 20 1 0 5.5035 -2.4528 A 0.8 0.3 20 1 0 4 -3',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 97
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.agitatedVesselObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Settler/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.SettlerObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.SettlerObject',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '12%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '12%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M0 0 0 6 3 9 6 6 6 0',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refY: 80
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.SettlerObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Open Vessel/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.OpenVesselObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.OpenVesselObject',
      size: { width: 30, height: 20 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } }
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 0 4 L 8 4 L 8 0',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.OpenVesselObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Trap/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.bfd.TrapObject = joint.dia.Element.define('bfd.TrapObject', {
    size: { width: 30, height: 10 },
    ports: {
      groups: {
        'in': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
        'out': {
          position: {
            name: 'absolute',
            args: {}
          }
        },
      },
      items: [
        { group: 'out', args: { x: '5%', y: '25%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '8%', y: '50%' }, id: 'out_left_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '12%', y: '75%' }, id: 'out_left_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '25%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '75%', y: '0%' }, id: 'out_top_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '96%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '92%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '88%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '25%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_2', attrs: { portBody: { magnet: 'true' } } },
        { group: 'out', args: { x: '75%', y: '100%' }, id: 'out_bottom_3', attrs: { portBody: { magnet: 'true' } } },
      ]
    },

    portMarkup: [{
      tagName: 'circle',
      selector: 'portBody',
      className: 'magnetTrial',
      attributes: {
        fill: '#FF7597',
        stroke: 'null',
        opacity: 0,
        r: 6
      }
    }],


    attrs: {
      body: {
        refD: 'M 2 4 L 0 0 L 12 0 L 10 4 Z',
        stroke: 'black',
        fill: 'transparent'
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%',
        ref: 'body',
        //refY: 50
      }
    }
  }, {
    markup: [{
      tagName: 'path',
      selector: 'body',
      className: 'elementBody'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject',
      className: 'foreignObjectclass',
      style: {
        'height': '400px',
        'width': '400px',
        'overflow': 'visible',
        'pointer-events': 'none',
        'display': 'none'
      },
      children: [{
        tagName: 'div',
        selector: 'shapename',
        className: 'shapename',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        attributes: {
          'content-editable': 'true',
          'overflow': 'visible',
          'id': 'placeHolderQuillId'
        },
        style: {
          position: 'absolute',
          width: '70px',
          zIndex: 100,
          overflow: 'visible',
          height: '30px',
          backgroundColor: 'transparent',
          textAlign: 'center',
          fontSize: 12,
          fontFamily: 'Arial',
          cursor: 'move',
          boxSizing: 'border-box',
          pointerEvents: 'auto',
        }
      }]
    }]
  })
    , {
    attributes: {
      innerHTML: {
        set: function (html, _, node) {

          if ('innerHTML' in node) {
            node.innerHTML = html;
            console.log(node.id)
          }

        }
      },
      style: {
        top: {
          set: function (styleTop, _, node) {
            if ('top' in node) {
              node.style.top = styleTop;
              console.log(node.id)
            }

          }
        },
        left: {
          set: function (styleLeft, _, node) {
            if ('left' in node) {
              node.style.left = styleLeft;
              console.log(node.id)
            }

          }
        },
        width: {
          set: function (styleWidth, _, node) {
            if ('width' in node) {
              node.style.width = styleWidth;
              console.log(node.id)
            }

          }
        },
        height: {
          set: function (styleHeight, _, node) {
            if ('height' in node) {
              node.style.height = styleHeight;
              console.log(node.id)
            }

          }
        }
      }
    }
  };

  joint.shapes.bfd.TrapObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Flare/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.FlareObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.FlareObject',
      size: { width: 20, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '-5%', y: '100%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '100%' }, id: 'out_bottom_3', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 M 0 10 L 6 10 M 2 10 L 2 3 L 4 3 L 4 10 M 3 3 Q 1 1.5 3 0 Q 5 1.5 3 3',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 50
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.FlareObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/HeatExchangerM/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.HeatXMObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.HeatXMObject',
      size: { width: 32, height: 30 },
      ports: {
        items: [
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '45%', y: '100%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '45%', y: '0%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } }
        ]
      },
      attrs: {
        body: {
          refD: 'M 4 0 A 1 1 0 0 0 4 8 A 1 1 0 0 0 4 0 M 9 2 L 2 2 M 5 4 L 2 2 M 9 6 L 2 6 M 5 4 L 2 6',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 50
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.HeatXMObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Steam Generator~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.SteamGenObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.SteamGenObject',
      size: { width: 27, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 2 L 0 10 L 8 10 L 8 2 L 6 2 A 1 1 0 0 0 2 2 Z L 6 2 M 8 2 L 0 10',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.SteamGenObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Dual Diam Vessel~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.DualDiamVesselObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.DualDiamVesselObject',
      size: { width: 15, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '25%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '75%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '75%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '25%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 1 4 L 0 4.5 L 0 9 Q 2 11 4 9 L 4 4.5 L 3 4 L 3 1 A 1 1 0 0 0 1 1 L 1 4 Z',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.DualDiamVesselObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Dual Diam Vessel Packed~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.DualDiamPackedVesselObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.DualDiamPackedVesselObject',
      size: { width: 12, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '25%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '75%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '75%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '25%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 1 4 L 0 4.5 L 0 9 Q 2 11 4 9 L 4 4.5 L 3 4 L 3 1 A 1 1 0 0 0 1 1 L 1 4 Z M 0 5 L 4 5 M 0 9 L 4 9 L 0 5 M 4 5 L 0 9',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.DualDiamPackedVesselObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Column Fixed Bed Vessel~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.FixedBedColumnObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.FixedBedColumnObject',
      size: { width: 15, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '45%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '20%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '70%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '20%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '45%' }, id: 'in_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '70%' }, id: 'in_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '20%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '45%' }, id: 'out_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '70%' }, id: 'out_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '20%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '45%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '70%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 1 L 0 11 Q 4 13 8 11 L 8 1 Q 4 -1 0 1 M 0 2 L 2 2 M 3 2 L 5 2 M 6 2 L 8 2 M 0 10 L 2 10 M 3 10 L 5 10 M 6 10 L 8 10 M 0 2 L 8 10 M 8 2 L 0 10',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.FixedBedColumnObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Compressor~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.CompressorObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.CompressorObject',
      size: { width: 15, height: 20 },
      ports: {
        items: [
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '66%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '49.5%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '33%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } }
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 0 2 L 4 4 L 4 -2 L 0 0 Z',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.CompressorObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Vacuum Pump ISO/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.VacuumPumpISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.VacuumPumpISOObject',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 A 1 1 0 0 0 6 0 A 1 1 0 0 0 0 0 M 5.563 -1.551 L 1.312 -2.472 M 5.563 1.551 L 1.312 2.472',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.VacuumPumpISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Vacuum Pump ISO/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.LiquidPumpISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.LiquidPumpISOObject',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 A 1 1 0 0 0 6 0 A 1 1 0 0 0 0 0 M 6 0 L 3 3 M 3 -3 L 6 0',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.LiquidPumpISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Compressor~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.TurbineISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.TurbineISOObject',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '66%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '49.5%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '33%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } }
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 0 2 L 4 4 L 4 -2 L 0 0 Z M 4 1 L 5 1',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.TurbineISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Insulated Cone/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.InsulatedConeObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.InsulatedConeObject',
      size: { width: 30, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '12%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '21%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '79%', y: '60%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '12%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } }
        ]
      },
      attrs: {
        body: {
          refD: 'M 1 0 L 6 0 L 6 1 L 4 4 L 4 5 L 3 5 L 3 4 L 1 1 L 1 0 M 4 5 L 4.5 5 L 4.5 4 L 6.5 1 L 6.5 0 L 6 0 L 6 1 L 4 4 M 3 5 L 2.5 5 L 2.5 4 L 0.5 1 L 0.5 0 L 1 0 L 1 1 L 3 4 M 2.5 4.6 L 3 4 M 2.3 3.7 L 2.6 3.4 M 1.5 2.5 L 1.8 2.2 M 1.9 3.1 L 2.2 2.8 M 1.1 1.9 L 1.4 1.6 M 0.7 1.3 L 1 1 M 0.5 0.5 L 1 0 M 4.5 4.5 L 4 4 M 4.7 3.7 L 4.4 3.4 M 5.5 2.5 L 5.2 2.2 M 6.3 1.3 L 6 1 M 5.9 1.9 L 5.6 1.6 M 6.5 0.5 L 6 0 M 5.1 3.1 L 4.8 2.8',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refY: 80
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.InsulatedConeObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/CrusherConeTypeISO/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.CrusherConeTypeISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.CrusherConeTypeISOObject',
      size: { width: 30, height: 15 },
      ports: {
        items: [
          { group: 'out', args: { x: '5%', y: '25%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '8%', y: '50%' }, id: 'out_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '12%', y: '75%' }, id: 'out_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '25%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '75%', y: '0%' }, id: 'out_top_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '96%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '92%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '88%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '25%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '75%', y: '100%' }, id: 'out_bottom_3', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 10 0 L 8 6 L 2 6 L 0 0 M 2 6 L 2 0 M 8 6 L 8 0 M 4 1.5 L 6 1.5 L 7 4.5 L 3 4.5 L 4 1.5 Z',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 90,
          refX: 40
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.CrusherConeTypeISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Solid Separator/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.SolidSeparatorObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.SolidSeparatorObject',
      size: { width: 20, height: 20 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '12%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '35%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '12%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } }
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 -1 L 0 -5 L 5 -5 L 5 -1 L 3 4 L 3 5 L 2 5 L 2 4 L 0 -1',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refY: 80
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.SolidSeparatorObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~HxEnFinnedTubeFanISOObject~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.HxEnFinnedTubeFanISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.HxEnFinnedTubeFanISOObject',
      size: { width: 25, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 0 9 L 8 9 L 8 0 L 0 0 M 4 1 A 1 1 0 0 0 4 5 A 1 1 0 0 0 4 1 M 1 7 L 7 7 M 2 7.5 L 2 6.5 M 3 7.5 L 3 6.5 M 4 7.5 L 4 6.5 M 5 7.5 L 5 6.5 M 6 7.5 L 6 6.5 M 3 1.2675 L 2.143 3.742 M 5 1.2675 L 5.857 3.742',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.HxEnFinnedTubeFanISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Furnace~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.FurnaceObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.FurnaceObject',
      size: { width: 35, height: 45 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '25%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '25%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 4 -2 L 4 -1 L 6 0 L 6 5 L 0 5 L 0 0 L 2 -1 L 2 -2',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.FurnaceObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~FurnaceHX~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.FurnaceHXObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.FurnaceHXObject',
      size: { width: 25, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '23%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '31.5%' }, id: 'in_left_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '15%', y: '50%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '15%', y: '75%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '57%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '25%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '50%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '75%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '57%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '25%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '75%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '57%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '23%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '31.5%' }, id: 'out_left_9', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '15%', y: '50%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '15%', y: '75%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '57%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 4 -2 L 4 -1 L 6 0 L 6 5 L 0 5 L 0 0 L 2 -1 L 2 -2 M -1 -0.4 L 1.5 -0.4 M 1.5 0.2 L -1 0.2 M 1 -0.1 L 1.5 -0.4 M 1 -0.1 L 1.5 0.2',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.FurnaceHXObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~Pyrolysis Reactor~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.pyroRxObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.pyroRxObject',
      size: { width: 15, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '20%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '17%', y: '55%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '17%', y: '80%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '20%' }, id: 'in_right_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '83.5%', y: '55%' }, id: 'in_right_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '83.5%', y: '80%' }, id: 'in_right_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_8', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '20%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '83.5%', y: '55%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '83.5%', y: '80%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '20%' }, id: 'out_left_5', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '17%', y: '55%' }, id: 'out_left_6', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '17%', y: '80%' }, id: 'out_left_7', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_8', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 0 3 L 1 4 L 1 9 C 2 10 4 10 5 9 L 5 4 L 6 3 L 6 0 C 5 -1 1 -1 0 0 M 0 0 L 6 0 M 0 3 L 6 3',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refY: 60
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.pyroRxObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Conveyor Belt ISO/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.ConveyorBeltISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.ConveyorBeltISOObject',
      size: { width: 10, height: 2 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 A 1 1 0 0 0 2 0 A 1 1 0 0 0 0 0 M 8 0 A 1 1 0 0 0 10 0 A 1 1 0 0 0 8 0 M 9 -1 L 1 -1 C 1.555 -1 2 -0.55 2 0 C 2 0.55 1.555 1 1 1 L 9 1',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.ConveyorBeltISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Drum/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.DrumObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.DrumObject',
      size: { width: 10, height: 3 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 1 0 L 9 0 C 10 1 10 2 9 3 L 1 3 C 0 2 0 1 1 0 Z',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.DrumObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/ConveyorRollerISO/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.ConveyorRollerISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.ConveyorRollerISOObject',
      size: { width: 25, height: 3 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 16 0 M 3 0 A 1 1 0 0 0 1 0 A 1 1 0 0 0 3 0 M 4 0 A 1 1 0 0 0 6 0 A 1 1 0 0 0 4 0 M 9 0 A 1 1 0 0 0 7 0 A 1 1 0 0 0 9 0 M 12 0 A 1 1 0 0 0 10 0 A 1 1 0 0 0 12 0 M 15 0 A 1 1 0 0 0 13 0 A 1 1 0 0 0 15 0 M 0 0 L 0 1 L 16 1 L 16 0',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.ConveyorRollerISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/ConveyorGeneralISO/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.ConveyorGeneralISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.ConveyorGeneralISOObject',
      size: { width: 10, height: 3 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 12 0 L 12 4 L 0 4 L 0 0',
          stroke: 'black',
          fill: 'transparent'
        },
        forbody: {
          refD: 'M 2 2 L 9 2 L 7.5 2.5 L 7.5 2 M 9 2 L 7.5 1.5 L 7.5 1.5 L 7.5 2 M 0 0 L 12 0 M 12 4 L 12 0 M 0 4 L 12 4 M 0 0 L 0 4',
          stroke: 'black',
          fill: 'black'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      },
      markup: [{
        tagName: 'path',
        selector: 'body',
        className: 'elementBody'
      },
      {
        tagName: 'path',
        selector: 'forbody'
      },
      {
        tagName: 'foreignObject',
        selector: 'foreignObject',
        className: 'foreignObjectclass',
        style: {
          'height': '400px',
          'width': '400px',
          'overflow': 'visible',
          'pointer-events': 'none',
          'display': 'none'
        },
        children: [{
          tagName: 'div',
          selector: 'shapename',
          className: 'shapename',
          namespaceURI: 'http://www.w3.org/1999/xhtml',
          attributes: {
            'content-editable': 'true',
            'overflow': 'visible',
            'id': 'placeHolderQuillId',
            'name': 'shapename',
          },
          style: {
            position: 'absolute',
            width: '60px',
            zIndex: 100,
            overflow: 'visible',
            height: '30px',
            backgroundColor: 'transparent',
            textAlign: 'center',
            fontSize: 12,
            fontFamily: 'Arial',
            cursor: 'move',
            boxSizing: 'border-box',
            pointerEvents: 'auto',
          }
        }]
      }]
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.ConveyorGeneralISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Process Gas Air Cooler/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.ProcessGasAirCoolerObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.ProcessGasAirCoolerObject',
      size: { width: 10, height: 4 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '36%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '36%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },

        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 14 0 L 14 4 L 0 4 L 0 0 M 2 -1 L 2 5 M 12 -1 L 12 5 M 2 5 L 1 7 M 12 5 L 13 7 M 7 5.5 L 5 5 Q 4.5 5.5 5 6 L 7 5.5 L 9 5 Q 9.5 5.5 9 6 L 7 5.5',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.ProcessGasAirCoolerObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Flanged Connection ISO/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.FlangedConnectionISOObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.FlangedConnectionISOObject',
      size: { width: 5, height: 10 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 1 0 L 1 2 M 2 0 L 2 2',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.FlangedConnectionISOObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/electroWinning/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.electroWinningObject = joint.dia.Element.define('pfd.electroWinningObject', {
      size: { width: 80, height: 80 },
      ports: {
        groups: {
          'in': {
            position: {
              name: 'absolute',
              args: {}
            }
          },
          'out': {
            position: {
              name: 'absolute',
              args: {}
            }
          },
        },
        items: [
          { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '85%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '35%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '60%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '85%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      portMarkup: [{
        tagName: 'circle',
        selector: 'portBody',
        className: 'magnetTrial',
        attributes: {
          fill: '#FF7597',
          stroke: 'null',
          opacity: 0,
          r: 6
          // If all the magnets are `true` / `passive` feel free to define
          // the magnet here in the default port markup or per a port group
          // 'magnet': true
        }
      }],
      attrs: {
        body: {
          refD: 'M 0 0 L 0 8 M 0 0 L 8 0 M 8 8 L 8 0 M 0 8 L 8 8 M 3.5 -2.5 L 3.5 -1.5 M 3.5 -2 L 1.75 -2 M 1.75 1.5 L 1.75 -2 M 1.25 1.5 L 2.25 1.5 L 2.25 6 L 1.25 6 L 1.25 1.5 M 4.5 -2 L 4.5 -2.25 M 4.5 -1.75 L 4.5 -2 M 6.25 1.5 L 6.25 -2 M 6.25 -2 L 4.5 -2 M 5.75 1.5 L 5.75 6 L 6.75 6 L 6.75 1.5 L 5.75 1.5',
          stroke: 'black',
          fill: 'transparent'
        },
        forbody: {
          refD: 'M 0 0 L 8 0 L 8 8 L 0 8 Z',
          stroke: 'transparent',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        },
        foreignObjectAnode: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '58%',
          refY: '85%'
        },
        foreignObjectCathode: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '2%',
          refY: '85%'
        }
      },
      markup: [{
        tagName: 'path',
        selector: 'body',
        className: 'elementBody'
      },
      {
        tagName: 'path',
        selector: 'forbody'
      },
      {
        tagName: 'foreignObject',
        selector: 'foreignObject',
        className: 'foreignObjectclass',
        style: {
          'height': '400px',
          'width': '400px',
          'pointer-events': 'none',
          'display': 'none'
        },
        attributes: {
          'overflow': 'visible',
        },
        children: [{
          tagName: 'div',
          selector: 'shapename',
          className: 'shapename',
          namespaceURI: 'http://www.w3.org/1999/xhtml',
          attributes: {
            'content-editable': 'true',
            'overflow': 'visible',
            'id': 'placeHolderQuillId',
            'name': 'shapename',
          },
          style: {
            position: 'absolute',
            width: '60px',
            zIndex: 100,
            overflow: 'visible',
            height: '30px',
            backgroundColor: 'transparent',
            textAlign: 'center',
            fontSize: 12,
            fontFamily: 'Arial',
            cursor: 'move',
            boxSizing: 'border-box',
            pointerEvents: 'auto',
          }
        }
        ]
      }
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectAnode',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          pointerEvents: 'none'
        },
        children: [{
            tagName: 'input',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            selector: 'anodeInput',
            className: 'shape-input-div',
            attributes: {
              'name': 'anodeInput',
              'overflow': 'visible',
            },
            style: {
              width: '37%',
              pointerEvents: 'auto'
            }
    }]}
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectCathode',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          pointerEvents: 'none',

        },
        children: [{
            tagName: 'input',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            selector: 'cathodeInput',
            className: 'shape-input-div',
            attributes: {
              'name': 'cathodeInput',
              'overflow': 'visible',
            },
            style: {
              width: '37%',
              pointerEvents: 'auto'
            }
    }]}
    ]
    } , {
      attributes: {
        innerHTML: {
          set: function (html, _, node) {
            if ('innerHTML' in node) {
              node.innerHTML = html;
            }
          }
        },
        value: {
          set: function (text, _, node) {
            if ('value' in node) {
              node.value = text;
            }
          }
        },
        style: {
          display: {
            set: function (styleDisplay, _, node) {
              if ('display' in node) {
                node.style.display = styleDisplay;
              }
            }
          },
          top: {
            set: function (styleTop, _, node) {
              if ('top' in node) {
                node.style.top = styleTop;
              }
            }
          },
          left: {
            set: function (styleLeft, _, node) {
              if ('left' in node) {
                node.style.left = styleLeft;
              }
            }
          },
          width: {
            set: function (styleWidth, _, node) {
              if ('width' in node) {
                node.style.width = styleWidth;
              }
            }
          },
          height: {
            set: function (styleHeight, _, node) {
              if ('height' in node) {
                node.style.height = styleHeight;
              }
            }
          }
        }
      }
    });

    joint.shapes.pfd.electroWinningObjectView = joint.shapes.pfd.TemplateObjectView.extend({
      events: _.extend({}, joint.shapes.pfd.TemplateObjectView.prototype.events, {
          'change input': 'onTagInput'
      }),
      onTagInput: function(evt) {
          var input = evt.target;
          this.model.attr(input.name + '/value', input.value);
      }
    });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/electroWinningHatched/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.electroWinningHatchedObject = joint.dia.Element.define('pfd.electroWinningHatchedObject', {
      size: { width: 80, height: 80 },
      ports: {
        groups: {
          'in': {
            position: {
              name: 'absolute',
              args: {}
            }
          },
          'out': {
            position: {
              name: 'absolute',
              args: {}
            }
          },
        },
        items: [
          { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '85%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '46%', y: '100%' }, id: 'in_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '35%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '60%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '85%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '54%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      portMarkup: [{
        tagName: 'circle',
        selector: 'portBody',
        className: 'magnetTrial',
        attributes: {
          fill: '#FF7597',
          stroke: 'null',
          opacity: 0,
          r: 6
          // If all the magnets are `true` / `passive` feel free to define
          // the magnet here in the default port markup or per a port group
          // 'magnet': true
        }
      }],
      attrs: {
        body: {
          refD: 'M 0 0 M 3.5 0 L 3.5 8 M 4.5 0 L 4.5 8 L 3.5 8 L 3.5 0 L 4.5 0 M 4 0 L 3.5 0.5 M 4.5 0 L 3.5 1 M 4.5 0.5 L 3.5 1.5 M 4.5 1 L 3.5 2 M 4.5 1.5 L 3.5 2.5 M 4.5 2 L 3.5 3 M 4.5 2.5 L 3.5 3.5 M 4.5 3 L 3.5 4 M 4.5 3.5 L 3.5 4.5 M 4.5 4 L 3.5 5 M 4.5 4.5 L 3.5 5.5 M 4.5 5 L 3.5 6 M 4.5 5.5 L 3.5 6.5 M 4.5 6 L 3.5 7 M 4.5 6.5 L 3.5 7.5 M 4.5 7 L 3.5 8 M 4.5 7.5 L 4 8 M 8 0 M 0 0 L 0 8 M 0 0 L 8 0 M 8 8 L 8 0 M 0 8 L 8 8 M 3.5 -2.5 L 3.5 -1.5 M 3.5 -2 L 1.75 -2 M 1.75 1.5 L 1.75 -2 M 1.25 1.5 L 2.25 1.5 L 2.25 6 L 1.25 6 L 1.25 1.5 M 4.5 -2 L 4.5 -2.25 M 4.5 -1.75 L 4.5 -2 M 6.25 1.5 L 6.25 -2 M 6.25 -2 L 4.5 -2 M 5.75 1.5 L 5.75 6 L 6.75 6 L 6.75 1.5 L 5.75 1.5',
          stroke: 'black',
          fill: 'transparent'
        },
        forbody: {
          refD: 'M 0 0 L 8 0 L 8 8 L 0 8 Z',
          stroke: 'transparent',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        },
        foreignObjectAnode: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '58%',
          refY: '85%'
        },
        foreignObjectCathode: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '2%',
          refY: '85%'
        },
        foreignObjectMembrane: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '25%',
          refY: '10%'
        }
      },
      markup: [{
        tagName: 'path',
        selector: 'body',
        className: 'elementBody'
      },
      {
        tagName: 'path',
        selector: 'forbody'
      },
      {
        tagName: 'foreignObject',
        selector: 'foreignObject',
        className: 'foreignObjectclass',
        style: {
          'height': '400px',
          'width': '400px',
          'overflow': 'visible',
          'pointer-events': 'none',
          'display': 'none'
        },
        children: [{
          tagName: 'div',
          selector: 'shapename',
          className: 'shapename',
          namespaceURI: 'http://www.w3.org/1999/xhtml',
          attributes: {
            'content-editable': 'true',
            'overflow': 'visible',
            'id': 'placeHolderQuillId',
            'name': 'shapename',
          },
          style: {
            position: 'absolute',
            width: '60px',
            zIndex: 100,
            overflow: 'visible',
            height: '30px',
            backgroundColor: 'transparent',
            textAlign: 'center',
            fontSize: 12,
            fontFamily: 'Arial',
            cursor: 'move',
            boxSizing: 'border-box',
            pointerEvents: 'auto',
          }
        }
        ]
      }
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectAnode',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          'pointerEvents': 'none',

        },
        children: [{
            tagName: 'input',
            selector: 'anodeInput',
            className: 'shape-input-div',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            attributes: {
              'name': 'anodeInput',
              'overflow': 'visible',
            },
            style: {
              width: '37%',
              'pointerEvents': 'auto',
            }

    }]}
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectCathode',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          'pointerEvents': 'none',
        },
        children: [{
            tagName: 'input',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            selector: 'cathodeInput',
            className: 'shape-input-div',
            attributes: {
              'name': 'cathodeInput',
              'overflow': 'visible',
            },
            style: {
              width: '37%',
              'pointerEvents': 'auto',
            }
    }]}
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectMembrane',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          'pointerEvents': 'none',
        },
        children: [{
            tagName: 'input',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            selector: 'EMInput',
            className: 'shape-input-div',
            attributes: {
              'name': 'EMInput',
              'overflow': 'visible',
            },
            style: {
              width: '50%',
              'pointerEvents': 'auto',
            }
    }]}
  ]
    }, {
      attributes: {
        innerHTML: {
          set: function (html, _, node) {
            if ('innerHTML' in node) {
              node.innerHTML = html;
            }
          }
        },
        value: {
          set: function (text, _, node) {
            if ('value' in node) {
              node.value = text;
            }
          }
        },
        style: {
          display: {
            set: function (styleDisplay, _, node) {
              if ('display' in node) {
                node.style.display = styleDisplay;
              }
            }
          },
          top: {
            set: function (styleTop, _, node) {
              if ('top' in node) {
                node.style.top = styleTop;
              }
            }
          },
          left: {
            set: function (styleLeft, _, node) {
              if ('left' in node) {
                node.style.left = styleLeft;
              }
            }
          },
          width: {
            set: function (styleWidth, _, node) {
              if ('width' in node) {
                node.style.width = styleWidth;
              }
            }
          },
          height: {
            set: function (styleHeight, _, node) {
              if ('height' in node) {
                node.style.height = styleHeight;
              }
            }
          }
        }
      }
    });

    joint.shapes.pfd.electroWinningHatchedObjectView = joint.shapes.pfd.TemplateObjectView.extend({
      events: _.extend({}, joint.shapes.pfd.TemplateObjectView.prototype.events, {
          'change input': 'onTagInput'
      }),
      onTagInput: function(evt) {
          var input = evt.target;
          this.model.attr(input.name + '/value', input.value);
      }
    });

  
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/electrolyserStack/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.electrolyserStackObject = joint.dia.Element.define('pfd.electrolyserStackObject', {
      size: { width: 80, height: 80 },
      ports: {
        groups: {
          'in': {
            position: {
              name: 'absolute',
              args: {}
            }
          },
          'out': {
            position: {
              name: 'absolute',
              args: {}
            }
          },
        },
        items: [
          { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '85%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '46%', y: '100%' }, id: 'in_bottom_4', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '35%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '60%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '85%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '54%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      portMarkup: [{
        tagName: 'circle',
        selector: 'portBody',
        className: 'magnetTrial',
        attributes: {
          fill: '#FF7597',
          stroke: 'null',
          opacity: 0,
          r: 6
          // If all the magnets are `true` / `passive` feel free to define
          // the magnet here in the default port markup or per a port group
          // 'magnet': true
        }
      }],
      attrs: {
        body: {
          refD: 'M 0 0 L 4 0 L 4 -18 L 0 -18 M 0 -18 L 0 0 M 4 -16 L 24 -16 L 24 -16 L 24 -2 L 4 -2 M 4 -2 L 4 -2 L 4 -2 L 4 -2 M 24 -18 L 28 -18 L 28 0 L 24 0 L 24 -18 M 6 -16 L 6 -2 M 8 -16 L 8 -2 M 10 -16 L 10 -2 M 12 -16 L 12 -2 M 14 -16 L 14 -2 M 16 -16 L 16 -2 M 18 -16 L 18 -2 M 20 -16 L 20 -2 M 22 -16 L 22 -2 M 2 -3 L 2 -1 M 1 -2 L 3 -2 M 25 -2 L 27 -2',
          stroke: 'black',
          fill: 'transparent'
        },
        forbody: {
          refD: 'M 0 0 L 8 0 L 8 8 L 0 8 Z',
          stroke: 'transparent',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        },
        foreignObjectAnode: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '58%',
          refY: '85%'
        },
        foreignObjectCathode: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '2%',
          refY: '85%'
        },
        foreignObjectMembrane: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
          refX: '25%',
          refY: '10%'
        }
      },
      markup: [{
        tagName: 'path',
        selector: 'body',
        className: 'elementBody'
      },
      {
        tagName: 'path',
        selector: 'forbody'
      },
      {
        tagName: 'foreignObject',
        selector: 'foreignObject',
        className: 'foreignObjectclass',
        style: {
          'height': '400px',
          'width': '400px',
          'overflow': 'visible',
          'pointer-events': 'none',
          'display': 'none'
        },
        children: [{
          tagName: 'div',
          selector: 'shapename',
          className: 'shapename',
          namespaceURI: 'http://www.w3.org/1999/xhtml',
          attributes: {
            'content-editable': 'true',
            'overflow': 'visible',
            'id': 'placeHolderQuillId',
            'name': 'shapename',
          },
          style: {
            position: 'absolute',
            width: '60px',
            zIndex: 100,
            overflow: 'visible',
            height: '30px',
            backgroundColor: 'transparent',
            textAlign: 'center',
            fontSize: 12,
            fontFamily: 'Arial',
            cursor: 'move',
            boxSizing: 'border-box',
            pointerEvents: 'auto',
          }
        }
        ]
      }
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectAnode',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          'pointerEvents': 'none',

        },
        children: [{
            tagName: 'input',
            selector: 'anodeInput',
            className: 'shape-input-div',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            attributes: {
              'name': 'anodeInput',
              'overflow': 'visible',
            },
            style: {
              width: '37%',
              'pointerEvents': 'auto',
            }

    }]}
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectCathode',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          'pointerEvents': 'none',
        },
        children: [{
            tagName: 'input',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            selector: 'cathodeInput',
            className: 'shape-input-div',
            attributes: {
              'name': 'cathodeInput',
              'overflow': 'visible',
            },
            style: {
              width: '37%',
              'pointerEvents': 'auto',
            }
    }]}
      ,{
        tagName: 'foreignObject',
        selector: 'foreignObjectMembrane',
        className: 'foreignObjectclass',
        style: {
          'overflow': 'visible',
          'pointerEvents': 'none',
        },
        children: [{
            tagName: 'input',
            namespaceURI: 'http://www.w3.org/1999/xhtml',
            selector: 'EMInput',
            className: 'shape-input-div',
            attributes: {
              'name': 'EMInput',
              'overflow': 'visible',
            },
            style: {
              width: '50%',
              'pointerEvents': 'auto',
            }
    }]}
  ]
    }, {
      attributes: {
        innerHTML: {
          set: function (html, _, node) {
            if ('innerHTML' in node) {
              node.innerHTML = html;
            }
          }
        },
        value: {
          set: function (text, _, node) {
            if ('value' in node) {
              node.value = text;
            }
          }
        },
        style: {
          display: {
            set: function (styleDisplay, _, node) {
              if ('display' in node) {
                node.style.display = styleDisplay;
              }
            }
          },
          top: {
            set: function (styleTop, _, node) {
              if ('top' in node) {
                node.style.top = styleTop;
              }
            }
          },
          left: {
            set: function (styleLeft, _, node) {
              if ('left' in node) {
                node.style.left = styleLeft;
              }
            }
          },
          width: {
            set: function (styleWidth, _, node) {
              if ('width' in node) {
                node.style.width = styleWidth;
              }
            }
          },
          height: {
            set: function (styleHeight, _, node) {
              if ('height' in node) {
                node.style.height = styleHeight;
              }
            }
          }
        }
      }
    });

    joint.shapes.pfd.electrolyserStackObjectView = joint.shapes.pfd.TemplateObjectView.extend({
      events: _.extend({}, joint.shapes.pfd.TemplateObjectView.prototype.events, {
          'change input': 'onTagInput'
      }),
      onTagInput: function(evt) {
          var input = evt.target;
          this.model.attr(input.name + '/value', input.value);
      }
    });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/HeatXPipes/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.HeatXPipesObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.HeatXPipesObject',
      size: { width: 10, height: 5 },
      ports: {
        items: [
          { group: 'in', args: { x: '-1%', y: '0%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '-1%', y: '100%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 0 L 9 0 L 6 1 L 9 2 L 0 2',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '1%',
          refHeight: '1%',
          ref: 'body',
          refX: -15,
          refY: 35
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.HeatXPipesObjectView = joint.shapes.pfd.TemplateObjectView
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~/Water Wash Column/~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  joint.shapes.pfd.WaterWashColumnObject = joint.shapes.pfd.TemplateObject.extend({
    defaults: joint.util.deepSupplement({
      type: 'pfd.WaterWashColumnObject',
      size: { width: 20, height: 30 },
      ports: {
        items: [
          { group: 'in', args: { x: '0%', y: '45%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '20%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '0%', y: '70%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '0%' }, id: 'in_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '20%' }, id: 'in_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '45%' }, id: 'in_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '100%', y: '70%' }, id: 'in_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'in', args: { x: '50%', y: '100%' }, id: 'in_bottom_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '20%' }, id: 'out_left_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '45%' }, id: 'out_left_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '0%', y: '70%' }, id: 'out_left_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '0%' }, id: 'out_top_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '20%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '45%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '100%', y: '70%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
          { group: 'out', args: { x: '50%', y: '100%' }, id: 'out_bottom_1', attrs: { portBody: { magnet: 'true' } } },
        ]
      },
      attrs: {
        body: {
          refD: 'M 0 1 L 0 10 Q 4 12 8 10 L 8 1 Q 4 -1 0 1 Z M 0 3 L 3 3 M 5 3 L 8 3 M 0 4 L 3 4 M 5 4 L 8 4 M 0 7 L 3 7 M 5 7 L 8 7 M 0 8 L 3 8 M 5 8 L 8 8',
          stroke: 'black',
          fill: 'transparent'
        },
        foreignObject: {
          refWidth: '100%',
          refHeight: '100%',
          ref: 'body',
        }
      }
    }, joint.shapes.pfd.TemplateObject.prototype.defaults)
  });
  joint.shapes.pfd.WaterWashColumnObjectView = joint.shapes.pfd.TemplateObjectView

  joint.shapes.dwgtemplate = joint.shapes.dwgtemplate || {};
  joint.shapes.dwgtemplate.sideBorderShape = joint.dia.Element.define('dwgtemplate.sideBorderShape', {
    attrs: {
      body: {
        d: 'M 0 0 L 1 0 M 1 0 L 1 1123 L 0 1123 L 0 0 Z',
        stroke: 'black',
        fill: 'black',
        style: { 'pointer-events': 'none' }
      }
    },
    markup: [{
      tagName: 'path',
      type: 'path',
      selector: 'body',
    }
    ]
  });
  joint.shapes.dwgtemplate.topBorderShape = joint.dia.Element.define('dwgtemplate.topBorderShape', {
    attrs: {
      body: {
        d: 'M 0 0 L 1587 0 M 1587 0 L 1587 1 L 0 1 L 0 0 Z',
        stroke: 'black',
        fill: 'black',
        style: { 'pointer-events': 'none' }
      }
    },
    markup: [{
      tagName: 'path',
      type: 'path',
      selector: 'body',
    }
    ]
  });




  joint.shapes.dwgtemplate.revisionBlock = joint.dia.Element.define('dwgtemplate.revisionBlock', {
    attrs: {

      foreignObject: {
        refWidth: '100%',
        refHeight: '100%'
      }
    }
  }, {
    markup: [{
      tagName: 'foreignObject',
      selector: 'foreignObject',
      attributes: {
        'overflow': 'visible'
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'transparent',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'grid',
          gridTemplateColumns: '57px 57px 57px 57px',
          gridGap: '0px'
        },
        children: [
          {
            tagName: 'input',
            selector: 'DrawnByLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'DrawnByLabel',
              'value': 'DW. BY'
            }
          }, {
            tagName: 'input',
            selector: 'AuthorLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'AuthorLabel',
            }
          }, {
            tagName: 'input',
            selector: 'CheckedByLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'CheckedByLabel',
              'value': 'CK. BY'
            }
          }, {
            tagName: 'input',
            selector: 'CheckerLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'CheckerLabel',
            }
          }
        ]
      }]
    }]
  }, {
    attributes: {
      value: {
        set: function (text, _, node) {
          if ('value' in node) node.value = text;
        }
      }
    }
  });

  joint.shapes.dwgtemplate.revisionBlockView = joint.dia.ElementView.extend({

    events: {
      'change input': 'onInputChange'
    },

    onInputChange: function (evt) {
      var input = evt.target;
      this.model.attr(input.name + '/value', input.value);
    }
  });

  joint.shapes.dwgtemplate.titleBlock2 = joint.dia.Element.define('dwgtemplate.titleBlock2', {
    attrs: {

      foreignObject: {
        refWidth: '100%',
        refHeight: '100%'
      }
    }
  }, {
    markup: [{
      tagName: 'foreignObject',
      selector: 'foreignObject',
      attributes: {
        'overflow': 'visible'
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'transparent',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'grid',
          gridTemplateColumns: '114px 114px',
          gridGap: '0px'
        },
        children: [
          {
            tagName: 'input',
            selector: 'DrawingNoLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'DrawingNoLabel',
              'value': 'DRAWING NO.'
            }
          }, {
            tagName: 'input',
            selector: 'NumberLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'NumberLabel',
            }
          }, {
            tagName: 'input',
            selector: 'ApprovedByLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'ApprovedByLabel',
              'value': 'APPROVED BY'
            }
          }, {
            tagName: 'input',
            selector: 'ApproverLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'ApproverLabel',
            }
          }, {
            tagName: 'input',
            selector: 'DateLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'DateLabel',
              'value': 'DATE'
            }
          }, {
            tagName: 'input',
            selector: 'drawingDateLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'drawingDateLabel',
            }
          }
        ]
      }]
    }]
  }, {
    attributes: {
      value: {
        set: function (text, _, node) {
          if ('value' in node) node.value = text;
        }
      }
    }
  });

  joint.shapes.dwgtemplate.titleBlock2View = joint.dia.ElementView.extend({

    events: {
      'change input': 'onInputChange'
    },

    onInputChange: function (evt) {
      var input = evt.target;
      this.model.attr(input.name + '/value', input.value);
    }
  });


  joint.shapes.dwgtemplate.titleBlock = joint.dia.Element.define('dwgtemplate.titleBlock', {
    attrs: {

      foreignObject: {
        refWidth: '100%',
        refHeight: '100%'
      }
    }
  }, {
    markup: [{
      tagName: 'foreignObject',
      selector: 'foreignObject',
      attributes: {
        'overflow': 'visible'
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'transparent',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
          flexDirection: 'column',
          justifyContent: 'left',
          alignItems: 'center',
          display: 'grid',
          gridTemplateRows: '2fr 1fr',
          gridTemplateColumns: '228px',
          gridGap: '0px'
        },
        children: [
          {
            tagName: 'textarea',
            selector: 'ProjectLabel',
            className: 'title-block-main-cell-formatting',
            attributes: {
              'type': 'text-area',
              'name': 'ProjectLabel',
              'id': 'title-block-project-name-site'
            }
          }/*, {
              tagName: 'input',
              selector: 'SiteLabel',
              className: 'title-block-main-cell-formatting',
              attributes: {
                'type': 'input',
                'name': 'SiteLabel',
                'value': 'Site Name'
              }
            }*/, {
            tagName: 'input',
            selector: 'SheetNumberLabel',
            className: 'title-block-cell-formatting',
            attributes: {
              'type': 'input',
              'name': 'SheetNumberLabel',
              'value': 'Sheet X of X'
            }
          }
        ]
      }]
    }]
  }, {
    attributes: {
      value: {
        set: function (text, _, node) {
          if ('value' in node) node.value = text;
        }
      }
    }
  });

  joint.shapes.dwgtemplate.titleBlockView = joint.dia.ElementView.extend({

    events: {
      'change input': 'onInputChange'
    },

    onInputChange: function (evt) {
      var input = evt.target;
      this.model.attr(input.name + '/value', input.value);
    }
  });


  joint.shapes.dwgtemplate.logoBlock1 = joint.dia.Element.define('dwgtemplate.logoBlock1', {
    attrs: {
      body: {
        refWidth: '100%',
        refHeight: '100%',
        stroke: 'none',
        fill: 'none',
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%'
      }
    }
  }, {
    markup: [{
      tagName: 'rect',
      selector: 'body'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject',
      attributes: {
        'overflow': 'hidden'
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'white',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'grid',
          gridTemplateColumns: 'auto',
          gridGap: '0px',
          cursor: 'pointer',
          border: '1px solid black'

        },
        children: [{
          tagName: 'input',
          attributes: {
            'type': 'file',
            'accept': 'image/png',
            'id': 'first_Cell_Image_Upload'
          },
          style: {
            position: 'static',
            width: '100%',
            height: '100%',
            display: 'none'
          }
        }, {
          tagName: 'label',
          className: 'logo-label',
          attributes: {
            'for': 'first_Cell_Image_Upload',
            'id': 'first_Cell_Image_Upload_Label'
          },
          style: {
            position: 'static',
            width: '100%',
            height: '20px',
            display: 'none',
            paddingTop: '2px',
            paddingBottom: '2px',
            cursor: 'pointer'

          }
        }, {
          tagName: 'img',
          selector: 'firstCellImage',
          attributes: {
            'src': "data:image/png;base64,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"
          },
          style: {
            position: 'static',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '220px',
            maxHeight: '100px',
            paddingBottom: '2px',
            paddingLeft: '10px',
            paddingRight: '10px',
            cursor: 'pointer'

          }
        }]
      }]
    }]
  }, {
    attributes: {
      src: {
        set: function (newLogoDataURL, _, node) {
          if ('src' in node) node.src = newLogoDataURL;
        }
      }
    }
  });

  joint.shapes.dwgtemplate.logoBlock1View = joint.dia.ElementView.extend({

    events: {
      'change input': 'onInputChange',
      'click div': 'onLogoClick'
    },

    onInputChange: function (evt) {
      try {
        const file = evt.target.files[0];
        // encode the file using the FileReader API
        const reader = new FileReader();
        reader.onloadend = () => {
          this.model.attr('firstCellImage/src', reader.result);
        };
        reader.readAsDataURL(file);
      }
      catch {
        return;
      }

    },
    onLogoClick: function (evt) {
      document.getElementById('first_Cell_Image_Upload_Label').click()
    }
  });
  joint.shapes.dwgtemplate.logoBlock2 = joint.dia.Element.define('dwgtemplate.logoBlock2', {
    attrs: {
      body: {
        refWidth: '100%',
        refHeight: '100%',
        stroke: 'none',
        fill: 'none',
      },
      foreignObject: {
        refWidth: '100%',
        refHeight: '100%'
      }
    }
  }, {
    markup: [{
      tagName: 'rect',
      selector: 'body'
    }, {
      tagName: 'foreignObject',
      selector: 'foreignObject',
      attributes: {
        'overflow': 'hidden'
      },
      children: [{
        tagName: 'div',
        namespaceURI: 'http://www.w3.org/1999/xhtml',
        selector: 'content',
        style: {
          fontSize: 14,
          width: '100%',
          height: '100%',
          position: 'static',
          backgroundColor: 'white',
          textAlign: 'center',
          margin: 0,
          padding: '0px 0px',
          boxSizing: 'border-box',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'grid',
          gridTemplateColumns: 'auto',
          gridGap: '0px',
          cursor: 'pointer',
          border: '1px solid black'

        },
        children: [{
          tagName: 'input',
          attributes: {
            'type': 'file',
            'accept': 'image/png',
            'id': 'second_Cell_Image_Upload'
          },
          style: {
            position: 'static',
            width: '100%',
            height: '100%',
            display: 'none'
          }
        }, {
          tagName: 'label',
          className: 'logo-label',
          attributes: {
            'for': 'second_Cell_Image_Upload',
            'id': 'second_Cell_Image_Upload_Label'
          },
          style: {
            position: 'static',
            width: '100%',
            height: '20px',
            display: 'none',
            paddingTop: '2px',
            paddingBottom: '2px',
            cursor: 'pointer'
          }
        }, {
          tagName: 'img',
          selector: 'secondCellImage',
          attributes: {
            'src': "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAADG4AAANpCAYAAADgrJ4ZAAAAAXNSR0IArs4c6QAAIABJREFUeJzs3Xu01nWh5/EPJoJcQkDcIN4FN24YlLyBjtw0Pc1wmbGTXczLiJ2cGkfPqTHtNKtp6TTZ5cxMmq6s1uqolbpKsk6ax8pQFERQZJ9JwO0lL8iGrYKoiCDMH1v3ySAV3c/zffbzvF5r/dbvByye5+3zsNd26fPhlwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFRKr9IBDaRXkkGlIwAAAKDBbUuyvnQEAAAAAAAAANA4di0d0ECGJOkoHQEAAAANbnOS3UpHAAAAAAAAAACNY5fSAQAAAAAAAAAAAAAAAPXKcAMAAAAAAAAAAAAAAKBCDDcAAAAAAAAAAAAAAAAqxHADAAAAAAAAAAAAAACgQgw3AAAAAAAAAAAAAAAAKsRwAwAAAAAAAAAAAAAAoEIMNwAAAAAAAAAAAAAAACrEcAMAAAAAAAAAAAAAAKBCdi0dAAAAAAAAAAAAAAAAhR2QpDnJIa+fRyXp+w5/77NJHkrSlmRlknsqEUjPZbgBAAAAAAAAAAAAAEAjOSDJUUmOfv18RJIB3fj47ekcb9z9+nlJkle78fHpYXqVDmggQ5N0lI4AAACABrc5yW6lIwAAAAAAAACour2S/KfXj+YCz78gybwkP0yyosDzU5DhRvUYbgAAAEB5hhsAAAAAAAAAjWV2knOSzCgd8ifuSPKdJDcn2VK4hSow3Kgeww0AAAAoz3ADAAAAAAAAoP71TnJWkv+WZHThlrfydJLvvn6sKdxCBRluVI/hBgAAAJRnuAEAAAAAAABQv/ol+UySv02yd+GWnbE5yU3pvAvHXYVbqADDjeox3AAAAIDyDDcAAAAAAAAA6tNpSf4hyV6lQ96j3yQ5O8mTpUPoPruUDgAAAAAAAAAAAAAAgHfpgCTzklyXnj/aSJITk/y/JOeWDqH7GG4AAAAAAAAAAAAAANAT/U2SPySZXDqkmw1MclWSO9I5TKGHM9wAAAAAAAAAAAAAAKAnGZBkbpLvJtm9cEslTU3yL0nOS9KrcAvvgeEGAAAAAAAAAAAAAAA9xRFJWpP8h9IhVdI/ybeT/CJJ38ItvEuGGwAAAAAAAAAAAAAA9AQzkixIckDpkAJmJJmfpKl0CDvPcAMAAAAAAAAAAAAAgFp3ZpKbk/QuHVLQEUmWJGkpHcLOMdwAAAAAAAAAAAAAAKCWXZzkh/H59yQZmeTeJNNKh/DO+YMLAAAAAAAAAAAAAEAt6pXk8iRfLR1SYwYkuT3JGaVDeGcMNwAAAAAAAAAAAAAAqEVXJvkvpSNq1PuS/GOSc0uH8PYMNwAAAAAAAAAAAAAAqDUXxyjhnbgyycdLR/DWDDcAAAAAAAAAAAAAAKglZyX5aumIHqJXkmuTnFQ6hL/McAMAAAAAAAAAAAAAgFoxI8kPSkf0MO9LcnOSY0uHsGO9Sgc0kKFJOkpHAAAAQIPbnGS30hEAAAAAAAAA7FBLkiVJ+pYO6aHWJRmX5OnSIbyZO24AAAAAAAAAAAAAAFBav3TeNcJo493bI8ncJLuWDuHNDDcAAAAAAAAAAAAAACjtyiSjSkfUgaOSXFY6gjcz3AAAAAAAAAAAAAAAoKRTk5xZOqKO/F2Svyodwb/qVTqggQxN0lE6AgAAABrc5iS7lY4AAAAAAAAAoMvwJCuTDCwdUmc6koxOsq50CO64AQAAAAAAAAAAAABAOd+K0UYl7Jnk66Uj6OSOG9XjjhsAAABQnjtuUI8GJDmydEQN+H3pAAAAAAAAAHbasUnuLh1R545Ksrh0RKMz3Kgeww0AAAAoz3CDenRE/IfWJBmS5PnSEQAAAAAAALxjvZO0JmkuHVLnWpNMSPJa6ZBGtkvpAAAAAAAAAAAAAAAAGs5ZMdqohn+T5IzSEY3OcAMAAAAAAAAAAAAAgGraJcnfl45oIBfHdqAoLz4AAAAAAAAAAAAAANX0sST7l45oIKPT+ZpTiOEGAAAAAAAAAAAAAADV0ivJF0tHNKD/kc7XngIMNwAAAAAAAAAAAAAAqJbJScaWjmhAo5OcWDqiURluAAAAAAAAAAAAAABQLWeUDmhgZ5YOaFSGGwAAAAAAAAAAAAAAVEPfJB8tHdHAPpxkQOmIRmS4AQAAAAAAAAAAAABANcxO0r90RAPrm+TU0hGNyHADAAAAAAAAAAAAAIBqOKN0AN6DEgw3AAAAAAAAAAAAAACotL5JTiodQaYkGVg6otEYbgAAAAAAAAAAAAAAUGmTkuxaOoIkybTSAY3GcAMAAAAAAAAAAAAAgEqbUjqALpNLBzQaww0AAAAAAAAAAAAAACrNWKB2GNFUmeEGAAAAAAAAAAAAAACVtGuSSaUj6PKBJANLRzQSww0AAAAAAAAAAAAAACqpJUnf0hF02SXJ+NIRjcRwAwAAAAAAAAAAAACASjq4dADbGVU6oJEYbgAAAAAAAAAAAAAAUEmGG7XHcKOKDDcAAAAAAAAAAAAAAKgkw43aY7hRRYYbAAAAAAAAAAAAAABUkpFA7fGeVJHhBgAAAAAAAAAAAAAAldRUOoDtDC8d0EgMNwAAAAAAAAAAAAAAqKT+pQPYTr/SAY3EcAMAAAAAAAAAAAAAgEoy3Kg93pMqMtwAAAAAAAAAAAAAAKCSjARqT58ku5aOaBSGGwAAAAAAAAAAAAAAVNKA0gHs0O6lAxqF4QYAAAAAAAAAAAAAAJX0UukAdmhz6YBGYbgBAAAAAAAAAAAAAEAlGW7Unq1JXikd0SgMNwAAAAAAAAAAAAAAqKSXSwewnRdKBzQSww0AAAAAAAAAAAAAACrJHTdqz4ulAxqJ4QYAAAAAAAAAAAAAAJVkuFF7DDeqyHADAAAAAAAAAAAAAIBKWl06gO08UzqgkRhuAAAAAAAAAAAAAABQSQ+XDmA73pMqMtwAAAAAAAAAAAAAAKCSjARqj/ekigw3AAAAAAAAAAAAAACopLbSAWzHe1JFhhsAAAAAAAAAAAAAAFSSuzvUHu9JFRluAAAAAAAAAAAAAABQSU8kebZ0BF1eSbKidEQjMdwAAAAAAAAAAAAAAKDS7iwdQJe7kmwpHdFIDDcAAAAAAAAAAAAAAKg0w43a8fvSAY3GcAMAAAAAAAAAAAAAgEqbVzqALt6LKjPcAAAAAAAAAAAAAACg0h5MsqF0BHklyb2lIxqN4QYAAAAAAAAAAAAAAJW2NckvS0eQW5NsKR3RaAw3AAAAAAAAAAAAAACohmtLB5BrSgc0IsMNAAAAAAAAAAAAAACq4fYka0pHNLB1SX5VOqIRGW4AAAAAAAAAAAAAAFANryX5UemIBnZdks2lIxqR4QYAAAAAAAAAAAAAANXy3STbSkc0oG1Jvl06olEZbgAAAAAAAAAAAAAAUC0rktxUOqIB3Zzk4dIRjcpwAwAAAAAAAAAAAACAarqsdEADuqR0QCMz3AAAAAAAAAAAAAAAoJruS/K70hEN5LdJ7i8d0cgMNwAAAAAAAAAAAAAAqDZ33aie/1U6oNEZbgAAAAAAAAAAAAAAUG3/nOSO0hEN4LZ03nGDggw3AAAAAAAAAAAAAAAo4Zwkm0tH1LGN6XyNKcxwAwAAAAAAAAAAAACAEh5N8rXSEXXsK0meKh2B4QYAAAAAAAAAAAAAAOX8z3QOOOhe/5Lkm6Uj6GS4AQAAAAAAAAAAAABAKZuSfDzJltIhdWRTklOTvFY6hE6GGwAAAAAAAAAAAAAAlLQoyX8vHVFHzkvyUOkI/pXhBgAAAAAAAAAAAAAApV2W5LelI+rAT5N8r3QEb2a4AQAAAAAAAAAAAABAaduSfCzJ6tIhPVhbkjNLR7A9ww0AAAAAAAAAAAAAAGpBR5J/n2Rj6ZAe6Nkkf5Xk5dIhbM9wAwAAAAAAAAAAAACAWnF/kr9OsrV0SA/ySpIPJnmkdAg7ZrgBAAAAAAAAAAAAAEAtuSXJfy4d0UO8luQ/JnmgdAh/meEGAAAAAAAAAAAAAAC15uok3ygd0QOcleTXpSN4a4YbAAAAAAAAAAAAAADUoi8kuaJ0RI16LcmZSa4rHcLbM9wAAAAAAAAAAAAAAKAWbUtyXpK/Lx1SY15M8sEk15QO4Z0x3AAAAAAAAAAAAAAAoJZ9NcnfpHPI0eieTnJMkjtKh/DOGW4AAAAAAAAAAAAAAFDrvpfkr5NsLh1S0LIkRyT5Q+kQdo7hBgAAAAAAAAAAAAAAPcFNSf5tOu860WhuSzIpSXvpEHae4QYAAAAAAAAAAAAAAD3FoiTjk9xaOqRKXkryd0k+lOTlwi28S4YbAAAAAAAAAAAAAAD0JM8l+XdJ/jbJ5sItlXRHkrFJ/neSbYVbeA8MNwAAAAAAAAAAAAAA6In+T5LDk9xZOqSbPZfkrCTTk/yxcAvdwHADAAAAAAAAAAAAAICe6g9JpiT5eJJVhVu6ww1JmpP8Y+kQuo/hBgAAAAAAAAAAAAAAPd31SUYl+VyS1YVb3o1nkpyc5GNJOgq30M0MNwAAAAAAAAAAAAAAqAcbk/xDkgOS/NckT5fNeUfmJzkjyYFJ/rlwCxViuAEAAAAAAAAAAAAAQD3ZlOTydA44Ppzkn5K8VrTozZ5P8n+TjElyfJJr09lMnTLcAAAAAAAAAAAAAACgHm1JclOSmUn2TvKFJMsL9rxxd40RSS5IsqJgC1XUq3RAAxmapKN0BAAAADS4zUl2Kx0B3eyIJItLR9SAIen8m4kAAAAAAADg7RyS5MQkJySZms7/19TdNiS5L8nCJPcmuTvJsxV4HnqAXUsHAAAAAAAAAAAAAABAFa18/bjy9R9/IMn4JKOSHJqkOcnYnXi85/7kMVcm+ackD3ZXLD2f4QYAAAAAAAAAAAAAAI3s/tcPqIhdSgcAAAAAAAAAAAAAAADUK8MNAAAAAAAAAAAAAACACjHcAAAAAAAAAAAAAAAAqBDDDQAAAAAAAAAAAAAAgAox3AAAAAAAAAAAAAAAAKgQww0AAAAAAAAAAAAAAIAKMdwAAAAAAAAAAAAAAACoEMMNAAAAAAAAAAAAAACACjHcAAAAAAAAAAAAAAAAqBDDDQAAAAAAAAAAAAAAgAox3AAAAAAAAAAAAAAAAKgQww0AAAAAAAAAAAAAAIAKMdwAAAAAAAAAAAAAAACoEMMNAAAAAAAAAAAAAACACjHcAAAAAAAAAAAAAAAAqBDDDQAAAAAAAAAAAAAAgAox3AAAAAAAAAAAAAAAAKgQww0AAAAAAAAAAAAAAIAKMdwAAAAAAAAAAAAAAACoEMMNAAAAAAAAAAAAAACACjHcAAAAAAAAAAAAAAAAqBDDDQAAAAAAAAAAAAAAgAox3AAAAAAAAAAAAAAAAKgQww0AAAAAAAAAAAAAAIAK2bV0AAD0dCNHjsyQIUMyePDgDB06tOt6yJAhXcfgwYPTu3fvnX7srVu35vnnn8+zzz6bjo6OdHR07PB63bp1Ffgng7IOOOCANDU1ZdCgQdl9993fdPTr12+7n/vzX9u2bVs2bdqUV155ZYfnjRs3ZsOGDVm/fn3Wr1+f5557Li+++GLXj9evX5+NGzeWfhkAAAAAAAAAAADo4Qw3AOAv2H333dPc3JxRo0Zl1KhRGT16dA488MAMGzasa5DRt2/f0pld2tvb8+yzz2bNmjV56qmn8sc//jFPPfVUnnjiiTz55JNpa2vzIXSKO+igg9LU1LTDY6+99sqIESPS1NSUgQMHlk5NkmzcuDHt7e1ZtWpVOjo6smbNmrS3t3cdq1atSltbW1avXl06FQAAAAAAAAAAgBrVq3RAAxmapKN0BABv9sY4Y/To0V3jjDfOw4cPL53X7Z555pk88sgjaWtrS1tbW9f1ww8/nPXr15fOo040NTWlpaVlu2OvvfYqnVYxL7zwQlasWJGVK1d2nVeuXJnly5cbTAHUns1JdisdAd3siCSLS0fUgCFJni8dAQAAAAAAAPDnDDeqx3ADoKC+ffvmsMMOy/jx4zN27NhMmDAhhxxySF2OM96t559/PitXrsySJUty//33Z9GiRWltbS2dRQ3bZ5990tLSkkMPPTRjx47NoYcemnHjxmWPPfYonVZTHn/88bS2tub+++9Pa2trHnzwwbS1tZXOAmhkhhvUI8ONToYbAAAAAAAAQE0y3Kgeww2AKhk4cGCOOeaYHH300fnABz6Q8ePHZ/To0aWzeqSNGzfmvvvuy4IFC7J48eIsWrQoTzzxROksChg8eHCmTJmS4447Lscdd1zGjRuXgQMHls7qsTZu3JgHHnggS5YsSWtraxYuXGgoBVA9hhvUI8ONToYbAAAAAAAAQE0y3Kgeww2ACujVq1fGjBmTSZMmZeLEiZk4cWLGjh2bXXbZpXRa3Wpvb8+iRYuyYMGC3HPPPZk3b17pJCpg+PDhmT59eiZNmpTp06enpaWldFLde+mll7qGUvfdd1/mz5+ftWvXls4CqEeGG9Qjw41OhhsAAAAAAABATTLcqB7DDYBu0tzcnOnTp+eEE07I1KlTM3To0NJJDe/uu+/OvHnzcs899+Suu+7KCy+8UDqJnXTIIYdk8uTJOf744zNp0iR3qakRTz75ZObNm5fbbrstv/71r9PR4V8nAbqB4Qb1yHCjk+EGAAAAAAAAUJMMN6rHcAPgXRo2bFg+9KEP5aSTTsr06dMzYsSI0km8jWXLlmXevHm5++67c8cdd2TNmjWlk/gzI0aMyCmnnJKpU6fm+OOPT1NTU+kk3oElS5bk1ltvzW233Zb58+eXzgHoqQw3qEeGG50MNwAAAAAAAICaZLhRPYYbADvh8MMPz8yZMzNz5swceeSR6dXLt6yerLW1NXPnzs3Pf/7zPPDAA6VzGtaRRx6ZGTNmZNasWZkwYULpHN6j9evX5/bbb8+vfvWr3HzzzXn+eZ9RBHiHDDeoR4YbnQw3AAAAAAAAgJrkU7DVY7gB8DZOPvnkzJ49OzNmzMi+++5bOocKefzxx7tGHPPnz8/WrVtLJ9WtPn365IMf/GBmzpyZGTNmZO+99y6dRIVs2bIld955Z2666abMnTs3q1atKp0EUMsMN6hHhhudDDcAAAAAAACAmmS4UT2GGwB/ZvDgwZk5c2ZmzZqVk08+OQMGDCidRJWtXbs2v/zlLzN37tzcfvvt2bRpU+mkHm/YsGGZPXt2Zs6cmRNPPDH9+vUrnUSVbdu2LYsXL87cuXMzf/783HXXXaWTAGqN4Qb1yHCjk+EGAAAAAAAAUJMMN6rHcAMgyX777ZdTTz01M2fOzOTJk0vnUENefvnl3Hzzzbnuuutyyy23lM7pUUaOHJkzzjgjs2bNysSJE0vnUGOeeuqp3Hjjjbn++utz3333lc4BqAWGG9Qjw41OhhsAAAAAAABATTLcqB7DDaBh7bbbbjnllFMyZ86cnHDCCenVy7cf3trq1avzox/9KD/4wQ/y0EMPlc6pSb17987s2bNz9tln56STTsr73ve+0kn0AI8++mhuuOGG3HDDDXnwwQdL5wCUYrhBPTLc6GS4AQAAAAAAANQkn5ytHsMNoOG0tLTk3HPPzWmnnZYhQ4aUzqGHeuCBB3LNNdfkmmuuyXPPPVc6p7iWlpZ86lOfyic/+cnsueeepXPowZYvX54bbrgh1157bR555JHSOQDVZLhBPTLc6GS4AQAAAAAAANQkw43qMdwAGsKAAQNy2mmnZc6cOTnqqKNK51BHtmzZkltvvTXXXHNNfvGLX+TVV18tnVQ1AwcOzCc+8YmcffbZOfroo0vnUIcWLFiQyy+/PD/96U+zefPm0jkAlWa4QT0y3OhkuAEAAAAAAADUJMON6jHcAOrapEmTcs455+SjH/1o+vfvXzqHOtfR0ZGrr7463/nOd7Jq1arSORUzZcqUzJkzJx/+8IfTr1+/0jk0gPb29lx99dW58sors3r16tI5AJViuEE9MtzoZLgBAAAAAAAA1CTDjeox3ADqzqBBg3LGGWfk3HPPTUtLS+kcGtT111+fq666KnfeeWfplG4xaNCgfPazn80555yTAw88sHQODWrLli2ZO3duLr/88tx1112lcwC6m+EG9chwo5PhBgAAAAAAAFCTDDeqx3ADqBujRo3KBRdckLPOOsvdNagZS5cuzbe//e38+Mc/zqZNm0rn7LR99tknn//85zNnzpwMGDCgdA50aW1tzRVXXJFrr702GzduLJ0D0B0MN6hHhhudDDcAAAAAAACAmmS4UT2GG0CPN3369Jx//vmZNWtW6ZSa0N7envb29qxduzbr16/PunXr3nR+41i3bl1eeeWVbNq06U3nN65ffPHFt3yeoUOHZs899+w6v3E9ePDgNDU1Zc8998yQIUMybNiwrl9rZB0dHfn+97+fK664Ik8//XTpnLc1YcKEXHzxxfnIRz5SOqUmrF27Nu3t7VmzZs0Ov67+9Lyjr6c3rl966aUkycCBA9OnT5/07du36/zGdZ8+fTJkyJAMGjQoe+yxRwYNGrTddVNTU5qamhr+6ypJNmzYkO9973v55je/mWeeeaZ0DsB7YbhBPTLc6GS4AQAAAAAAANQkw43qMdwAeqzTTz89F154YcaNG1c6pWqeeOKJrFy5Mq2trVm1alXa29uzevXqrrFGe3t76cS3tO+++2a//fbLfvvt13U9atSojB49OgcddFDpvKq58cYbc+mll6a1tbV0ynZmz56d888/P9OmTSudUjXPPPNMVqxYkeXLl+fxxx/P6tWrs2rVqq6xRq2PAUaOHJnhw4dn6NChGTlyZJqamnLwwQdnzJgxaW5uzrBhw0onVsWrr76aH/7wh/na176Wxx57rHQOwLthuEE9MtzoZLgBAAAAAAAA1CTDjeox3AB6nDPPPDNf/vKXc+CBB5ZOqZilS5fmoYceyvLly7NixYq0tbVlyZIlpbMqrrm5OQcddFDGjBmT0aNH5+CDD05zc3P233//0mkV8Zvf/CZf//rXc/vtt5dOyemnn56LLrooLS0tpVMqZtmyZVm5cmXXSOPhhx9Oa2trXn755dJpFTVw4MCMHz8+hxxySJqbmzNmzJiMGzcuBx98cOm0injttdfyk5/8JJdeemlWrFhROgdgZxhuUI8MNzoZbgAAAAAAAAA1yXCjegw3gB6hd+/emTNnTi666KK6+xB/e3t7Fi5cmHvvvbfrXO8fJN9Zu+++e4466qhMnDix6xgxYkTprG6zZMmSXHbZZfnZz36WrVu3Vu153//+9+czn/lMzjvvvOy9995Ve95K27BhQ5YtW5alS5fmwQcfzNKlS7Ns2bJs2rSpdFpNGTBgQA477LAcfvjhOfzwwzNhwoSMGzcuffr0KZ3WLbZt25abbropX/nKV2ry7jYAO2C4QT0y3OhkuAEAAAAAAADUJMON6jHcAGreBRdckC984QsZPnx46ZRusWjRoixYsKBrqPHYY4+VTuqR9t9//xxzzDGZOHFijj322BxzzDGlk96zRx99NN/61rdy5ZVXVvR5+vfvny9+8Ys5//zz079//4o+VzW0tbXljjvuyO9+97viKB1vAAAgAElEQVQsXrw4bW1tpZN6tPHjx+fYY4/N1KlTM23atOy1116lk96zW265JZdcckkWLlxYOgXgrRhuUI8MNzoZbgAAAAAAAAA1yXCjegw3gJrUt2/fnHvuubnwwgt79J0Vnn766SxYsCALFy7MggULsmTJEn/rfwVNmjQpxx9/fCZPnpwpU6ZkwIABpZPelTVr1uQb3/hGrrrqqrz00kvd+tif/vSnc8kll2TYsGHd+rjV9Mgjj2TevHn57W9/m9///vdZtWpV6aS6Nnbs2EybNi3Tpk3L1KlTM2TIkNJJ79q8efPypS99KfPnzy+dArAjhhvUI8ONToYbAAAAAAAAAA1uaJJtDofDUStH3759t33uc5/btnr16m3/n707D6+qPPc+/kuYhACSQBgElFIUsOKsWLWKM84DWhVt0TrU6SjOdagep9ZZEQVxoDjVDtaKehRnqVWsWhWFEBVQQZQqgwESQkJyv38s7Yu6gYT9rHXvvfb3c13fq+c913uy1/Ps/ewd67qz89GiRYvs4YcftmOPPdZ69+7tvp+F3nbbbWfnn3++Pf7447Z48WLvl0ezffnll3bqqacG2YtDDz3UKisrvZe0TubMmWPjx4+3Y4891nr16uX+uir0tthiC7vooovsH//4h/dLY5099thjtskmm7jvJRHR96oTkD7byP9s5UKl2W4kAAAAAAAAAAAAACC/MbhBRDnTmWeeaV999ZX3/bzN9s4779hVV11lO+20k/se0prbZpttbOTIkfb3v//dqqurvV86TTZjxgzbb7/91mnNW221lb3yyiveS2iWzz//3B588EE74YQTrG/fvu6vG1p966+/vh1++OH2wAMP2IIFC7xfOs2ycuVKGzdunHXr1s19H4mIvonBDaQRgxtRDG4AAAAAAAAAAAAAQIFjcIOI3Nt5552toqLC+x7eZnniiSfspJNO4obfPO/ggw+2CRMm2JIlS7xfUk3y/PPP22abbdaktfXu3dsefPBB70tusvfee88uvPBCvgUhz9t+++3tqquusmnTpnm/pJps2bJlduWVV1qHDh3c94+ICj4GN5BGDG5EMbgBAAAAAAAAAAAAAAWOwQ0icqu8vNzuv/9+73t2m2T58uX297//3Y455hhr3769+95R2Fq1amX77befjR8/3hYuXOj9clujhoYGmzBhwmqHhjp27GjXX3+91dbWel/qWs2ZM8euvfZaGzhwoPtrgML34x//2C6++GL797//7f1Sa5L//Oc/dvrpp1vLli3d946ICjYGN5BGDG5EMbgBAAAAAAAAAAAAAAWOwQ0iSryioiI77rjj7IsvvvC+T3eN6uvr7emnn7YRI0YwrFFg7b777nbHHXfYokWLvF+Ga3TnnXd+51sCrrzySu9LWqslS5bY+PHjbd9993V/nim5ysrK7JRTTrE333zT+yW4VrNmzbKDDjrIfc+IqCBjcANpxOBGFIMbAAAAAAAAAAAAAFDgGNwgokQbPHhwzv/19SlTptipp55qpaWl7vtF/u255552991325IlS7xfmhnNmzfPTj31VKuoqPC+lNWqqamx++67z/bff3/355P8+8lPfmLXXXedzZkzx/uluUYvv/yybbzxxu77RUQFFYMbSCMGN6IY3AAAAAAAAAAAAACAAsfgBhElUpcuXWzChAne9+Gu1pdffmnXX3+99e/f332vKDdr27at/epXv8qLbwzIFe+++66ddtppfGMNrbYhQ4bYuHHjrKqqyvvlulo333yzlZSUuO8VERVEDG4gjRjciGJwAwAAAAAAAAAAAAAKHIMbRBR7I0aMsAULFnjfe/sD9fX19vjjj9shhxxiLVq0cN8nyp+23HJLu+uuu2zZsmXeL+OcU11dbX/4wx9shx12cH+eKL868sgjbdKkSd4v4Yw+++wz23fffd33iIhSH4MbSCMGN6IY3AAAAAAAAAAAAACAAsfgBhHF1kYbbWTPPvus9/22PzB//ny77LLLrHv37u57RPldx44d7bTTTrP33nvP+2Xt7v3337f/+Z//sQ4dOrg/L5Tf9e/f38aOHWvV1dXeL+sf+OMf/2hdunRx3yMiSm0MbiCNGNyIYnADAAAAAAAAAAAAAAocgxtEFLwWLVrYBRdcYDU1Nd732H7Hq6++akcddZS1bNnSfY8ofQ0ZMsQef/xxa2xs9H6pJ6ahocEmTpxou+22m/v+U/oqLS21Cy+80ObOnev9Uv+OhQsX2ogRI9z3h4hSGYMbSCMGN6IY3AAAAAAAAAAAAACAAsfgBhEFbdCgQfbvf//b+77a7xg/frxtvfXW7ntDhVG/fv1szJgxOfltAaEsXbrUbrvtNuvbt6/7flNhdOSRR9pbb73l/dL/jueee8769OnjvjdElKoY3EAaMbgRxeAGAAAAAAAAAAAAABQ4BjeIKFjXXHON9320//X111/blVdeaeXl5e77QoVZaWmpXXTRRTZv3jzv4xDMJ598Yuedd5517NjRfX+pMNtxxx3tkUcesYaGBu/jYGZmy5YtszPOOMOKi4vd94aIUhGDG0gjBjeiGNwAAAAAAAAAAAAAgALH4AYRZd22225rH374off9s2Zm9vnnn9v5559vJSUl7vtC9G3HHXeczZw50/t4rLP333/ffv7zn7vvI9G3bbTRRnbrrbfa0qVLvY+HmZm9/vrr1q9fP/d9IaK8j8ENpBGDG1EMbgAAAAAAAAAAAABAgWNwg4jWubZt29qoUaNy4i+fz5o1y0455RRr06aN+74QZapFixY2YsQImz17tvdxabJp06bZsGHDrKioyH3/iDLVsWNHu/jii23hwoXex8XMzC666CL3PSGivI7BDaQRgxtRDG4AAAAAAAAAAAAAQIFjcIOI1qntttsuJ25Anzlzpg0fPtx9P4iaWqtWrezkk0+2uXPneh+f1frggw9s+PDhVlxc7L5fRE2pQ4cOdtVVV9myZcu8j49NmTLF+vTp474nRJSXMbiBNGJwI4rBDQAAAAAAAAAAAAAocAxuEFGzKi4utksuucTq6+tdb4z9+OOP7bjjjrMWLVq47wnRutS6dWs788wzbf78+a5naVWzZ8/mXFFeV15ebqNHj7a6ujrXs7RkyRL7xS9+4b4fRJR3MbiBNGJwI4rBDQAAAAAAAAAAAAAocAxuEFGT69mzp73yyiuuN8N++eWXduaZZ7rvBVGo2rZta2+//bbruTIze/LJJ933gihUffr0sQcffNAaGhpcz9Wf//xnW3/99d33g4jyJgY3kEYMbkQxuAEAAAAAAAAAAAAABY7BDSJqUocddphVVVW53fy6YMECu+CCC6xt27bue0EUqg4dOtjEiRPdztX3jRkzxlq3bu2+L0Sh2myzzWzSpEmu52rOnDm28847u+8FEeVFDG4gjRjciGJwAwAAAAAAAAAAAAAKHIMbRLTGWrdubXfddZfbDa91dXV20003WYcOHdz3gihkW221lc2ePdvtbK3O22+/bT179nTfH6KQ7brrrvbOO++4nauVK1fab37zG/d9IKKcj8ENpBGDG1EMbgAAAAAAAAAAAABAgWNwg4hW24Ybbmhvv/22242uEydOtL59+7rvA1HoTj/9dKutrXU7W2uzcOFC23PPPd33iShkRUVFdvTRR7sOTD311FMMIhLRmmJwA2nE4EYUgxsAAAAAAAAAAAAAUOAY3CCijO2555729ddfu9zYOm3aNNt1113d94AodB06dLC//vWvLuequRobG+2KK66w4uJi930jCt15551n1dXVLmfr448/ts0339x9D4goJ2NwA2nE4EYUgxsAAAAAAAAAAAAAUOAY3CCiH/S///u/LjezLliwwE466ST39RPF0aBBg1z/0v+6evnll62srMx9/4hC16tXL3vmmWdczlVNTY0NHz7cfQ+IKOdicANpxOBGFIMbAAAAAAAAAAAAAFDgGNwgov/Wvn17e+qpp1xuYr333nutc+fO7ntAFEcnn3yyLV++3OVshfDZZ5/Z9ttv776PRHF01FFH2Zdffulytm677Tb39RNRTsXgBtKIwY0oBjcAAAAAAAAAAAAA5KQi7wsoIJ0lLfC+CAD+evfurWeffVYDBgxI9HFnzZqlX/7yl3rttdcSfVwgCSUlJbrrrrs0fPhw70vJWn19vc4991yNHj3a+1KA4NZff33ddNNNOuGEExJ/7GeeeUaHH364li1blvhjA8g59ZJae18EENg2kt7yvogcUCZpsfdFAACAgtFLUjdJXVf5z46S1pPU5ptW/Z+b8v/uuMrPXyZpRRbVKPrd6Itv+vyblofdBgAAAAAAAABNweBGchjcAKDttttOTz/9tDp37pzYY9bV1em6667T1Vdfrbo6/rgw0meTTTbRxIkTEx+GittDDz2kY4891vsygFgMGTJE9913nzbccMNEH3f69Onab7/9NGfOnEQfF0DOYXADacTgRoTBDQAAkI0O+u4Qxpr+M5+/6atK/3+Q44vV/M+fS6r2ukAAAAAAAAAgjRjcSA6DG0CBO+aYY/Tggw8m+pivvfaajj/+eH344YeJPi6QlMGDB+vpp59WaWk+/3vS1Zs8ebIOPvhgVVVVeV8KEFzbtm119dVXa+TIkSouLk7scRcsWKADDjhA//rXvxJ7TAA5h8ENpBGDGxEGNwAAQFMMlDRAUv9v/nMTSYMktfe8qBxUrWiAY56kmZI+kPThN//5geN1AQAAAAAAAMAadZZkRFSYXX311Za0s88+233dRHE2bNiwxM/VeeedZ6+88kqijzljxgzbaKON3PebKK623XZbmzFjRqLnyszs6KOPdl87EbnF19AhjbaR/9nKhdI50Q0AANbF+pJ2lPQrSddLmqho2KBe/r+zpKH6b/bzCUk3SjpZ0q6SejTlyQEAAAAAAACAODG4QVSAtW7d2v72t78leiPqu+++a/369XNfO1GcnXvuudbQ0JDYuXrvvfds4403NklWVFRkI0eOtJqamsQe/8svv7Rtt93Wfd+J4qp169Z25ZVXWl1dXWLnyszskksucV87EbnE4AbSiMGNKAY3AAAoLMWS+kk6QNJ5ku6W9Iqkr+T/e0kht0TRt8E9JOlySUdJ2lpS28xPIwAAAAAAAACExeAGUYFVWlpqr7/+emI3n9bV1dlll11mLVu2dF87UVwVFRXZXXfdldi5amxstBtvvNFatWr1g2vp169fomd8+fLldvDBB7s/B0RxNmjQIJs6dWpi58rM7A9/+IP7uoko8RjcQBoxuBHF4AYAAOnWVtKekq6Q9KKkavn//kFNr1HSDEUDNscpGroBAAAAAAAAgOAY3CAqoPr27WuzZs1K7KbTyspK22KLLdzXTRRn6623nj366KOJnau5c+fabrvtttbrOueccxK7JjOzkSNHuj8XRHHWpk0bu/nmm62xsTGxc/Xcc89Zhw4d3NdORInF4AbSiMGNKAY3AABIlzJJh0q6WdIbkurl//sGhe0/kh6VdK6kwZJaCQAAAAAAAACyxOAGUYG0zTbb2KJFixK72XTs2LHWpk0b93UTxVlpaalNmTIl0XPVnJu4BwwYkOi3BIwePdr9OSGKu7333tvmz5+f2LmaNm2a9erVy33dRJRIDG4gjRjciGJwAwCA/PYjSb+QdJeib2bw/t2Ckq9G0mRJ10jaT9L6AgAAAAAAAIBmYnCDqAA64IADErvBdNmyZTZs2DD3NRPFXZLfYDNnzhwbMmTIOl1nmzZt7I477kjkOs3MnnrqKWvXrp3780MUZ126dLEnn3wysXM1b948GzhwoPu6iSj2GNxAGjG4EcXgBgAA+aWVpL0ljZI0U/6/S1Du1SjpfUl3SjpW0XAPAAAAAAAAAKwRgxtEKe+II46w+vr6RG4sfffdd61Pnz7uayaKu8GDB9vixYsTOVdmZu+9956VlpZmdc2HHXaYVVVVJXK9b731lnXu3Nn9eSKKu9NPPz2RM2VmtmDBAttyyy3d10xEscbgBtKIwY0oBjcAAMh93SSdIOnvkpbK//cHyr9mSbpJ0s8kFQsAAAAAAAAAvofBDaIU96tf/coaGxsTuaF01KhR1qpVK/c1E8XdXnvtZTU1NYmcq1VNnTo16+GNDTfc0F5//fVErnfGjBm2wQYbuD9fRHE3aNAg+/TTTxM5V1VVVbbDDju4r5mIYovBDaQRgxtRDG4AAJB7iiRtL+kKSW8p+gYF798ZKD19JWm8pIMktREAAAAAAAAAiMENotR29tlnJ3ITaXV1tR100EHu6yVKoqFDhyZyrlYnxDdvSLIbbrghkeudPXu2bbjhhu7PG1Hcrb/++vbcc88lcq5qampsjz32cF8zEcUSgxtIIwY3ohjcAAAgN7SXNEzRDfXz5f87AhVG1Yq+yeU48XshAAAAAAAAUNAY3CBKYVdccUUiN4/OnDnT+vfv775eoiTaa6+9rK6uLpGztSbTpk0LMrxx2GGHWW1tbezXO2/ePNt4443dnz+iuCsqKrLLL7/cGhoaYj9XdXV1tu+++7qvmYiCx+AG0ojBjShu0AMAwM+PJJ0t6XlJK+T/ewEVdislTVb0muwtAAAAAAAAAAWFwQ2ilDV69OjYbxg1M3vhhResY8eO7uslSqL9998/J4Y2vhVqeGOLLbawuXPnxn69CxYssM0339z9eSRKoj333NO+/vrr2M9VfX29HXrooe7rJaKgMbiBNGJwI4rBDQAAktVJ0hmS3pb/7wFEa+p1SadIWl8AAAAAAAAAUo/BDaIUldTQxnXXXWfFxcXu6yVKov3339/q6+sTOVvNEWp4o3PnzjZlypTYr7eqqsq22WYb9+eTKIn69Olj06ZNi/1cmZkdffTR7uslomAxuIE0YnAjisENAADiVyxpH0l/llQr/89/oua0XNLDil7DxQIAAAAAAACQSgxuEKWgoqIiu+uuu2K/ObS2ttYOO+ww9/USJVWuDm18a9q0adalS5es19myZUu74447Yr/eZcuW2c9+9jP355Uoidq3b28vvvhi7OeqsbHRfvnLX7qvl4iCxOAG0ojBjSgGNwAAiE9fSVdLmiv/z3yiEH0m6XeS+gkAAAAAAABAqjC4QZSCJkyYEPuNoV999ZVttdVW7mslSqpDDz00p4c2vlVZWRlkeEOSnXrqqdbY2Bjr9dbW1toee+zh/vwSJVGLFi0SGaxkeIMoNTG4gTRicCOKwQ0AAMJqJ2mEpJclNcr/s54orl6TdJKkDgIAAAAAAACQ9xjcIMrzHnzwwdhvCK2srLQ+ffq4r5UoqQ499FBbuXJl7GcrlJDDGwcffLDV1tbGer11dXV28MEHuz/PREl11llnxXqmvvXrX//afa1ElFUMbiCNGNyIYnADAIAwfirpbklL5P/5TpRkNZIelLSnpCIBAAAAAAAAyEsMbhDlcffff3/sN4G+9tprtv7667uvlSip8m1o41shhzd++tOf2sKFC2O93pUrV9rQoUPdn2+ipNpnn32suro61nPV2NhoRx99tPtaiWidY3ADacTgRhSDGwAArLsWkoZLekf+n+lEudAcSVdJ6isAAAAAAAAAeYXBDaI8bfTo0bHe/Glm9thjj1mbNm3c10qUVIcffnjs5ypO06ZNCza80b9/f/v0009jv+bBgwe7P+9ESbXVVlvZggULYj1TK1eutGHDhrmvlYjWKQY3kEYMbkQxuAEAQPO1kzRS0qfy/ywnysUaJf2fpF0EAAAAAAAAIC8wuEGUh11xxRWx3vRpZnbLLbdYUVGR+1qJkmq33XaL/VwloaKiwsrLy4PsSdeuXe2dd96J9XoXLVpkAwYMcH/+iZKqX79+NmfOnFjPVX19ve29997uayWiZsfgBtKIwY0oBjcAAGi6ckm/k7RI/p/hRPnSFEmHSioSAAAAAAAAgJzF4AZRnjVy5MhYb/Y0Mzv77LPd10mUZIMGDbKqqqpYz9WiRYti/fmrCjm80aFDB3vppZdivd65c+daz5493V8HREnVo0cPmzFjRqznavny5bbjjju6r5WImhWDG0gjBjeiGNwAAGDt+km6W1Kt/D+7ifK1SkknSGolAAAAAAAAADmHwQ2iPOrEE0+M9SZPM7NTTjnFfZ1ESbbBBhvY/PnzYz1Xl156qfXs2dM++eSTWB9nVZWVldalS5cge9SmTRt74oknYr/eTp06ub8eiJKqrKzM3njjjVjPVVVVlW2++ebuayWiJsfgBtKIwY0oBjcAAFi9nSVNlNQo/89sorT0uaQLJHUUAAAAAAAAsBZ8jWtyOkta4H0RANZuzz331DPPPKPi4uJYfr6Z6Re/+IUeeuihWH4+kIs6deqk119/Xf3794/tMU477TSNHTtWktSzZ0+9+uqr2mijjWJ7vFV98MEH2nnnnbVgQfYf9cXFxRo/frxGjBgR4Moye+ONN7TrrruqtrY2tscAcklJSYmeeOIJ7bbbbrE9xvz587Xddtvps88+i+0xAARTL6m190UAgW0j6S3vi8gBZZIWe18EAAA5pEjSIZLOl/RT52sB0myJpDsl3SJpvvO1AAAAAABQSE6XVO59EQmrkXS990Vg3TC4kRwGN4A8MGjQIE2ZMkUlJSWx/PyVK1dq+PDh+utf/xrLzwdyUevWrfXKK69o++23j+Xnm5lOPPFEjR8//jv/+3we3pCka665RhdffHGQn5XJpEmTdMABB6ihoSG2xwBySevWrTVx4kQNHTo0tseYMWOGdthhBy1ZsiS2xwAQBIMbSCMGNyIMbgAAEGkj6ThJ50ra2PlagEJSJ+kBSddKmul8LUDc9pe0nfdFOFkh6ffeFwEAzXCBpHZN/P87QdInMV4LAMThDEldvC/C0UpJV3tfhKMKSQO9LyJhixTdkw5gDTrL/+t6iWgN9ezZ0+bPn29xqaurs3333dd9nURJN3HixNjOlZnZMcccs9rH7tmzp82cOTPWx1/VtGnTrEuXLsH27txzz431esePH+/++iBKstatW9vTTz8d67l6+eWXrUWLFu5rJaI1VicgfbaR/9nKhUqz3UgAAPJcsaQTJM2T/+cyUSHXKOlRSdsKSK895X/WPPtZ9lsIAInYTc17f7vd5zIBYJ0NlP/vht79MetdzG8z5P8cJN3CIDsHpByDG0Q5XMeOHW3atGmx3si51157ua+TKOnGjh0b67k65JBD1noN+T68cfbZZ8d6vVdeeaX764QoyVq3bm0vvPBCrOeKoSiinI/BDaQRgxtRDG4AAArZvpLel//nMRF9t/9T4f3lTxSOmfI/Y179OcD+AUASHlfz3t+qJXVwuVIAWDfj5P+7oXeDs97F/MbgBoCMGNwgytFatWplkydPju3mzdraWhsyZIj7OomS7uKLL47tXJmZHXjggU2+FoY31uz44493f70QJdl6660X+/DGpZde6r5OIlptDG4gjRjciGJwAwBQiDaT9LL8P4eJaPU1SLpHUjcB6XKa/M+XV/WSume/hQAQq76Kvgmsue9x53tcLACsg46SauX/u6Fn72S9i/mPwQ0AGTG4QZSjPfTQQ7HdtMnQBhVqxx57bGznqr6+3vbff/9mX1PPnj3tk08+ie26vq+ysjLo8MbIkSNju9a6ujrbeuut3V83REmWxPDGEUcc4b5OIsoYgxtIIwY3ohjcAAAUkg0k3a91uxGLiHyqlnSVpBIB6dBOUpX8z5ZX/5v9FgJArG7Xur2/zZVU7HC9ANBc58v/d0Lvjs56F/MfgxsAMmJwgygHO+ecc2K7WZOhDSrUhgwZEtu5MrN1Gtr4tnz/5o0437Pmzp1rXbt2dX/9ECXZeuutZy+++GJs56qmpsa22WYb93US0Q9icANpxOBGFIMbAIBC0EHStZKWy/+zl4jWrf9IOlVSSwH571b5nymvvhDnGEDu6qBoaHRd3+OOSP6SAaBZihUNmnn/TujZfPH7qMTgBoDVYHCDKMfaa6+9rKGhIZYbNRnaoEKtZ8+etmjRoljOlZnZfvvtl/U1duvWzT766KPYrvH7pk+fHnR445JLLontWl955RX31xBR0rVr186mTJkS27n6/PPPrUePHu7rJKLvxOAG0ojBjSgGNwAAadZK0lmSFsj/M5eIwlQp6RAB+e3HKuxvfzoy+y0EgFhcqOze315L/pIBoFkOkf/vgt5dkvUupgODGwAyYnCDKIcaOHCgLV26NJYbNJcvX2677bab+xqJPHr99ddjOVdmZgcddFCw6+zRo0eiwxuhv3njtttui+1ab7vtNvfXEVHStW/f3qZOnRrbuXrnnXesbdu27uskov/G4AbSiMGNKAY3AABpdYSkj+T/WUtE8fS6pG0F5K+n5H+OvHolwP4BQGgtFeav0G+R9IUDQDO8KP/fBT2rlVSW9S6mA4MbADJicIMoRyotLbW5c+fGcmNmY2Nj0JvLifKpMWPGxHKuzMxOPvnk4NfbrVs3mzVrVmzX/H2VlZXBhjeKiorsL3/5S2zXOnz4cPfXE1HSlZWVWUVFRWznauLEie5rJKL/xuAG0ojBjSgGNwAAabO1pKny/4wlomR6WFIfAflnqPzPj2ebZr+FABDU0Qr3uwkA5KKB8v8d0Lt7s97F9GBwA0BGDG4Q5Uj/+Mc/Yrspc+TIke7rI/Jo+PDhsZ2rm2++ObbrzufhjZYtW9oLL7wQy3XW1tba1ltv7f66Ikq6rl272ocffhjLuTIzu/jii93XSEQyMbiBdGJwI4rBDQBAWrSXdLukBvl/vhJRstVJGiUg/3wo//Pj1bgA+wcAIb2rMO9v9ZK6JnztANAU4+T/O6B3A7PexfRgcANARgxuEOVA119/fWw3Y95zzz3u6yPyaNCgQVZbWxvLuXr00UetqKgo1uvP5+GNkpISe/vtt2O5znnz5llZWZn764so6Xr06GGffvppLOfKzGzIkCHuayQiBjeQSgxuRDG4AQBIg59L+lz+n6tE5D6Iyb8AACAASURBVNs7kgYJyB9nyv/ceFUrqWP2WwgAQeyksO9xv0/28gFgrToq+v3L+3dAz17KehfThcENABkxuEHk3P777x/bTZhPP/20FRcXu6+RKOk6depkH3/8cSzn6s0337T11lsvkXX06NHDZs6cGcs6MqmoqLDy8vIg196lSxf76KOPYrnOF1980f01RuTRgAEDrKqqKpZztWDBAuvWrZv7GokKPAY3kEYMbkQxuAEAyGe9Jb0g/89TIsqdVkq6QVJbAbmvo6Rq+Z8br87OfgsBIIhHFPb9baGkdomuAADW7Hz5/+7n3SFZ72K6MLgBICMGN4gc23DDDW3p0qWx3ID5r3/9K7Gby4lyrWeeeSaWczVz5sxg30rR1Lp162YffvhhLOvJZPr06cHW2LdvX1uwYEEs13nTTTe5v86IPNpll12srq4ulnP1z3/+01q2bOm+RqICjsENpBGDG1EMbgAA8lFLSRdJqpH/ZykR5WafSNpbQO67Xf7nxauZkoqy30IAyEovSQ0K/x53SpKLAIA1KJY0V/6/+3k295t9wP/H4AaAjBjcIHLs3XffjeXGy5kzZ1qnTp3c10fk0RVXXBHLuVq0aJH169fPZU3dunWzWbNmxbKuTCorK4MNb2y77bZWW1sby3UeeOCB7q83Io+OPPLIWM6Umdn111/vvj6iAo7BDaQRgxtRDG4AAPLNQEnvyf8zlIjyo4cldRWQu34s/3Pi2dDstxAAsnKL4nl/myWG0wDkhkPl/zufd+dkvYvpw+AGgIwY3CByaty4cbHccPn111/bxhtv7L4+Io/23HNPa2xsDH6uVqxYYTvssIPr2vJ5eGPYsGGxPC+LFi2yHj16uL/uiDz6zW9+E/xMfeuAAw5wXx9RgcbgBtKIwY0oBjcAAPmiSNG/aK+V/+cnEeVXiyWdKG6eRO56Vv7nxKsnA+wfAKyrDpKWKL73uH2TWwoArNaL8v+dz7NqRe/3+C4GNwBkxOAGkUP7779/LDdarly50nbddVf39RF5tNFGG1lVVVUsZ2vYsGHu65Oi4Y0PP/wwljVmMn369GDDG+ecc04s1/jCCy+4Py9EXk2YMCGWc7Vo0SIrLy93Xx9RAcbgBtKIwY0oBjcAAPmgp6TJ8v/cJKL8brKk7gJyz4HyPx9eNUrqnf0WAsA6OVvxvsc9k9xSACCjgfL/fc+727PexXRicANARgxuECVc9+7dbdGiRbHcaHn88ce7r4/Io6KiInv11VdjOVfnnXee+/pWLZ+/eWPMmDGxXOMFF1zg/rwQedSiRQubPHlyLOdq0qRJ7usjKsAY3EAaMbgRxeAGACDXjZD0tfw/M4koHS2WdJiA3FIkaY78z4dXN2S/hQDQbMWS5ir+97gBSS0IADK4S/6/63nWKKlv1ruYTgxuAMiIwQ2ihIvrBstbb73VfW1EXo0cOTKWczVt2jT3tWWqW7du9sEHH8Sy5kxCfvPGSy+9FMs1brXVVu7PC5FHZWVl9umnn8Zyrs444wz39REVWAxuII0Y3IhicAMAkKs6S/qb/D8riSidPSipo4DccY78z4VXVZLaZL+FANAsw5TMe9xdSS0IAL6no6Ra+f+u59lTWe9iejG4ASAjBjeIEiyum8ufffZZKy4udl8fkUcDBgywFStWxHK2zMzGjBnjvsZM5es3b5SVldm8efOCX9+sWbOspKTE/Xkh8mjQoEFWW1sb/FwtX77cBgwY4L4+ogKKwQ2kEYMbUQxuAABy0VBJ/5H/5yQRpbvPJO0iIDd0lFQt/3Ph1a+y30IAaJZXlcz7W62ksoTWBACrOl/+v+N5t0/Wu5heDG4AyIjBDaKE2nTTTYPfUGlmNmPGDGvfvr37+og8Ki4utqlTp8ZytlbF8EYk1PDG1ltvHctN5nfffbf7c0Lk1fDhw4OfKTOzqVOnWsuWLd3XR1QgMbiBNGJwI4rBDQBALmkp6Wb5fz4SUeHUKOkGSa0F+LtT/mfCq+kB9g8AmmoLJfsed0kyywKA/yqWNFf+v+N5NivrXUw3BjcAZMTgBlFCvf/++8FvpqyqqrJ+/fq5r43Iq8svvzz4uVodhjcioYY34rrJ/MADD3R/Toi8uuGGG2I5V1dffbX72ogKJAY3kEYMbkQxuAEAyBU9Jf1L/p+NRFSYVUgaKMDXpvI/C57tmP0WAkCTPKxk39/+o2hIHQCScqj8f7fz7pSsdzHdGNwAkBGDG0QJdPXVVwe/ibKxsdH22GMP97URebX55ptbfX198LO1JgxvREINb4wdOzb4tS1atMh69Ojh/pwQefXcc88FP1dmZttuu6372ogKIAY3kEYMbkQxuAEAyAW7KvqXp96fi0RU2NVKOkmArxflfxa8eijA/gHA2vSSVK/k3+OOSWJxAPCNl+T/u51nSyS1y3oX043BDQAZMbhBFHNbbLGFNTQ0BL+B8tJLL3VfG5FnFRUVwc9VU9xxxx3ua89Ut27drLKyMrF9qKioCDK88a9//Sv4tU2ePNn9+SDyqnPnzvbZZ58FP1fTp0+31q1bu6+PKOUxuIE0YnAjisENAICnIkmXS2qQ/2ciEdG3PSSprQAfhfzXkesV3SMCAHG6Tj7vce8msTgAUPRNgt6/13l3fda7mH4MbgDIiMENohhr3bp1LDeXP/XUU+5rI/LspptuCn6umoNv3oiE+OaNnj172uLFi4Nf2xlnnOH+fBB5tc0228TyjUTXXnut+9qIUh6DG0gjBjeiGNwAAHgpk/Sc/D8LiYgyVSHpRwKSVyxpjvzPgFeXZr+FALBa7RT9FXav97id418iAOgu+f9O51mDom9XwpoxuAEgIwY3iGLs2muvDX7TZGVlpbVv3959bURe7bjjjtbY2Bj8bDUXwxuREMMbQ4cODX5dS5Ysse7du7s/H0RejRw5Mvi5WrlypW2//fbuayNKcQxuII0Y3IhicAMA4GF7SZ/J/3OQiGhNLZF0kIDkXSD/179XXygaXgGAOJwh3/e4v8W/RAAFrqOkWvn/TufZI1nvYmFgcANARgxuEMXUdtttZw0NDUFvmFy+fLn179/ffW1EXpWUlNinn34a9Fxlg+GNSIjhjeuvvz74df3lL39xfy6IPHv88ceDn6uPPvrIWrdu7b42opTG4AbSiMGNKAY3AABJG6no90vvz0AioqZ2o6QWApJTpsK+4e7w7LcQAH6gSNIs+b6/8VfgAcStkAeAv+1nWe9iYWBwA0BGDG4QxVRFRUXwmyXPOOMM93UReTZ69Ojg5ypbd9xxh/u+ZKp79+5WWVmZ2D5UVFRkPbzx6quvBr+uoUOHuj8XRF516NDBPvroo+Dn6ne/+5372ohSGoMbSCMGN6IY3AAAJKWlpL/I/7OPiGhdelVSdwHJuUf+r3uvXgqwfwDwfQfJ//3NJN0U90IBFKxiSXPl/z7n2TtZ72LhYHADQEYMbhDF0BVXXBH8JslnnnnGfV1Enm2++ebW2NgY/GyFkMvfvJHk8Ea237zRs2dPW7x4cdBrmjNnjrVt29b9uSDyarPNNgt6pr41aNAg97URpTAGN5BGDG5EMbgBAEhCqaKbnr0/94iIsulLSbsKSMam8n/Ne7Zp9lsIAN/xkvzf20zSEkntYl4rgMJ0qPzf47wbkfUuFg4GNwBkxOAGUeA23nhjq6+vD3pz5KJFi6y8vNx9bUSevfHGG0HPVWi5OrzRpUuXvBreOOSQQ4Jf07XXXuv+PBB5ds455wQ/V2+99ZYVFRW5r40oZTG4gTRicCOKwQ0AQNz6SfpY/p95REQhapB0koBk/EP+r3mvxgTYPwD41hbyf19btTPjXS6AApUrA2peLZTUJutdLBwMbgDIiMENooAVFRXZ66+/HvzmyAMPPNB9bUSeHXvsscHPVRwY3ohkO7zxwAMPBL2elStXWv/+/d2fByKvioqK7KWXXgp6rszMzjrrLPe1EaUsBjeQRgxuRDG4AQCI046SquT/eUdEFLpRkooFxOsI+b/WvaqW1DH7LQQASdJ98n9fW7VZkopiXTGAQjNQ/u9t3l2R9S4WFgY3AGTE4AZRwE4//fTgN0Xee++97usi8qxDhw721VdfBT9bcWF4I5LN8EbHjh1t3rx5Qa/n1VdfdX8OiDzr0aOHVVVVBT1XNTU11qtXL/e1EaUoBjeQRgxuRDG4AQCIyzGS6uX/WUdEFFeTJLUXEJ9iSfPl/1r3ir9IDyCErsrNfy45OM5FAyg4d8v/fc2zekndst7FwsLgBoCMGNwgClSvXr1s6dKlQW+I/OSTT6ykpMR9bUSe3XjjjUHPVRIY3ohkM7yx++67B7+ek08+2f05IPIsjm8vmjRpkvu6iFIUgxtIIwY3ohjcAADE4Tr5f8YRESXRdEk9BcTnYvm/zr2aGWD/AOBq+b+fZeqlOBcNoKB0lFQr//c1zx7IehcLD4MbADJicIMoUH/961+D3wy50047ua+LyLO+fftaXV1d8LOVBIY3ItkMb4wdOzbotSxevHidr4UoLT322GNBz5WZ2SGHHOK+LqKUxOAG0ojBjSgGNwAAIa0n6TH5f74RESXZfEX/fAHEoUyFfSPeXtlvIYAC1kbRTZre72Wra4v4lg6ggFwg//cz77bMehcLD4MbADJicIMoQDvttFPwmyDvvPNO93UReff8888HPVdPPfWUTZ06NejPXJNRo0a572GmunbtahUVFYntQ0VFhXXt2rXZ19muXTubPXt20Gu577773PefyLPS0lL74osvgp6r2bNnu6+LKCUxuIE0YnAjisENAEAoHST9S/6fbUREHi2XdJiAeEyQ/2vcq8cC7B+AwnWy/N/H1tSE+JYOoEAUS5or//czz17NehcLE4MbADJicIMoy4qKimzGjBlBb4CcN2+elZSUuK+NyLPDDjss6Ln6+uuvrWvXrlZWVmbvvfde0J+9JnzzRmRdv3ljt912C34tm222mfv+E3n285//PPi5+s1vfuO+LqIUxOAG0ojBjSgGNwAAIXSV9J78P9eIiDxrlHShgPC2kv/r26sGSb2z30IABahIuX9Tar2if5YCgHV1mPzfy7z7eda7WJhy/TMyjhjcyGNF3hdQQDpLWuB9EUA+O/XUUzVmzJigP3OPPfbQiy++GPRnAvmkTZs2+uijj9S7d7j/nvjEE0/UvffeK0kqKyvTyy+/rEGDBgX7+WsyduxYnXbaaYk8VnN06dJF//znP9W/f/9EHu+DDz7QzjvvrAULmverx5/+9CcdeeSRwa7jpZde0u677x7s5wH5aNKkSdpnn32C/byamhr16dNHX331VbCfCRSgekmtvS8CCGwbSW95X0QOKJO02PsiAAB5rbekf0jq430hyGu1kqqb2LLV/O/rJLVV9M8ua6qNpHJJ3Vepxzf/t0AI90s6UdE/SwOhvCbpp94X4eQ6Sb/xvggAeWeopKe9L6IJrpR0ufdFAMhbL0va1fsiHH0maSNFQ/RonhmSBnhfRMIWKbonHcAa8I0bRFnUqVMnW7x4cdC/WD1u3Dj3dRF5d9VVVwU9V6+88soPHoNv3ojKh2/e6N69uy1ZsiTodey3337ue0/kWa9evaympibouZowYYL7uojyPL5xA2nEN25E8Y0bAIBs9JP0ufw/zyj3+0LSFEkPS/qdpF9L2kdSMn+1pWk6StpE0i6SjpR0lqJr/ZOiG6bnyX8fKX96XgwDIayj5f+69mqBoqE7AGiOZ+X//tWUFor3OADrZqD838O8Y7h33fGNGwAyYnCDKItGjRoV9IbHzz77zEpKStzXReTZhhtuGPRcLV++3DbaaKOMj1VWVmZTp04N+nhrcvvtt7vvb6a6dOliFRUVie3DjBkzmj28ccYZZwS9hunTp7vvO5F3I0eODHquzMy23HJL93UR5XEMbiCNGNyIYnADALCuBim6kdL7s4xyo/mKBjP+JOlaRYMZeyu3BjNC+bGkIZKOU/TXke9VdJP+Qvk/D5RbTVE0EASE0FLRe63369qrEdlvIYACMkD+71vN6fh4tgFAyt0t//cvz2oVfaM41g2DGwAyYnCDaB370Y9+ZCtXrgx6s+MRRxzhvi4i78aPHx/0XJ155plrfDy+eSMq1795o6ioyN58882g13DiiSe67zuRZ0VFRfbWW28FPVeTJ092XxdRHsfgBtKIwY0oBjcAAOtiJ0lL5P85Rj59KekJSZdI2lNSe+FbPSUdqGigY6KkufJ/vsi3qYr+nTcQwmXyf0179e8A+wegcNwj//et5jQjnm0AkGJligYXvN+/PLsr610sbAxuAMiIwQ2idezhhx8OeqPjiy++6L4mIu/69esX9Fy99dZbTXrczp07Jzq8cdttt7nvdabKy8sT/+aNrl27Nvn6tt5666CP//nnn1vbtm3d953Isy233DLouTIz22effdzXRZSnMbiBNGJwI4rBDQBAc+0tbg4otKZIuk3SzxV92wSap7OkfSRdJOkvkj6X/3NKyfahpA0EZK+bpHr5v6a92j77LQRQAPL1Zubd49gMAKl1ofzft7wbmPUuFjYGNwBkxOAG0To0aNCgoDc41tXVWd++fd3XReTdQw89FPRsbbfddk1+bL55IyrXv3lj3LhxQR//t7/9rfueE3k3ZsyYoOfq3XffdV8TUZ7G4AbSiMGNKAY3AADNcZgK+4bRQuhjSQ9LGilpB0mthThsLOlkRXs9X/7PO8Xfp5J+JCB7D8r/9ezV/QH2D0D65eu3Ez0Rx2YASKVi8e2Oz2W9i2BwA0BGDG4QrUP/93//F/QGx9///vfuayLybsCAAdbQ0BDsXN1///3NvgaGN6JyeXijtLTUlixZEuyxly1b1qxv/SBKY6WlpVZVVRXsXJmZHXHEEe7rIsrDGNxAGjG4EcXgBgCgqQ6X1CD/zy4K1xJJL0i6RtJBiv69HHxsKul0SY9IWiD/1wbF03++ea6BbAyW/2vZq1rxWQVgzdoo+rz1fr9alxol9Q2/JQBS6DD5v2d5d0DWuwgGNwBkxOAGUTPbeeedg97Y+MUXX1jbtm3d10Xk3SOPPBLsXFVXVzfrWxxWjeGNqFwe3hg5cmTQx87V54Aoyc4+++yg52rWrFlWXFzsvi6iPIvBDaQRgxtRDG4AAJriIEkr5f+5Rdn3laS7JO0lqYWQi4oU3Zh9jaT35f+aobAtVvTPIkA23pb/a9mriwLsH4D0Ol7+71PZNDr8lgBIoZfl/37l2SxF/9yM7DC4ASAjBjeImtmbb74Z9MbGYcOGua+JyLstttgi6Lk6//zzs7oehjeicnV4o0WLFvbRRx8Fe9yVK1faJpts4r7fRJ61atUq6LkyMzv++OPd10WUZzG4gTRicCOKwQ0AwNocJKle/p9ZtO4tEMMa+ay3pLMUfTsKZzEdLRXDG8jOL+T/OvZqjqTi7LcQQErl+02o1ZI6BN8VAGkyUP7vVd6dmfUuQsr/z8x1icENoAkY3CBqRkOHDg16Q+PkyZPd10SUCz3++OPBztUHH3wQ5Jo6d+6c6PDG6NGj3Z+HTJWXl9u0adMS24eKioomDW/svvvuQR/3T3/6k/teE3m33377BT1Xn3zyifuaiPIsBjeQRgxuRDG4AQBYk6HiRvF8bYGkuyXtLYY10qSjpKMk/VHRNzd4v85o3fta0uYC1k1LRTcdeb+OvTok+y0EkEJ7yP/9KUTnhd4YAKlyj/zfpzyrltQu612ExOAGgNVgcIOoGU2ZMiXoDY1bb721+5qIvNtuu+2CnqsDDzww2LUlPbwxatQo9+cjU+Xl5VZRUZHYPsyYMcO6du261uuaOHFi0Mft16+f+14Teffyyy8HPVcnnnii+5qI8igGN5BGDG5EMbgBAFid3SWtkP9nFTW9BYpu4mBYozC0UvSNOI9IqpX/64+a30IxvIF1d5X8X8NePR9g/wCkz5Pyf38K0VzxzUIAMisT/+x3a9a7iG8xuAEgIwY3iJrY3nvvHfRGxkceecR9TUS50LPPPhvsXP373/8Ofn1lZWWJDm+MGTPG/TnJVJcuXayysjKxfZg1a5Z169ZtjdfUv39/W7lyZbDHHDdunPs+E3m36aabBjtTZmazZ892XxNRHsXgBtKIwY0oBjcAAJnsLGm5/D+naO0tVDSssY8Y1ihk60s6SdI/JDXK/3VJzTvDA3/4lAJr1U2F/a1YP85+CwGkSF+l63egI8JuD4CUuFD+70+eNSp6v0cYDG4AyIjBDaImFvLbNlauXGl9+vRxXxORdz/5yU+CnSszsx133DGW62R4IyoXhzfGjRsX7PFWrFjRpG/6IEp7EyZMCHauzMyOO+449zUR5UkMbiCNGNyIYnADAPB9gyVVy/8zitbc25J+qehbF4BV9ZZ0iaRK+b9OqWl9KWnjTE8msBZ/kv/r16vRAfYPQHqMkf/7UsheDbs9AFKgWNE38ni/P3n2eNa7iFUxuAEgIwY3iJrQHnvsEfQGxrFjx7qviSgXevjhh4OdqyeffDLWa+3cubNNnTo12PWuzahRo9yfn0yVl5cnug+VlZXWvXv31V5Pt27drKamJtjj/e53v3PfYyLvevXqZXV1dcHO1YcffmjFxcXu6yLKgxjcQBoxuBHF4AYAYFVbS1oq/88nylyDpEcl7bK6JxD4nu0k3aZoMMD79Utr7nMxvIHm20n+r12vqiW1y34LAaRAmdI5eL5FyE0CkPeGyf99ybs9st5FrIrBDQAZMbhB1IRCftvGsmXL+IvuRJJttNFG1tDQEOxsbbbZZrFfM9+8EVVaWmrTpk1LbB/W9s0bV155ZbDHWrJkiXXo0MF9j4m8u/nmm4OdKzOzY4891n1NRHkQgxtIIwY3ohjcAAB8q7+kxfL/bKIfViXpFkkbrfbZA9aslaQjJU2W/+uZVt/nkn60mucQWJ235f/a9eq0APsHIP9dJP/3ozj6Y8hNApD3Cv2f5Sqy30J8D4MbADJicINoLe2yyy5Bb1y84oor3NdElAvdeeedwc7VQw89lNh1l5WV2YwZM4Jd+9owvBFZ0/BGSUmJLVy4MNhjXXjhhe77S+Rd586drbq6Oti5+uCDD9zXRJQHMbiBNGJwI4rBDQCAJHWTNE/+n0v03WZJGimp/eqfOqDZNpV0h6Ql8n+N0w+bI4Y30DzHy/9169XMAPsHIL+1lPQf+b8fxVG9pK7htgpAHhso//ck707KehfxfQxuAMiIwQ2itfT0008Hu2nx66+/tpKSEvc1EXnXpUsXW7FiRbCz1adPn0Svv7y83CoqKoJd/9qMGjXK/TnLVFlZmb3//vuJ7cNHH31k3bt3z3gtZ5xxRrDH+fLLL933ligXuuSSS4KdKzOzQw45xH1NRDkegxtIIwY3ohjcAAB0kPS+/D+T6P83WdKhkorX8LwB2eqg6K/VT5P/a56+2xxJvVf/1AHf0UbRDUjer1uv9sh+CwHksWPk/z4UZ78Pt1UA8tg98n8/8myhot95ERaDGwAyYnCDaA1tttlmQW9Y/O1vf+u+JqJc6MYbbwx2riZMmOCyhvLycr55Q7nzzRutW7e2zz//PNjjnHzyye57S+Rd27Zt7auvvgp2rqZMmeK+JqIcj8ENpBGDG1EMbgBAYWsp6RX5fx6RtELS/ZK2WuMzBsRjV0l/VvTPft5ngaJmSuq0picNWMXv5f+a9ervAfYPQP56V/7vQ3HGzcoAyiTVyv/9yDOG2OLB4AaAjBjcIFpDDz74YLCbFfm2DaKoTp06WU1NTZBz1dDQYP369XNbC8MbUbkyvHHWWWcFe4zZs2dbcXGx+94SeXfeeecFO1dmZjvvvLP7mohyOAY3kEYMbkQxuAEAhatI0l/k/1lE0gPir+sjN3SXdL2k5fI/FyS9Lmm9NT5jQKSn/F+vXjWIz1CgUP1M/u9BSfTrUBsGIC/9Rv7vQ96/63XLeheRCYMbADJicINoNW2wwQZWX18f7EbFiy++2H1NRLnQZZddFuxcPfDAA+7rYXgjKheGN0J/O8ARRxzhvq9E3rVt29YWLVoU7FxNnDjRfU1EORyDG0gjBjeiGNwAgMJ1g/w/hwq9lyVttrYnCnDQVdKtYoAjF3paUvGany5AkvSI/F+vXvFXmIHC9Hf5v/8k0SxFQ/cACk+xpLnyfx/y7M9Z7yJWh8ENABkxuEG0mm699dZgNynybRtEUW3btrXFixcHO1ubbLKJ+5qkaHgjyaGF0aNHu685U6WlpTZ16tTE9qGysvIHwxsXXnhhsJ//xhtvuO8pUS4UcuCusbHR+vfv774mohyNwQ2kEYMbUQxuAEBhOl3+n0GF3HuShq71WQL89ZB0h6QV8j83hdw9a3uiAEm7yv+16tVCSW2y30IAeaSvor/C7v3+k1T8swNQmIbJ//3Hux2z3kWsDoMbADJicIMoQ506dbLq6upgNyleeOGF7msiyoVOPvnkYOfqoYcecl/PqiX9zRu33HKL+5oz5f3NG+3btw86HDRo0CD3PSXyrlOnTrZ06dJg5+ruu+92XxNRjsbgBtKIwY0oBjcAoPAcJKlR/p9Bhdhnko4Xfz0f+WdDSXdLqpf/OSrULlvrswRI0+X/WvVqRID9A5A/Rsn/fSfJngmzbQDyzGT5v/949k72W4g1YHADQEYMbhBl6Nxzzw12c+LChQttvfXWc18TUS705ptvBjtbRx11lPt6vl/S37yRy8Mbnt+8cfnllwf72Xfeeaf7fhLlQtddd12wc1VbW2sdO3Z0XxNRDsbgBtKIwY0oBjcAoLDsLP5yvkdVki6WtN7anyIgp/1I0gRJK+V/rgqxY9f+FKHAnST/16lXbwfYPwD5oYOkavm/7yTdgBCbByBvDJT/+453/PNPvBjcAJARgxtE36uoqMjmzJkT7ObEq6++2n1NRLnQT37yk2Dnysxs6dKlNnjwYPd1fT++eSPK85s3SktLraamJsjPXbZsmZWUlLjvJ5F35eXltmLFpECdTAAAIABJREFUiiDnyszsnHPOcV8TUQ7G4AbSiMGNKAY3AKBw9JX0tfw/ewqpOkmjFf37LiBN+kn6o6QG+Z+zQmqlpKFNeH5QuNooGhb0fq16NTj7LQSQB86V//uNR+NCbB6AvHGv/N93PJsvqWXWu4g1YXADQEYMbhB9r3322SfYTYkrVqywrl27uq+JKBcaM2ZMsLP1LYY3IgxvRFYd3rjhhhuC/dyTTjrJfS+JcqHbb7892LmaOXOm+3qIcjAGN5BGDG5EMbgBAIWhvaRK+X/uFFJ/lfTjpjw5QB7bVNFrvVH+Z65QWi5pq6Y8OShYN8j/derVAwH2D0BuK5Y0V/7vNx7VSirLfgsB5IEyRWfe+33Hs8uy3kWsDYMbADJicIPoe02cODHYTYnjx493Xw9RLtSmTRurrq4OdrZWxfBGhOGNyLfDGyG/HeDNN99030eiXKhv377W2NgY5FyZme21117uayLKsRjcQBoxuBHF4AYApF+RpKfk/5lTKL0uadsmPTNAemwvaar8z1+h9KWk3k16ZlCIeqtwvw2nXtzUDKTdYfJ/r/Hs4uy3EEAe+I383288Y1AtGQxuAMiIwQ2iVerdu7c1NDQEuyGxf//+7msiyoWOO+64YOcqE4Y3IgxvRL4d3hg3blywnzlo0CD3fSTKhUIOuD766KPu6yHKsRjcQBoxuBHF4AYApN8V8v+8KYSWSDqxic8JkEbFkv5HUpX8z2MhNF3RtykBmTwm/9eoV5cE2D8AuesV+b/PePYfSS2z3kUAuayQv1no2/6Q9S6iKRjcAJARgxtEq3TNNdcEuxlx0qRJ7ushypVeffXVYGdrdRjeiDC8EZk1a5YNHjw42M8bO3as+x4S5UJDhgwJdq4aGhqse/fu7msiyqEY3EAaMbgRxeAGAKTbIfL/rCmE/in++j3wre6SHpL/uSyEJim6sQv4vj3k//r0ar44F0BabSH/95hc6JhsNxJATjtc/u8z3m2Z9S6iKRjcAJARgxtEqzR//vxgNyPutdde7ushyoU23XTTYOdqbRjeiDC8EZk1a5a98MILQX7WsmXLrKSkxH0PiXKhd955J8i5MjO79NJL3ddDlEMxuIE0YnAjisENAEivzSTVyP+zJs3VSDpLUlETnxOgkOwiqVL+5zTt3dDUJwQFZ6b8X59eDQuwfwByD4OhUe9mu5EActpk+b/PeDY5+y1EEzG4ASAjBjeIvmnfffcNdhNiRUWF+3qIcqVbbrkl2NlqiiVLltgOO+zgvu7vV15ebtOnT09sH26++Wb3NWeqtLQ06E3fSTrxxBPd948oF/rlL38Z7FzNmjXLfT1EORSDG0gjBjeiGNwAgHQqkzRH/p8zae4tSf2a+oQABaqlpAslVcv/zKa5Y5v6hKCgnCr/16ZXLwXYPwC5paukevm/v+RKO2e3nQBy1ED5v794d1jWu4imYnADQEYMbhB908MPPxzsJsRTTz3VfT1EuVCbNm2sqqoq2NlqKr55I8I3b4T15ptvuu8dUS7UsmXLoN9SlovDdkROMbiBNGJwI4rBDQBInxaSXpH/Z0xaq5N0iaTipj4hANRb0qPyP79prU7STk1+NlAo2kmqkv/r06tNs99CADnk9/J/X8mlHsluOwHkqHvl//7i2Vzx37UkicENABkxuEEkWUlJiS1fvjzIzYfV1dXWrl079zUR5ULDhw8Pcq7WBcMbEYY3who0aJD73hHlQpdddlmwc3X77be7r4coR2JwA2nE4EYUgxsAkD6j5P/5ktamSfpJ058KAN+zj6SP5X+W09giST9q+lOBAnGL/F+bXo0NsH8AckM7SUvk/76SSzVI6pXNpgLIOWWSauX//uLZeVnvIpqDwQ3kFaa6ACTqyCOP1HrrrRfkZ913332qqakJ8rOAfHfCCSe4PXb79u31/PPPa/DgwW7XkMlXX32lXXbZRZWVlYk83siRI3XLLbck8ljNsXjxYv3sZz/T9OnTvS+lWX71q195XwKQE+6++26ZWZCfNXz4cLVq1SrIzwIAAACABBwq6Uzvi0ihBkV/5XcrSfn1XxgBueUZSQMkXSlphfO1pE2ppEmSOnpfCHLK7YpuUCpEvxTnAUiLEZI6eF9EjimWdLb3RQAI6teS2nhfhKMaSeO8LwIAwDduEJkke/nll4P91ehNN93UfT1EuVBpaak1NjYGO1vrim/eiPDNG2F88cUX7ntGlCs9/fTTwc7WwQcf7L4eohyIb9xAGvGNG1F84wYApEcv8Zdo4+gjRb83AAjrJ5Iq5X/G09aL4g9R4ruelP/r0quzAuwfAF9FkmbJ//0kF1ui6NtIAOS/Yklz5f++4tmYrHcRzcU3biCv8F90AEjMBhtsoF122SXIz3rttddUUVER5GcB+e6oo45SUVGR92XwzRvfyPVv3nj33Xe9L6VJunfvrh133NH7MoCccM899wT7Wb/4xS+C/SwAAAAAiElLSX8Tf4k2tFslDZL0b+8LAVJouqQtJY31vpCU2U3Sdd4XgZwy2vsCHP2Popu+AeSv/ST19b6IHNVB0gneFwEgiMMU/TGOQmWSbvS+CAC5jcENAIkZMWJEsJvLx47lv/sGvnXEEUd4X8J/MbwRyeXhjV133TVvhjdy6bUNeHr88ce1YMGCID/roIMOUocO3PsEAAAAIKddKWl774tIkWpJQyWdLanW+VqANKuVdJqkQyVVOV9LmpwnaU/vi0DOeFbRX6svRD+WtLf3RQDIytneF5DjRooBNSANzvS+AGfPSprtfREAgEhn+X89DpFr7733noWwaNEi97UQ5Url5eVBzlVoS5cutcGDB7vvT6b9mjFjRmL7cMstt7ivOVMdO3a0d955J7F9WFdffPGF+14R5Uo33PD/2Lv3MK3qeu/j7wEERWAQD1CikKYCppKoqDkcPZbazrNZu3ZaWqGOlm2snq56SuOxrXjMyuKpTLNMzc4mJ49lOwSpLXnCAyYIinIQQXDm+eNuHhxFYOb+3eu77rXer+ta17626Xd9uJ17Zpz5fdb3W8neWx/72MfC/zxeXsHXa0jFM4L491Yerm2qfSElSeEOAVqI/5pSlOspYI8O/RuQlMJOwJ+I/xxQlGsJMKBD/wZUZGcT/zEZdf06wesnKcYQ4j+H1MN1bGdfYEm5MJT4zyPR11FVv4rqjHnE/7vP+noxySunEG7ckJSJYcOGsddeeyWZ9bOf/SzJHKkIjjvuuOgIG+TmjYq8bt5Yvnx5XWzeGDBgAAcffHB0DCkXrrvuumSzTj311GSzJEmSJCmh7YCb8SmrqUwHhgOPRAeRSmgBlSLa16mU0VSd7YCf4dcHVfwAWBUdIsgHqBTDJNWfL0QHqBNuJZHq2+ejAwSbD/whOoSk/LO4ISkTp512WrJZP/nJT5LNkurdiSeeGB3hbVneqLC8UZ2TTjopOoKUC48++ij3339/kllHHHEE2223XZJZkiRJkpTQTfhE9VQuBw4DXo4OIpXY68BXgNHAwuAsRTAK+M/oEMqFVcCU6BBBGoBzokNI6rAdgA9Hh6gTY6hsJ5FUf/oB6Q4H1qfLqGxCkCTlxLbEr8fx8gq7FixY0JrCggULwv8sXl55ubbZZpvWdevWJXlv1dKKFStaR44cGf56vfnafvvtW+fNm5fZ6zB58uTwP/OGrj59+rTOnj07s9ehoxYuXNja0NAQ/jp5eeXh+uxnP5vsvfXpT386/M/j5RV4vYZUPCOIf2/l4dqm2hdSkhTmfOK/jhThWgOc3MHXXlLtbQP8hvjPEfV+rQXy9aQoRdmVyjab6I/JiGsZ0KP6l1BShr5K/OeOerr+b+deZknBLiT+80fktRzoWfWrqM6aR/zHQNbXi0leOYVw44akmhs5ciQDBw5MMutHP/pRkjlSEZx44ol07do1OsYmuXmjws0bnTNgwAAOOuig6BhSLtx44428/vrrSWadeuqpSeZIkiRJUgLDgW9GhyiAhcDBwM+ig0h6i5eAo6k8KX9NcJZ61g24GegdHUThngDujA4RpA8+zVqqJz2As6ND1JlTqWwpkVQ/ugDnRocIdh2VzXCStEkWNyTV3CmnnJJs1k9+8pNks6R6d8IJJ0RH2GyWNyosb3TOSSedFB1ByoWXXnqJP/7xj0lmNTU18Y53vCPJLEmSJEmqQk/gNqB7dJA6NwvY51//V1J+XQWMBl6IDlLHdsIncaviyugAgT4XHUDSZjsN6Bcdos70AD4THUJShxwP9I8OEagFyN9BIEkS2xK/HsfLK+R68sknW1OYNWtW+J/Fyysv1zbbbNO6bt26qt9Xy5cvb/34xz+e4B26eVasWNE6cuTI8Nfvzdf222/fOm/evMxeh8mTJ4f/mTd09enTp3X27NmZvQ6ba+HCha0NDQ3hr4+XVx6uj3zkI8neW2eeeWb4n8fLK+h6Dal4RhD/3srDtU21L6QkKXM/Jf7rR71fN2HxRao3OwOPEP/5o56v0zv8qqtoGoBniP9YjLoOrv4llJSBecR/vqjH60UqBQ5J9eFu4j9vRF63Vf8Sqkpl/Hr7YpJXTiHcuCGppoYOHcrgwYOTzHLbhrTe8ccfT9euXauec9ttt/HDH/6Qj3/84wlSbVqvXr248847c7l5Y/To0Zlu3rj00kszuVdHLF++nLFjxzJ79uzoKO0MGDCAAw88MDqGlAu33HILr776apJZRx99dJI5kiRJktRJHwXSrWsun9eB86m8hpaTpfryDHAAcG90kDp2NbB7dAiFaqXcTzaeEB1A0iYdCgyJDlGn+gEfjg4habMMBZqiQwS7IjqApPpicUNSTR1zzDHJZt18883JZkn17t/+7d+SzLnlllsA+NGPfsRHPvIRWlpakszdmN69ezN16tTclTcWL17MqFGjMitvnH/++UyenL/fKbz88suMGTOGOXPmREdp5wMf+EB0BCkXXn31VW6//fYksw4//HC6d/ehrJIkSZJCDAa+Ex2ijr0MHE65D6xK9W4ZMI7K1hx13JbALbhxqOx+AKyKDhHkRKB/dAhJG3VedIA694XoAJI2ywXRAYLNA2ZGh5Akbdi2xK/H8fLK/LrvvvtaU/jrX/8a/mfx8srL1bVr19bVq1dX/b5avnx56xZbbNFu9mmnndba0tKS4F27aStWrGgdOXJk+Ov55mv77bdvnTdvXiavQWtra+vkyZPD/8wbuvr06dM6e/bszF6HTXnggQfCXxMvr7xcH/zgB5O9t97//veH/3m8vAIun0asIhpB/HsrD9c21b6QkqTMzCb+60a9Xo8A7+r4Sy4px75K/OeWer2u6sTrrWK5lviPw6jrKwleP0m1sQvQQvzniXq/xnX0hZeUqX7AauI/V0Re/1H1q6gU5hH/sZD19WKSV04qOIsbXqW7tt1222QHwL/4xS+G/3m8vPJyjRkzJsn76oYbbtjg/E984hOWNyxvtEK+yhstLS2tffv2DX9NvLzycPXs2bN1zZo1Sd5b3/nOd8L/PF5eAZfFDRWRxY3KZXFDkurDZcR/zajX60Ggb8dfckl14BQq/70a/XmmHi/XNZfbMOI/BqOuRUC36l9CSTVQ5lJZyutXHX3hJWXqQuI/T0ReLwI9qn4VlYLFDdWVLtEBJBXX0UcfTUNDQ5JZt956a5I5UhEcfvjhSeb84he/2OBfnzJlCmeccQatra1J7rMxvXr1YurUqYwcObLm9+qIJUuWMGrUKP7xj39kcr/m5mYmT56cyb06Yvny5YwePZo5c+ZER6GhoYHx48dHx5ByYdWqVUydOjXJrGOOOSbJHEmSJEnaTOOB86JD1KkZQBPwcnQQSTVxE5WnSi+LDlKHrgcGRIdQmIeB6dEhgvQHjosOIekt+uET2FM5msr2Ekn50wU4NzpEsG8Da6JDSKo/Fjck1cxRRx2VZM4jjzyS2eFpqR4cdthhVc9YtWoVt91229v+723ljSz06tWLadOm5ba8MW/evEzu19zczKWXXprJvTqirbwxa9as6Cgceuih0RGk3PjVr9I8ZOid73wne+21V5JZkiRJkrQJvagcrlXH/QE4EnglOoikmroXOAB4JjpIndkG+Hl0CIW6MjpAoAnRASS9xZn4BPZUGrD4L+XV8VRKpGW1Drg6OoQkaeO2JX49jpdXptdLL73UmsJFF10U/mfx8srL1djY2NrS0lL1++r222/frPt94hOfSHK/zbFixYrWkSNHhr/Gb76233771nnz5mXyGrS2trZOnjw5/M+8oatPnz6ts2fPzux12JAnnngi/HXw8srL9c53vjPZe6u5uTn8z+PllfH1GlLxjCD+vZWHa5tqX0hJUk19m/ivFfV4/Qno3onXW1L92g54ivjPP/V2lf2Jv2XWhUrhKfpjMOoaVv1LKCmRbsDzxH9eKNL1CtC7I/8SJGXiHuI/P0ReN1T/EiqhecR/TGR9vZjklVMIN25Iqom9996bvn37Jpl16623JpkjFcFRRx1FQ0ND1XN++9vfbtbf17Z5o7W1tep7bkqvXr2YOnVqbjdvZLX5p7m5mcmTJ2dyr45o27wxZ86csAy77LILO++8c9j9pTx57rnn+Otf/5pk1rhx45LMkSRJkqSNGAGcFR2iDs0CDsPysVQ2LwDvA+ZHB6kzXwcGRIdQiBbgqugQgZqjA0j6/04GdogOUTA9gU9Fh5DUzlDgkOgQwb4VHUBS/bK4IakmUh0AXLJkCbNmzUoySyqCww47LMmc3/zmN5v991resLzRJg/ljaOOOirs3lLe/PrXv04yZ+zYsXTp4n8aSpIkSaqZrsAPgeqfRlIuc4HxwMroIJJC/BM4GMsbHdEbuCI6hMJ8F1gTHSLIvwN9okNIAuCC6AAF1YxnHKU8Kfvnuj8DcYdmJNU9v6mRVBOpiht33HFHkjlSURxzzDFVz3jooYd47rnnOvTPWN6wvNEmuryRqrwkFcGvfvWrJHN69erFiBEjksySJEmSpA34HPCe6BB1Zh4wFlgWHURSqOeplDceiQ5SR06i8vlT5bMcuD46RJAewBnRISTRBOwTHaKgBgLHRYeQBEA/4MPRIYJZFpdUFYsbkpJraGhIVtz44x//mGSOVARDhw5l++23r3rOb3/72079c5Y3LG+0iSxvjB8/noYGH9ApAcyZM4elS5cmmZXqezdJkiRJepOBwFejQ9SZx4DRQJr/4JNU754HDsHyRkd8n8pBdpVP/n6hkp1m3G4mRTsvOkDB+fpK+XAW5f5e+3ngF9EhJNU3ixuSkjvggAPYeuutk8z6wx/+kGSOVASHH354kjmdLW6A5Q2wvNEmqrzRt29f9t9//0zvKeXZnXfemWSOxQ1JkiRJNfJ9YKvoEHVkAZXSxpLoIJJy5QUq5Y3/iQ5SJ3YBLowOoRAPA3dHhwiyE3BUdAipxAYCH4wOUXAH40YTKVoX4JzoEMGuBNZFh5BU3yxuSEpuzJgxSebMnTuXJUv8/ZTU5rDDDqt6xsqVK7n//vurmjFlyhQ++clPVp1lc/Tq1Ys777wzl+WN0aNHZ1re+Na3vpXJvTpi+fLljBkzhgcffDDT+44fPz7T+0l5lqq48b73vS/JHEmSJEl6g5OAI6JD1JGFVEobC6ODSMqlF4AmLG9srolUChwqn6uiAwSaEB1AKrHP4xm8LHwhOoBUcscD/aNDBFoDfCc6hKT65zeNkpI7+OCDk8yZOnVqkjlSUTQ1NVU94+670zxo6Ac/+AGnn356Jps3evfuncvNG4sXL85088bnP//5XG7eWLZsGWPHjuW///u/M7vnIYccktm9pLybNm1akjlbb701++67b5JZkiRJkgT0Aq6IDlFHllApbTwZHURSrr1EpbyR7Rrk+tSDytYnlc+twPPRIYIcCewaHUIqod5ANk891EnADtEhpBIr+7aNnwBLo0NIqn8WNyQll+qJzameIC0Vwe67706fPn2qnnPXXXclSFMxZcoUzjjjjEzKG7169WLq1Km5O1S8ZMmSTMsbzc3NuSxvLF++nHHjxmVW3nAzgLTeU089xfz585PMSlW+lSRJkiTgEmBAdIg6sQY4HHgsOoikuvASMA54PDpIHRgLnBIdQplrobzl0Qbgs9EhpBL6JNAzOkRJdAOao0NIJTUcKPsTNi+NDiCpGCxuSEpqt912Y9ttt00yK9VmAKkI9t9//yRzUhY3IPvyxvTp0y1v5LS8sXLlyszKG42NjbzrXe+q+X2kepFqS5nFDUmSJEmJjADOig5RRz6KT8+X1DEvAYcCL0QHqQOTqTwJXeXyXSrFyDI6HQ+QS1nqApwXHaJkzqSyWUtSts6NDhBsBjAvOoSkYrC4ISmpVE9B//Of/8yqVauSzJKKYL/99qt6xsqVK2tyqD7L8kZjY6PlDSxvABxwwAE1v4dUL1JtKTvwwAOTzJEkSZJUal2BH1J54rM27VvAzdEhJNWlp4EjgFejg+TcAOCi6BDK3FLgp9EhgvQBPhIdQiqR44CB0SFKph/w8egQUsn0A06NDhGsrBvdJNWAxQ1JSaV6UvN9992XZI5UFCk2btx33320tLQkSPNWljfWlzcefzybDfVlL29Y3JDWmzlzZpI573rXu9huu+2SzJIkSZJUWucD74kOUSdmABOjQ0iqaw8CJwCvRwfJuQnAXtEhlLkrowMEKvsTsaUsuW0jRnN0AKlkzqLcm26eBX4VHUJScVjckJRUqo0bFjek9bp06ZKkpJDqYO/bmTJlCmeeeWZN79GmrbwxYsSITO63uZYsWUJTUxOPPfZYJvdrbm7mkksuyeReHbFy5UrGjx/PX/7yl5rdI8UWGqkoXnjhBRYsWJBk1ujRo5PMkSRJklRKA4GvRYeoE08C/wbU5ikrksrkd8Dp0SFyrgGYgtugymY2cH90iCDDgFHRIaQS2AdI82RTddQQ4MjoEFJJdAHOiQ4R7DKg9k+xlVQaFjckJdO7d2+GDRuWZNY999yTZI5UBMOGDWOrrbaqes6f//znBGk27rrrruP000/PbPPGtGnTcrd5Y9GiRZlu3rjgggtyuXljxYoVjB8/vmabN/bff3+6dPFbWanNn/70pyRz3GYjSZIkqQrfB6r/IVbxraRyyGh5dBBJhfEj4OLoEDm3H5UnBatcrooOEGhCdACpBNyeF8utG1I2TgD6R4cItIrKz7skKRlPu0lKJtXh6ccff5wXXnghySypCFIdon3ggQeSzNmUKVOmcMYZZ2RW3pg+fXouyxtNTU2ZlTeam5tzWd5YuXIl48aNq0l5Y6uttmKvvdxuL7VJ9Tk+b5uMJEmSJNWNE4EjokPUgVYqhx4ejQ4iqXC+BPwsOkTO/R9gu+gQytQvgOejQwQ5nnIfspRqbSCV7+sV5wgqmzck1VbZt21MAVZEh5BULBY3JCXz3ve+N8mce++9N8kcqSj222+/qmc88sgjvPrqqwnSbB7LG5Y32tSyvOFmAGm9VFuVLG5IkiRJ6oRewJXRIerEF4E7okNIKqyPAndHh8ix3kD+foiuWloHXBMdIkgX4LPRIaQCOxvoFh1CnBcdQCq44cD7okMEasX/fpBUAxY3JCWT6tD0fffdl2SOVBT7779/1TMi3leWNyxvtKlVecPihrTef//3f7N27dqq5/Tt25edd945QSJJkiRJJfJlYEB0iDpwMzApOoSkQlsLHAP8IzpIjn0ESPMkOtWLa6gUOMroU3iwXKqFnsCno0MIgI8B/aJDSAV2bnSAYL8D5keHkFQ8FjckJZPqwHQtnsou1astttiCffbZp+o5f/nLXxKk6TjLG5Y32tSivGFxQ1pv7dq1zJkzJ8msVFvUJEmSJJVCf/xF/uaYQ+VJ+JJUa8uBo4AV0UFy7OvRAZSppcBN0SGC9AdOjA4hFdB/UNnipHg9gDOjQ0gF1Q84NTpEsCuiA0gqJosbkpLYYostGDp0aNVzWlpa+Nvf/pYgkVQM++yzD1tssUXVc1Id5u2MKVOmcNZZZ2Vyr7byxogRIzK53+ZqK2889thjmdyvubmZSy65JJN7dURbeeOBBx5IMm/vvfdmyy23TDJLKoJU763hw4cnmSNJkiSpFL4C+B/nG/cKcCywJjqIpNJ4isoTqLVhH8CtG2VzWXSAQBOiA0gF0wCcHx1C7TTjdiGpFj5NpRxVVvOAO6NDSComixuSkth3333p0qX6Tylz586lpaUlQSKpGFIdnp07d26SOZ31ve99j0996lOZ3KuxsZFp06ax3377ZXK/zbVo0SJGjRrFI488ksn9LrjggtyWNw499FBmzZqVZN4ee+yRZI5UBKnKr3nbXCRJkiQptwbi0003x/nAgugQkkrnNuDq6BA5dlF0AGVqNhCzmj7ewcCw6BBSgRwN7BIdQu3sAJwUHUIqmC7A2dEhgrltQ1LNWNyQlMTee++dZE7kVgApj3bfffeqZzz88MO8+uqrCdJU57rrruP000+ntbW15vdqbGxk6tSpuTt8vGjRIsaMGcPjjz+eyf0uuOACJk+enMm9OmLlypXceOONSWZZ3JDWe+ihh5LMSfV9nSRJkqTCuwjoGh0i5/4IfC86hKTS+hzgL9427CjgwOgQytRV0QECfS46gFQg50UH0AZ9ITqAVDAnAP2jQwRaAVwfHUJScVnckJTEnnvumWRO9FYAKW9SHErPUyFqypQpnHHGGZmVN6ZPn57L8kZTU1Nm5Y3m5uZcljcefvjhJHN22223JHOkIvj73/+eZM7gwYPp0aPMm28lSZIkbYY9gI9Eh8i5l/A1khTrNeBDVA4e6a2+Fh1AmboJWBodIshpQJ/oEFIBDAHGRofQBu0DvC86hFQg50QHCHYtsCo6hKTisrghKYmhQ4cmmZOnA+ZSHqTYuDF79uwESdKxvGF5A2DevHlJ5qR4j0hF8corryT7vDJs2LAkcyRJkiQV1sX4O6ZN+RiwJDqEpNJ7isrnI73V4bh1o0zWAVdHhwijjDBbAAAgAElEQVTSAzgzOoRUABOjA2ijmqMDSAUxnHIXoVoo96Y2SRnwh+qSkhgyZEiSOQ899FCSOVJRpHhvPfroowmSpNVW3siC5Y2KvJU3nn76adasWVP1HDduSO2l+l4qVSlXkiRJUiHtBRwXHSLnbgB+HR1Ckv7lNuB70SFy6hvRAZSpb1MpcJTR2UBDdAipju1AZXuN8us4YGB0CKkAyl6CuhV4NjqEpGKzuCGpaltvvTU777xz1XMWLFjA0qVl3VArvdUuu+ySZM6VV17JwIH5+xnFlClT+MxnPpPJvRobG5kxYwb7779/JvfbXG3ljazKNc3NzXzzm9/M5F6b429/+1vVMyxuSO3NnTs3yRyLG5IkSZI24tLoADm3EMjmh16StPnOBf4nOkQOjcetG2XyPPCL6BBBdgKOjg4h1bEJQLfoENqoLnjgXKpWP+CU6BDBrogOIKn4LG5Iqlqqg32PPPJIkjlSUey+++5J5gwaNIh77703l+WNa6+9NrPyRp8+fbjzzjtzuXlj9OjRmW3emDhxYm7KGw8//HDVM7bbbjv69OmTII1UDHPmzEkyZ4899kgyR5IkSVLhHAIcFh0i504FlkeHkKQ3WQ2cTHm3DWzMxdEBlKmrogMEmhAdQKpTPYDPRofQZvkU0DM6hFTHPk3lc15ZzQHujQ4hqfgsbkiqWqriRlZPnJfqRariBlTKG/fcc0/pyxuNjY1Mnz49l+WNpqam0pU35s2bl2TOkCFDksyRiuCxxx5LMmfYsGFJ5kiSJEkqnMnRAXLuauCu6BCS9Db+B7gkOkQOjQXGRIdQZu4HZkeHCHIYsGt0CKkOfYTKU+iVf72B06NDSHWqG3B2dIhg/sxLUiYsbkiqWqrD5RY3pPbe/e53J503ePBgyxtY3miTh/JGio0bkLbkJNW7VIWoPffcM8kcSZIkSYVyNLBfdIgcmw9cEB1Ckjbha0CaJ38US/yTjpSlK6MDBGkAzokOIdWhz0cHUIc0U/l8J6ljjgf6R4cI9DxwY3QISeVgcUNS1QYPHpxkTlaHlaV6UYstApY3KtrKGyNGjMjkfpurrbyR6on5mzJx4kQuvjhuC3yq4sauu/qAKOmNnn766SRzBgwYkGSOJEmSpMKI+yFCffgosDo6hCRtwmtUPl+pvQOBcdEhlJmfAkujQwT5ONAzOoRURw4D0v/SXrW0C3BMdAipDpW93PkdYF10CEnlYHFDUtUGDRqUZE5WB5WlelGrLQKWNyoaGxuZNm1aLjdvjBo1KrMy24UXXhi2eeOpp56itbW16jm1KDlJ9SzV54+dd945yRxJkiRJhXAKsFd0iBz7KXB/dAhJ2kwPUDmYpPYuig6gzKwBvhsdIkgf4GPRIaQ6cl50AHVKc3QAqc4MBw6ODhFoHXBtdAhJ5WFxQ1LVUhQ3Xn/9dZ544okEaaRi6NGjR7JS1IZY3qho27yRx/JGU1NTZuWNiRMnhpQ31q1bx6JFi6qes9tuuyVIIxVHqs8dtfw6JEmSJKmudMVtGxvzKnB+dAhJ6qALgOejQ+TMgVSerK5yuAJoiQ4RZEJ0AKlODAGOjA6hThmLm1Kkjih72emn+N9GkjJkcUNS1VI8jfnJJ5/k9ddfT5BGKoZddtml5vcYPHgwM2fOZMCAATW/V0dFlDf222+/TO63udrKG48++mgm95s4cSIXX5z9GYxnnnmm6hkeLpfaS7XFzI0bkiRJkv7lE8C7okPk2FeB6p9MIUnZWgmcER0ih/53dABl5nng1ugQQYZROdQsaeOagYboEOq0/4wOINWJflS2rJbZZdEBJJWLxQ1JVUl1oM9tG1J773jHOzK5z6677so999xjeaOxkalTp+Zy88bo0aMz27xx4YUXZr55Y8GCBVXP2G677ejevXuCNFIxpPqcYXFDkiRJErAF8PXoEDk2H5gcHUKSOuk3wM3RIXLmQOCI6BDKzFXRAQK5dUPauH7Ax6NDqCqnUvn3KGnjPgP0iA4R6D5gTnQISeVicUNSVQYPHpxkzj//+c8kc6Si6N+/f2b3eve73215g/WbN/JY3mhqasqsvDFx4sRMyxspihsA22+/fZI5UhHMnz8/yRyLG5IkSZKoHOrL7gdV9ecMYG10CEmqwnnA6ugQOXNBdABl5m7g4egQQf4Nv8eTNuYsyn2QuQh6AGdHh5ByrhuWOa+IDiCpfCxuSKrKTjvtlGSOxQ2pvR122CHT+1neqLC8UZFleeOZZ55JMifLspOUdwsXLkwyx+KGJEmSVHrdgP+MDpFjtwIzokNIUpX+CVwSHSJnxgPvjg6hzJR1c1YX4JzoEFJOdQPOjQ6hJM7BAo60McdT7iLns8At0SEklY/FDUlVSXXIO9UBQ6koIg6hW96osLxRkVV5I9XGDYsb0novvvgia9dW/8BX31eSJElS6ZX9F/gbswZojg4hSYlcAiyODpEzZ0UHUGauB5ZHhwhyFpUD6pLaOwXI9imLqpV+wKnRIaQcK3uJ8yqgJTqEpPKxuCGpKqkO9D333HNJ5khFEXVY1vJGheWNiizKG6mKG1lvqZHyrLW1lUWLFlU9Z/vtt0+QRpIkSVIdOzs6QI59A0jzQw1JivcKMDE6RM58Ep/QXRZrgO9GhwjigWZpwz4fHUBJuUVS2rDhwMHRIQKtAa6NDiGpnCxuSKpKqoOyFjek9iKfcm55o8LyRkWtyxvPPPNMkjluBpDaS/G9Vffu3enbt2+CNJIkSZLq0FDgfdEhcmoB8K3oEJKU2I+Av0eHyJE+wEnRIZSZMj9teUJ0AClnRgH7RIdQUkOAsdEhpBw6LzpAsB8CK6JDSConixuSquLGDak2orcHWN6osLxRUcvyxuLFi5PMsbghtbdw4cIkc6K/HkmSJEkKc0F0gBz7DJUnM0pSkbQA50SHyJmzogMoMwuAX0WHCHIA8N7oEFKOlP0gc1E1RweQcqYfcHJ0iGBXRAeQVF4WNyRVJcVhvtbWVosb0pvk4RB6W3lj++23j47yFpY3ilPeaGlp4eWXX656Th7eM1KeWNyQJEmSVIV+wIejQ+TU74HfRIeQpBqZAfw6OkSOHAzsGR1CmbkqOkAgDzRLFbsAH4wOoZo4hsq/X0kVnwF6RIcIdCcwLzqEpPKyuCGpKikOyj7//PO0trYmSCMVx8477xwdAaiUN+6++27LG5Y3gNqVN5YuXVr1DA+XS+1Z3JAkSZJUhU9S7l/gv50WYEJ0CEmqsc8Dr0eHyJFsfgmhPJgOPBwdIsjJVIq7UtmdCzREh1BNNGBJTWrTDX+24bYNSaEsbkiqyo477lj1jJdeeilBEqk4evfuHR2hnSFDhljewPJGm1qUN1J8HXDjhtTe4sWLk8yxuCFJkiSVThf8Bf7buQmYHx1CkmrsUeDb0SFy5ONAz+gQykxZt270AD4VHUIK1hs4IzqEaup0Kv+epbI7ASjz4Yr5wO+iQ0gqN4sbkjqtZ880P6dctmxZkjlSUQwYMCA6wltY3qiwvFGRuryRYuOGxQ2pveXLlyeZ07dv3yRzJEmSJNWNDwIDo0PkUAvwv6JDSFJG/jfwanSInOgJnBYdQpn5MZDmB6v15zN4fkjl9iks6hVdTyypSQBnRwcIdjnQGh1CUrn5H16SOq1Pnz5J5rz88stJ5khFkdcD6EOGDOGuu+7KbXnj7LOz+e/LtvLGiBEjMrnf5lq0aBGjRo3KtLxx0UUXJZn14osvVj0jr+8bKUqqYmyvXr2SzJEkSZJUN9y2sWE34LYNSeXxAvDd6BA5cm50AGVmFfCD6BBBdgKOjQ4hBekCNEeHUCaa8aykym04cHB0iEArKO/3epJyxG9GJHVa795ptgha3JDaa2xsjI7wtoYOHZrbzRtXX311pps3pk2blrvNGwsXLsx088YXv/jFJJs3XnrppQRpYOutt04yRyqCVMWNVN/vSZIkSaoLQ4Fx0SFyqAX4anQIScrYJcBr0SFyYk9g/+gQysxkyvsUZgu8KqvjcetgWQwEjosOIQU6LzpAsB9QKepKUiiLG5I6zeKGVBvdu3ePjrBRQ4YMyW1549prr820vDF9+vTclTcWLVqUaXlj4sSJVZc3UhU3evZ0g7HUZvny5UnmWNyQJEmSSuWc6AA5dT1u25BUPguB70eHyJFPRwdQZhYAv40OEWQ8sGt0CClA2Q8yl43bVVRW/YAPR4cI1ApcGh1CksDihqQq9OnTJ8kcixtSez169IiOsElt5Y1+/fpFR3kLyxv1V95YunRpkhxbbbVVkjlSEbhxQ5IkSVIH9Qb+PTpEDr0O/K/oEJIU5BvAuugQOfFhIM0vRlUProoOEMgD7CqbkcBB0SGUqfcB+0SHkAJ8FugWHSLQr4Fno0NIEljckFQFN25ItVEPxQ2olDdmzJiR2/LGhAnZbHRuK2/st99+mdxvcy1atIhRo0ZlWt64+OKLO/XPpjpgbnFDWs/ihiRJkqQOOh1wleVb/YjKk7clqYwWAj+MDpETPYCPR4dQZu4EnogOEeQ/8HtClYtlpXL6QnQAKWPdqBQ3yuyK6ACS1MbihqRO69WrV5I5qQ4WSkXRvXv3qmesXr06QZJN23vvvZk5c2YuyxvXXHNNpps3pk6dmrvNGwsXLsx088aFF17Yqc0ba9asSXL/nj39XYLUJtX3V6m+35MkSZKUaw3A2dEhcuh14KvRISQp2DeAlugQOeHXyvJoBS6PDhGkJ/CJ6BBSRgYCJ0aHUIiTgB2iQ0gZOgHoHx0i0DxgenQISWpjcUNSp6V6snlDQ0OSOVJRpNi4cfXVV3PbbbclSLNpe+21V27LG9dee22m5Y3p06fnrryxaNGiTMsbEydO7HB547XXXktyb4sbUnvLly+veobFDUmSJKkUjgJ2iQ6RQ1Nw24YkPQ3cEB0iJ94NjIoOocxMAVZFhwjSHB1Aysg5eG6urLoB50aHkDJ0TnSAYJdFB5CkN/IbUEmdtm7duiRzunbtmmSOVBQpNm688sornHTSSfzhD39IkGjTLG9UWN6o6Gh5I1VxI1WhUCqKV155peoZvXv3TpBEkiRJUs75BPG3eh34enQIScqJr+PWjTYfjQ6gzKwCfhAdIsiuwKHRIaQa6wmcFR1Coc4Cqn+ippR/w4GDokMEWgpcHx1Ckt7I4oakTlu7dm2SOV26+KlIeqMtt9yy6hmvvfYa69at44Mf/KDlDSrljfPOOy+Te1neqOhIeWPNmjVJ7unGDam9lStXVj1j6623TpBEkiRJUo71B46IDpFD1+G2DUlq8xhwc3SInPgQ0BAdQpm5AmiNDhFkQnQAqcY+AfjkqnLrB3wsOoSUgWwOyuTXd4E0B1IkKRFPS0vqtFRPSLe4IbW3xRZbVD1j9erVQOV9etRRR/G73/2u6pmbY6+99mLatGm5LG9cfvnlmZc39ttvv0zut7kWLVrEqFGjMi1vfOMb39jk35equOHGDam9FStWVD2jV69eCZJIkiRJyrFT8QDqm70GfC06hCTlzLeiA+TEtsDo6BDKzBPAHdEhghwD7BQdQqqRBjzIrAo/DlR0/YAPR4cItI5KEVeScsXT0pI6bd26dUnmdO3aNckcqShSbNx4/fXX2/3/H/rQh5g+fXrVczfH8OHDmTlzJo2NjZncryOyLm9MnTo1d5s3Fi5cmOnmjS996Uub3LyRqgjoxg2pPTduSJIkSdoMJ0cHyKEbgEXRISQpZ2YBD0SHyInjogMoU1dFBwjSBfhMdAipRo4BdokOkQOzgOp/kVTfhgCHR4eQauizQLfoEIFuAZ6PDiFJb2ZxQ1KnuXFDqo3u3btXPePNxarXXnuND3zgA5mVN/baay+mT59ueeNfmzfyVt5YtGhRpuWNiRMnbrS8YXFDqo0UGzfA8oYkSZJUYDsBB0aHyCGfKi9JG3ZNdICcOCE6gDL1eyqbN8roU0CP6BBSDbhloeJi4PvRIXLAjwcVVTcqxY0yuzw6gCRtiKelJXWaGzek2kixcaOlpeUtf2316tWZljf23XdfyxtY3mizsfLGmjVrktxjq622SjJHKooUGzfA4oYkSZJUYKdGB8ihe4B50SEkKad+CrwYHSIH3gGMjA6hzLQCV0eHCNIPv19U8ewDjIkOkQNPAr8ELgXeerCgXI6gsnlDKpoTgf7RIQLNAf4cHUKSNsTihqROW7t2bZI53bqVeSub9FYp3hOtra0b/Ott5Y2pU6dWfY/Nse+++zJt2jT69u2byf06IuvyxowZM3Jb3njiiWweFjVx4kS+/vWvv+WvpypupCg9SUWSauOG22wkSZKkwjolOkAOXRkdQJJybB3wvegQOXF8dABlagqwKjpEkHOiA0iJnR8dICcmUylsPAvcFpwlWgPQHB1CqoGzowMEc5uqpNyyuCGp01577bUkc3r0cMOq9EYpttl07979bf+31atXc8wxx2S2eWPEiBFMmzat9Js3+vTpk9vNG2PGjOGpp57K5H5f/vKX37J5o0sXvyWVaqGhoSHJnLcrA0qSJEmqa+8G3hsdImeeBW6NDiFJOfcdfDI3VJ5grPJYDvwoOkSQ9wIHRoeQEtkB+HB0iBxYAXz/Df//ZVFBcuTjVLYMSUUxHDgoOkSg54GfR4eQpLfjKTlJnZaquLGxA+ZSGaXYZrPFFlts9H9v27yRVXlj3333Zfr06aUvbzQ2NuayvPHss8/S1NSUWXlj4sSJ7cobqYobqTZBSUWRqhyb6ns+SZIkSbnito23ugYPI0vSpjwD/Co6RA4MBvaODqFMXRodINCE6ABSImcD3aJD5MA1wKtv+P/vBx4KypIXPYAzo0NICZV9u9DVVLYFSlIuWdyQ1GmpDsha3JDay6K4AZY33sjyRmx5o2vXrklmerhcai/V91i+tyRJkqRC+lh0gJxZA3wvOoQk1YlrogPkxPHRAZSpJ4Bp0SGCnIxPolf96wF8JjpEDqwDJm/gr39zA3+tbJqx2KNi6AecGh0i0Brg29EhJGljLG5I6jQ3bki1kVVxAyxvvJHljbjyxuZ+vG7KmjVrksyRisLihiRJkqS3sSfw7ugQOXMDsDQ6hCTVianA49EhcuC46ADK3JXRAYJ0wwPvqn//jgUkgBuBxRv46zcDz2acJW92AE6KDiEl8FnKXUK6EX++IynnLG5I6jSLG1JtZFncgEp54+ijj+auu+6q+r6bY9999+WOO+6gd+/emdyvI7Iub0ybNi235Y0nnngik/tNnDiRr3zlK0lmpdoEJRWFxQ1JkiRJb+OU6AA59F/RASSpzpT1APsbvQcYHB1CmfoNsCA6RJAJeL5I9e386AA5cenb/PUW/NoO8IXoAFKVulEpbpTZt6IDSNKm+B9Wkjot1QFZixtSeykOyHb0ffXqq6/y/ve/n3vvvbfqe2+OkSNHcuedd9KrV69M7tcRWZY3+vbtm9vNG2PGjMls88bRRx+dZI7FDam9Hj16JJnjNhtJkiSpcCxutHc3MC86hCTVmf8L+ANZv6aWTZkPNvfHLTOqX0cAQ6JD5MBUYO5G/vfvAKsyypJX+wAHR4eQqnAila/ZZXUX/nxHUh2wuCGp09y4IdVG1hs32qxatYojjjgi0/LG1KlTS1/eaGxszG15o6mpKbPyRgoWN6T2UnyPtW7dugRJJEmSJOXIe4F3R4fImbIewJSkaqwEbo8OkQMeZC+f7wFlfdLNhOgAUidl80vf/Hu7bRttVgA/yCJIzvnxonp2TnSAYFdEB5CkzWFxQ1KnuXFDqo2o4gZY3ngjyxv1V95IVSiUiiLF91i+ryRJkqTC8cng7T0L3BYdQpLq1PXRAXJgf+Ad0SGUqeXAj6NDBBkNDIsOIXXQECobN8ruEeAPm/H3XQ601jhL3h0HDIwOIXXCcODA6BCBnsViuaQ6YXFDUqetXr06yZzOHjCXiirFIdmtttqq0/+s5Y31LG/UV3nDA+ZSeymKG6m+35MkSZKUG6dGB8iZq4GW6BCSVKd+C7wUHSIHTooOoMxdHh0gUNmf5K36c350gJy4ZDP/vvl48LkLcG50CKkTyv757nL8+Y6kOmFxQ1KnvfLKK7S0VP89T+/evROkkYpjxYoVVc/YZpttqvrnLW+sZ3mjfsobr7zySnQEKVeqKfG1Wb58eYIkkiRJknLiQGCn6BA50gJMiQ4hSXXsdeDG6BA5cFx0AGXuYeCu6BBBPgr0iQ4hbaZ+wL9Hh8iBxcBPOvD3X1arIHXkTKBndAipA/pR7gd1rAK+Fx1CkjaXxQ1JVUlxmK9fv34JkkjF8fLLL1c9o2/fvlXPsLyxnuWN+ihvpHjvSEWy3XbbVT1j2bJlCZJIkiRJyomTowPkzO+AJdEhJKnOXR8dIAeagG2jQyhzV0YHCNIT+I/oENJm+gzQIzpEDlwNvNaBv/8e4KEaZakXvYFPRIeQOmAC0C06RKAfAtU/IVeSMmJxQ1JVXnqp+g3IFjek9lK8r1IUNyCuvNGzZ/4eYGF5I//ljRTvHalItt22+t8X+76SJEmSCqOBcj99cUN+HB1AkgrgAWB+dIhgDcBR0SGUuV8CC6JDBDmbyse9lGfdqHyslt1rVIobHfWt1EHq0Hn4uU71oRuVolpZtQKXRoeQpI6wuCGpKimebm5xQ2ovLxs32kSUN+644w7LG5Y3OsyNG9J6ffv2paGh+p8nW9yQJEmSCqMJ6B8dIkdeoXLgUpJUvf8bHSAHmqIDKHMtwLejQwTZFTg8OoS0CR8GdogOkQNTgM78oudnwOLEWerNLsDR0SGkzXAi5f55zx1YJJdUZyxuSKpKisN8PXv2ZMstt0yQRiqGPG3caNNW3njggQeSzn07hxxyiOUNLG901NKlS6MjSLmRqhhrcUOSJEkqDA+ctHcDsDY6hCQVxA+jA+TAqOgACvE9YE10iCATogNIm3B+dIAcaAUu6eQ/uw6YnDBLvWqODiBthnOiAwS7IjqAJHWUxQ1JVUn1dPNtttkmyRypCFK8r2rxnlq1ahWHHnqo5Q0sb0D+yhsrVqygtbU1OoaUG9tuu22SOW6ykSRJkgpjbHSAnPlxdABJKpBngXuiQwQbAqT5gZzqyVLgxugQQT4A7BQdQnobY4B9okPkwK+BJ6v4568BViXKUq/GUfkaL+XVcODA6BCB5lPZuCFJdcXihqSqpDrMl+pwoVQEK1eupKWlpaoZXbp0oVevXokSrbdy5UrLG/9ieSNf5Q0Pl0vtpfreyo0bkiRJUiFsDYyIDpEjTwL3RYeQpIK5PjpADoyODqAQ/xUdIEgDPuFb+ZXNL3Dz79Iq//kVuFUL4AvRAaSN+Fx0gGCXUtkuJEl1xeKGpKosXbo0yZy+ffsmmSMVxYsvvlj1jFoVoixvrGd5Iz/lDQ+XS+3169cvyRzfW5IkSVIhjKNyuE4VP4oOIEkF9HPg9egQwUZFB1CIhylvIfRTQI/oENKb7AIcEx0iB+YCdyeY46Fo+DCQ5pduUlr9gFOiQwSyXCapblnckFSVZcuWJZmz3XbbJZkjFUWK99aOO+6YIMmGWd5Yz/JGPsobbtyQ2nPjhiRJkqQ3GBsdIGd+HB1AkgpoGWkOiNYzixvldVV0gCB9gI9Eh5De5DwsrQN8M9Gc+cBvEs2qVz2As6NDSBswAegWHSLQd4FV0SEkqTMsbkiqyvPPP59kjsUNqb0U7613vvOdCZK8vZUrV3LYYYfx5z//uab3aXPIIYfwu9/9Lrfljc99LpstlI2NjUybNo0RI0Zkcr/N1VbemD9/fsj9lyxZEnJfKa9SFTdSfa8nSZIkKZTFjfXuAZ6MDiFJBXV7dIBg+wC9o0MoxC1AWX+Qen50AOkNegOfiA6RA/+ksgkrlcsSzqpXn6HcB+SVP92ofFyWVQtwRXQISeosixuSqvLcc88lmTN48OAkc6Si+Oc//1n1jJ122ilBko1bsWIFhx12WGabN0aPHs0dd9zBlltumcn9OuKyyy7LbPNG3759mTZtWi43b4wePTpk80aqr0dSUQwaNCjJnBRfjyRJkiSF6kvlIKkq3LYhSbVzc3SAYF2AQ6JDKMQ64OroEEGGAe+LDiH9y5lA/p4AmL3LqBxqTmUm8FDCefVoB9wwpHw5CegfHSLQL4Fno0NIUmdZ3JBUlWefTfN9UKrDhVJRpHhv7bjjjgmSbNrKlSs59NBDMytvHHLIIfz2t7/NZXnj8ssvz6y80djYyPTp03NZ3mhqasq8vJHq65FUFKm+t3rmmWeSzJEkSZIUZizQEB0iJ1YDP40OIUkF9hwwJzpEsFHRARTm21QKHGU0ITqAROX827nRIXJgBXBdDea6dQP+MzqA9AbnRAcI5rYNSXXN4oakqqR6CrMbN6T26qm4AevLGw8++GAm9xs3blyuyxsXXnhhJveyvNH+npLWS1HcWL58OatWrUqQRpIkSVKgsdEBcuR24JXoEJJUcL+MDhCsKTqAwiylvAXREyj3U7+VDycAA6ND5MD3qJQ3UrsRWFyDufVkCDAmOoQEDAdGRocINA+4OzqEJFXD4oakqrzwwgusXbu26jlu3JDaq7fiBlTKG+PGjbO8AUyaNMnyRsblDYsb0noNDQ3svPPOVc/xfSVJkiQVgsWN9X4cHUCSSqDsxY2RQP5+aaGsTI4OEKQbcFZ0CJXe+dEBcqCF2n0eWgdcWaPZ9eS86AAS8LnoAMEuiQ4gSdWyuCGpaikO9Q0cOJBu3bolSCMVQz0WNwCWLVtmeeNfLG9kW97wgLm03jvf+c4k31f5vpIkSZLqXl/gPdEhcmIJ8IfoEJJUAg8BT0aHCNQNODA6hMLMBh6IDhHk01Q+/qUIB1Lup8+3+RnwzxrOvxZYU8P59eAYYJfoECq1/sAp0SEClXnDmaQCsbghqWopDvU1NDQwcKCbK6U2Kd5Xu+wS8zMDyxvrWd7IrrzxzDPP1HS+VE9SbTL75z9r+fN9SZIkSRk4LDpAjtxM5bbGq0cAACAASURBVAm0kqTauz06QLCm6AAKdVV0gCD9geOjQ6i03IJQManG85cCP6zxPfKuATg3OoRK7SzKXZS8BgtkkgrA4oakqqU61JfqkKFUBM8++yytra1Vz4l6X1neWM/yRu3LG0uWLGHdunU1mS3Vo1Sf+924IUmSJNW9sdEBcqTsh4glKUu/jA4QbFR0AIX6GfB8dIggE6IDqJQGAidEh8iBu4C5GdznEqD6Qwz17Qygd3QIlVI3KhuuymodleKGJNU9ixuSqmZxQ0qvtbWVhQsXVj1njz32SJCmc6LKG927d8/kfh1heaO25Q0Pl0vtWdyQJEmS9C8WNypeBaZFh5CkErkbWBYdItAhlPtJyGW3DvhOdIgghwDDokOodM7Fs28Al2Z0n/nA7zO6V171BD4ZHUKldBKVDVdlVeZyrKSC8ZtXSVVLdQj3Xe96V5I5UlE88cQTVc/YfffdEyTpvGXLljF+/HhmzZqVyf3GjRvHL3+Zz4d5ZV3emDZtWi7LG6NGjeLJJ59MOrdWmzykepXqe6qnn346yRxJkiRJIXYAhkSHyIlfA69Hh5CkEmkFfhcdItCWQL5+OK+sXUulwFFG50UHUKn0BM6MDpEDTwK/yfB+l2V4r7w6D89cKnvnRAcI9l/RASQpFb+JkFS1xx57LMmcPffcM8kcqSgeffTRqmcMGRL/+/mXX36Z8ePHZ7Z546ijjuL3v/996Tdv9O3bN5ebNxYsWMCoUaOSli1SvFekIhk2LM1DzR555JEkcyRJkiSFGB8dIEdujw4gSSU0NTpAsFHRARTqeeDm6BBBPgr0iQ6h0jgd6B0dIgcuoVKazMo04B8Z3i+PBgIfig6hUhkOjIwOEehPwJzoEJKUisUNSVVLdagv1SFDqShSvLeiN260WbZsGePGjcusvHHkkUdy++23l7680djYmMvyxrPPPktTU1Oy8obFDam99773vVXPWLNmjdtsJEmSpPo2JjpATrxOtk+flSRVTI8OEMzihq6KDhCkB/DJ6BAqhQagOTpEDrwETAm47yUB98wbP/6Upc9HBwh2RXQASUrJ4oakqj311FOsWbOm6jlDhgyha9euCRJJxZCiuLHHHnskSJJGW3njb3/7Wyb3s7xRkefyxm9+k+bchFsBpPXe8Y53sPXWW1c9x/eVJEmSVPfGRgfIiZnA8ugQklRCTwGPRYcItF90AIX7EzA7OkSQc6kcqpdq6Vhgl+gQOXA18FrAfW8EFgfcN08OAfaJDqFS6A+cHB0iUJk3mUkqKIsbkpJIcbiva9eu7LbbbgnSSMWQ4n21884706NHjwRp0li2bBljxoyxvIHlDYC99947yRwPmEvr7bnnnknm/OMfZd9yLUmSJNW1HQB/0Fpxe3QASSqxqdEBAr0D6BUdQuHK+nTonYD3R4dQ4Z0XHSAHXqNS3IiwBrgm6N55ckF0AJXCWUC36BCBrgBaokNIUkoWNyQlkerQ7NChQ5PMkYog1ftqn33y9aCHpUuXWt74l7KXN/bbr/qHjq1cuZIXXnghQRqpGFIVNyxESZIkSXXtkOgAOfKL6ACSVGJlLm4ADI8OoHA3AUujQwSZEB1AhbYPMDo6RA5cT+zWi6upFDjK7GQqD06QaqUb8OnoEIHWAN+NDiFJqVnckJREqsN9qQ4bSkWR4r3185//nB133DFBmnTayhsPPfRQJvc78sgjufXWWzO5V0dNmjSJL37xi5ncq7GxkRkzZuSivLHzzjvTs2fPqudkVQCS6oUbNyRJkiQB74kOkBNzgIXRISSpxGZS7qfjDosOoHBrgGujQwQ5Atg1OoQK63PRAXKgFfhWcIalVMojZdYNODc6hArtZKB/dIhA11PeEqykArO4ISmJVMWNYcP8Gab0RineW4MGDeK+++5j8ODBCRKls3TpUsaNG5fZwfsPfOAD3H777XTrlr8tkt/85jcz27zRp0+fXGzeSLUJ5tFHH00yRyoKN25IkiRJAvaKDpATt0cHkKSSWwrMig4RyKfVCeAqyllgasCtG6qNHYBTo0PkwB+APPwi59LoADlwFtAjOoQK65zoAMEuiw4gSbVgcUNSEqmeyjx06NAkc6SiSHVwdtCgQcyYMSOX5Y0xY8ZkVt449thjueWWW3JZ3pg0aVJm5Y3Gxsbw8sbee++dZI7FDam9VKWov//970nmSJIkSQrhxo0KixuSFG9qdIBAFjcE8DxwS3SIIJ8Aql+9LrV3DpUtB2WXl8LEP4A7okME6wd8LDqECmk4cEB0iEDTgXnRISSpFixuSEpi3rw03ysNGTIkyRypKFIWGgYPHszMmTNzWd4YO3Ysc+fOzeR+xx57LL/4xS8yuVdHTZo0iS996UuZ3KuxsZFp06aFlTdSFTf+53/+J8kcqQh23HFHtt5666rnPPXUU6xZsyZBIkmSJEkBtgB2jw6RAwuB2dEhJEkWNyQqWzfKqA/wkegQKpQewKejQ+TAXGBadIg38In4cF50ABXS56MDBLsiOoAk1YrFDUlJvPLKK0meer7llluGPgFeypvZs9P+fnnQoEG5LG+8+OKLjBs3LrPNGx/84Ae59dZbM7lXR1188cV8+ctfzuReffv2DStvpCpupH6PSPVs5MiRSebMmTMnyRxJkiRJIYbh736gvE+2lqS8uR9YHR0iyACgV3QI5cI9wMPRIYKcGx1AhfIxKtsNyu6/ogO8yR+pbN4osyHA4dEhVCj9gZOjQwSaD/w6OoQk1Yo/vJeUTKrDswceeGCSOVIRPPzww6xduzbpzEGDBjFjxoxcljfGjBmTWXnjQx/6ELfffjvduuVvm+5FF13EhRdemMm9+vbty/Tp0zMtb/Tu3TvJhqVly5bxzDPPJEgkFUOq4saDDz6YZI4kSZKkEO+JDpATt0cHkCQBldLGvdEhAg2PDqDcKOsT6YcBo6JDqBAacKsBwGLgp9EhNuDS6AA54MenUvo0kL+DLNm5EmiNDiFJtVLmT/CSEnvwwQc5+eTqC78HHngg3/72txMkkupfS0sLDz74YLLDuG0GDx7MjBkzGDt2LE899VTS2dVYunQpY8aM4b777ktysH9Tjj32WG655RaOP/541q1bV/P7dcSkSZMA+OY3v1nzezU2NjJ9+nTGjRuXyYHtgw46KMmcv/71r0nmSEVxwAEHJJkza9asJHMkSZIkhdgzOkBOfBXIZqWpJGlT3h0dINAwyl1c0Xo3AJdQzm0BE4C7o0Oo7h1BZatB2V0G5OuX2hXXA/+Hcn6Oa3MEsAuVTQFSNboBZ0WHCLQKmBIdQpJqyeKGpGRSHfZ144bU3uzZs5MXNyDf5Y1Ro0Zx9913W94oaHkj1ef5VJuepCLo0qVLsq8VlqIkSZKkurZ3dICceF90AEmScBOW1lsNXAf8Z3SQAMcD/YHno4OorrnNAF4F8voE1DXA1cBXooMEagAuoLIpQarGyVS+bpbV94EV0SEkqZa6RAeQVBypDvnttttu9OnTJ8ksqQhqeYi+rbwxePDgmt2jM5YsWcKoUaP4xz/+kcn92sobXbt2zeR+HTFp0iQuvPDCTO7VVt7Yd999a3ofixtSenvuuSdbbbVV1XMWLlzI4sWLEySSJEmSFMQDopIk5cew6ADKlWuAlugQAboAn40Oobo2BDg8OkQOXEe+DzNfQ6XAUWb/Qbm3jiiNz0cHCNQKXBEdQpJqzeKGpGRefvllnn766SSzmpqaksyRiqDW2w8sb1Qce+yx3HTTTZY3MihvHHLIIUnm1Pq9IdWTAw44IMkc31eSJElSXesJDIoOIUmS/r89owMoVxYAt0eHCPJZoFt0CNWtz0UHyIEW4PLoEJuwGLgxOkSwHsCnokOoro0EhkeHCPRbYH50CEmqNYsbkpJK9fTzVE9jl4pg7ty5tLTU9gE8ljcqTjjhBMsbrC9v7LXXXsln77HHHvTu3bvqOa+++iqPPvpogkRSMYwcOTLJnFmzZiWZI0mSJCnEPtEBJElSOwOAXtEhlCtXRQcI0g84KTqE6lI/4KPRIXLgVuDJ6BCb4ZLoADlwHhbV1HnnRAcI5rYNSaVgcUNSUqme0mxxQ1pv7dq1zJ07t+b3sbxRYXmjorGxkZkzZyYvb6T6/D5nzpyaF5qkepKquOHGDUmSJKmuvSc6gCRJeov3RgdQrswAHo4OEWRCdADVpc9S2WJQdt+KDrCZ/gFMjQ4RbAfgxOgQqkv9KXfJcR5+/pBUEhY3JCX1l7/8JcmcVIcPpaL405/+lMl9Bg8ezMyZM3NZ3hg9ejTz5s3L5H4nnHACN9xwQyb36qhJkybxpS99KZN79evXj5kzZzJ8eLptnAcddFCSOam+3khF0KtXL/bee+8ksx544IEkcyRJkiSFsLghSVL+DIsOoNy5MjpAkIOwyKSO6YaFH4D7gXr6xejk6AA58J/RAVSXPk25t7VcHh1AkrJicUNSUvfff3+SJ6D37t2bgw8+OEEiqRjuueeezO41aNCgXG7eWLx4MaNHj85s88bJJ5/MzTffnMvNGxdffHFmmzf69evHtGnTkm3eOPTQQ5PMyfI9IeXduHHjksx5/PHHWbRoUZJZkiRJkkJY3JAkKX/2jA6g3LkeWB4dIsjZ0QFUV06jsr2g7C6NDtBBv6eyeaPM9gE88KSO6AacFR0i0FLgR9EhJCkrFjckJbVixQpmz56dZFaqw71SEdx1112Z3m/w4MG5LG8sWbKEUaNGZVbeOOGEE7jppptyWd6YNGkSX/va1zK5V9vmjWrLGwMHDmTXXXdNkmnGjBlJ5khFcPjhhyeZc/fddyeZI0mSJCnMvtEBJEnSW1jc0JutAr4fHSLIh4F+0SFUN86LDpADTwK/jA7RQa345HyA5ugAqiunAP2jQwS6DlgTHUKSsmJxQ1JyqQ79jR8/PskcqQiee+455s+fn+k9817eePzxxzO5X1t5o0uX/H3b9NWvfpVJkyZlcq8U5Y0jjzwySZZHHnmEpUuXJpklFUGq4kbWJUFJkiRJSe0A9I0OIUmS3sLihjbkciqHm8umB3BGdAjVhbFUthaU3WSgJTpEJ/yQyhP0y+x4YGB0CNWNz0UHCNQCXB0dQpKylL8TiJLqXqpDfwcffDBbbrllkllSEUQ8CT3P5Y2mpqZMyxs//vGPc1neuPDCC+umvHHYYYclyeFWAGm9gQMHsttuuyWZZXFDkiRJqmvviQ4gSZI2qD+wbXQI5c4C4DfRIYJMwLNK2jS3bcAK6nc7zxrg2ugQwboA50aHUF0YCQyPDhHoFuDZ6BCSlCX/Y0hScvfee2+SOd26dWPs2LFJZklFEHVYPa/ljUWLFmVa3jjttNMsb1BdeeOII45IkuGee+5JMkcqgve///1J5ixatIinn346yaz/x96dR1lRXusffxoaGloGBQQRsKERAY3ihGgERJwgMhjjlGA04kWChkT0pxFj4jVqMJoIRgU1QWPQqEQUmQUHgmA0ehESRVRAlAa6macGGuh+f3+cGBUbaKi3atep+n7Weta669676ux318ARap8XAAAAgAkGNwAAiK9W1gUglh60LsBIC0m9rItArBWKa0SSHpa0zbqIAP4gaZd1EcYGSsq3LgKx91PrAow9YF0AAEQtfm8eAsh6a9eu1fvvv+/lWGeddZaX4wBJYPlL6AxvZDC8kXEgwxsnnHCC6tev7+Xz2XED+NK5557r5TgzZszwchwAAAAAZlpbFwAAAPaoqXUBiKUZkhZbF2HkJ9YFINZukJRjXYSxXZKGWxcR0CpJf7UuwlhdSf2ti0CsNZF0iXURhuZJmmNdBABELX5vHQJIBF8v1Z599tlejgMkwZIlS7RixQqzz2d4I4PhjYz9Hd7w9TxnVwDgSzk5Od7uLQaiAAAAgKzHC6EAAMQXf05jT7L9xewDdY4YPEbl6kq6yrqIGPirMoMP2e5+6wJiYIgYRMKeXSsp17oIQzwjAKRS/N44BJAIM2fO9HKcDh066NBDD/VyLCAJfN1bB4rhjQyGNzL2Z3ijZ8+eXj7zlVde8XIcIAk6derkbScby12dAAAAAHhxuHUBAABgjxjcwJ48IWmTdRFGfmZdAGJpkKR86yJi4DfWBXgyX9Lr1kUYK5R0vnURiKVcSQOtizBUIukZ6yIAwEL83jYEkAgzZ86Uc87LsXy97AskwYwZM6xLYHjjPxjeyKjK8Ea9evXUtWtXL5/H4AbwpV69enk5zooVK/TJJ594ORYAAAAAM7wQCgBAfPHnNPZkq6Q/Wxdh5Grxgj6+rpqkwdZFxMArkj6yLsKjtO4s9FVDrAtALF0mqYl1EYZGSdplXQQAWIjfm4YAEmH16tV6++23vRzrwgsv9HIcIAkmT55sXYIkhje+8MXwRk5O/HY3jdPwRq9evVS9enUvnxWXewCIA1/fkcaPH+/lOAAAAABMHWFdAAAA2CMGN7A3f5Dk5xcRs0u+pCuti0CsXCypuXURMfB76wI8myRpiXURxrpLamddBGLnRusCDO2S9KB1EQBghcENAKGZMmWKl+P07NlTtWvX9nIsINutXr1a8+bNsy5DEsMbX+jXr5/+9Kc/Mbyxl+GNPn36ePmMd999V2vWrPFyLCDbtWnTRu3bt/dyrEmTJnk5DgAAAAAz9SXlWhcBAAD2iMEN7M1iSdOsizCS5pdW8U1DrQuIgY+UvOeBU/KGUQ7ETdYFIFZOlXS8dRGGnpa0zroIALDC4AaA0Pj6VfSaNWuqZ8+eXo4FJMHUqVOtS/ivuA9vLF26NJLP69+/P8Mbqnx4o3r16t6e4ey2AXzp4osv9nKcHTt26NVXX/VyLAAAAABmeBkUAIB4489q7Etaf3W6tTK/RA98W1IH6yJi4F7rAkLyZ/GSdj9JDayLQGwMti7A2AjrAgDAEoMbAEIzd+5crV692suxLrzwQi/HAZIgToMbEsMbX2B4I2P34Y0zzzxT9erV83JsXzs5AUng67vR9OnTtWPHDi/HAgAAAGDmcOsCAADAXjWTFL9/PECcTJO0wLoIIz+xLgCxMMS6gBgokfS4dREh2SrpUesijOWJ5x0ymki6xLoIQ29ImmddBABYYnADQKgmTJjg5Ti9e/dW9erVvRwLyHZvvvmmSktLrcv4mrgObxQVFTG88R9Wwxt9+vTxcsw1a9bonXfe8XIsINsddthhOumkk7wci51sAAAAgETgV7wBAIi3HEmNrItArDlJD1gXYaSvpBbWRcBUc0n8kqf0kHUBIRshaZd1Ecauk5RrXQTMXat0Xwdp/b4DAP/F4AaAUPl6GbBevXo6++yzvRwLyHbl5eWaNm2adRnf0LJlS82cOTO2wxtLliyJ5PP69++vRx+N5w+GDB06VHfffXckn/XF8MZFF13k5XiTJ0+Wc87LsYBsd9lll3k7lq8hWwAAAACmGNwAACD+DrMuALH3lKRN1kUYqCZpkHURMDVEvL+2Q9LD1kWEbJWk56yLMNZYUj/rImAq7TuvFEl60boIALCW9i++AEI2ffp0lZeXeznWd7/7XS/HAZJg6tSp1iVUqqCgILY7b5xxxhmR7bwxYMAAjR49OpY7b9x2222R7rzRtKmfd0fies0DFnx9J/rXv/6lFStWeDkWAAAAAFMMbgAAEH+HWxeA2Nsq6Y/WRRgZqHT/+nia5UsaYF1EDIyWtN66iAjcZ11ADAyxLgCmfiipgXURhv4gqcK6CACwxuAGgFCVlpbqtdde83IsBjeAL02ZMsW6hD2K+84bn376aSSfF/edN4YNG2Zdxn6J4y4zgIXGjRura9euXo41ceJEL8cBAAAAYI7BDQAA4o8/r1EVD0hK4/bjDSR937oImBggqa51Ecac0jPQMF/SLOsijHWQ1M26CJi5wboAQ9sk/cm6CCSWn18VByLC4AaA0P3tb3/zcpzGjRurR48eXo4FZLuVK1dq9uzZ1mXsUZx33ujatWvkO2/E0a233hrZzhtBTZ8+XRs3brQuA4iF73/f379djRs3ztuxAAAAAJjiF7wBAIg/BjdQFcskTbIuwshPrAtA5KpJ+ql1ETEwQVI0vzwYD8OtC4iB660LgIluktpbF2HoSaVjZyHYqG5dALA/GNwAELpx48apvNzPYOOVV17p5ThAEjz33HPWJexVy5YtYzu80aVLl8iGN/r376+RI0dG8ln7a+jQoVkxvMHL5cCX+vXr5+U4y5Yt03vvveflWAAAAADM8SIoAADxx5/XqKoHrQswcoqkE6yLQKT6Siq0LiIGfm9dQMRekrTEughjfcS1n0ZpH1T7g3UBABAXDG4ACN26des0ffp0L8e64IILVKdOHS/HArLd888/L+fivVsywxsZgwYNYnjjADnn9Pzzz1uXAcRCYWGhOnbs6OVYzzzzjJfjAAAAAIgFXgQFACD++PMaVTVD0kLrIozwK/Tp8jPrAmLgX5LesC4iYk7SCOsijOWI6z9tmiszrJZW0yV9aF0EAMQFgxsAIuFrZ4BatWrpsssu83IsINsVFxfr9ddfty5jn+I+vFFUVBTJ5zG8cWD+/ve/a926ddZlALHgc+cxBqIAAACAxMiXVNe6CAAAsE8MbmB/PGRdgJFLJTWwLgKR6CDpDOsiYmCYdQFGRkvabF2Esf8R/y2fJoOV7vd0H7AuAADiJM1/IACI0AsvvKAdO3Z4OdYVV1zh5ThAEjz77LPWJVQJwxsZDG/sv3HjxlmXAMTG5Zdf7uU4y5Yt0zvvvOPlWAAAAADMHW5dAAAAqBIGN7A/npC0yboIA3mSBloXgUjcZF1ADKyXNNa6CCNbJT1iXYSxfEkDrItAJPIk/di6CENLJE21LgIA4oTBDQCR2Lx5s6ZNm+blWF26dFFhYaGXYwHZbty4cSovL7cuo0riOryxdOlShjf+I27DG845dgUA/qNTp07evv+MHZvWfwcAAAAAEonBDQAAskML6wKQVbYqM7yRRoPEu0xJ11iZ3VXS7kFJFdZFGPqD0r1+SRoinndpcIWketZFGBouyVkXAQBxwh/+ACLz3HPPeTvWD3/4Q2/HArLZunXrNH36dOsyqozhjQyGN6rmrbfeUnFxsXUZQCz069fP27EYiAIAAAAShV/vBgAgO9RQul/aw/57UOl80bGFpL7WRSBU10vKtS7C2A5JI6yLMFYkyd9LRNmpuaQLrItA6H5mXYChzZIety4CAOKGwQ0AkXnhhRe0fft2L8e66qqrlJOT4+VYQLZ78sknrUvYLy1bttTs2bNVUFBgXcrXMLzxpaFDh2rECPu/K+TlciAjLy/P2+DGZ599prfeesvLsQAAAADEQmPrAgAAQJU1sy4AWWWxpKnWRRj5iXUBCE2+pIHWRcTAaEnrrYuIgd9aFxADN1gXgFB1k3SMdRGGHldmFzEAwFcwuAEgMtu3b9fYsWO9HKugoEDnnXeel2MB2e6ll17Sli1bvBxr7dq1Xo6zL82aNdObb76pVq1aRfJ5VbV06VKdccYZWr58eSSfN2jQID300EORfNb+GjJkiO6//37TGp566inTzwfi4tJLL1WDBg28HOuxxx7zchwAAAAAscEvdwMAkD3qWheArPOgdQFGuktqbV0EQnGFJD//4JG9nKT7rIuIifmSZlkXYex0SR2si0BofmpdgCEn6Q/WRQBAHDG4ASBSY8aM8XasgQP5IQZAygxFPfPMM16ONWvWLM2cOdPLsfbl8MMP1xtvvBG7nTeWLFmizp07R7bzxnXXXRfbnTduvPFGs503pk6dqlWrVpl8NhA31113nZfjVFRU6IknnvByLAAAAACxwQugAABkDwYusb9eVmbnjTTiV+iTJ0fSTdZFxMBESZ9aFxEjtr8kGA83WxeAUDSX1Ne6CEMTJS2xLgIAkG4NlZkkJCTVycnJccuWLXM+lJeXu6ZNm5qviZA45PTTT/dyXznnXEFBgXv99de9HW9fioqKXEFBgXkPd0/Lli3dypUrI+vDyJEjzde8p4wcOTKyPnzhsssuM183IXHICSec4O2+mjJlivl6CIlJdghInpNkf2/FIYcEbSQAZKGRsn/+EkIIIaRquVDA/hss+2vXIqWS8j30D/HxHdlfV3FI16CNTJgcZQbUrM+LZXZKahy0kYide2V/bVmme/AWAlX2oeyv+aiz1kvnYIIdNwBEyjmnv/71r16OVa1aNQ0YMMDLsYBsN2fOHC1Z4mdY/Yc//KF69OgR2c4bzZo105w5c2K388bSpUvVpUsXFRcXR/J5gwYNiu3OG9dee61GjRoV2eeVlpZq/PjxkX0eEGeDBw/2dqzRo0d7OxYAAACA2GDHDQAAsgd/buNAjJa01boIA/mSrrYuAl4NsS4gBv4laZZ1ETHjJI2wLsJYrqTrrYuAV3mSBloXYehDSa9ZFwEAccXgBoDIPfnkk96OdfXV/F0N8IXHH3/cy3Guu+46lZWVMbwhadGiRQxv/EeUwxvPPvustm/fHslnAXFWr149/eAHP/ByrDVr1mjChAlejgUAAAAgVupZFwAAAKqMP7dxILZK8vOPgNnnZ9YFwJt2ks62LiIG7rEuIKZGS9psXYSxgcq87I9kuELp/t53v3UBABBnDG4AiNyCBQs0d+5cL8c64ogjdPHFF3s5FpDtnnjiCS/HOeyww3ThhReqrKxMZ555pl555RUvx92XZs2a6c0331SrVq0i+byqWrRokbp27aqSkpJIPm/QoEEaPnx4JJ+1v6699lo98sgjoX+OzwE/IJsNGDBAeXl+/o52zJgx2rlzp5djAQAAAIiVNL8IAABAtmHHDRyoEcr8Kn3atJZ0jnUR8OIm6wJiYLmk56yLiKmtksL/R+h4ayDpSusi4E2adxhaJ2mMdREAAEhSQ2X+Q5oQIrmBAwc6X+bPn2++HkLikvHjx3u5r1599dX/HjMvL8+9/vrrXo5bFUVFRa6goMC8l7vnyCOPdCtXroysD8OHDzdfc2XJyclxhe5Y4gAAIABJREFUo0ePDm3dn3zyifkaCYlDcnJy3Oeff+7t3jrqqKPM10RIjLJDQPKcJPt7Kw45JGgjASALvSv75y8hhBBCqhZ+aR1BvCz7a9gi4300D6YaSNou+2vJOjcGbWTCNZe0U/bnyTIfBu4i4uBM2V9LlvlN8BYC++1D2V/7UWetl87BBDtuADAxZswYbdq0ycuxjjvuOHXr1s3LsYBs9+ijj3o5Tvfu3XXMMcdIksrKytSzZ89Id96YPXu2CgsLI/m8qlq0aJHOOOOMyHbeuP7663X//fHbQdI5p6uvvlp/+tOfQjn+Qw89FMpxgWxz3nnnqUWLFl6O9fbbb+vjjz/2ciwAAAAAscOOGwAAZA/+3EYQf7AuwEhvSX7+shxWBkvys7149tos6THrImKuSNLz1kUYayfpPOsiENhPrQswtEvSA9ZFAEDcMbgBwMTWrVv15z//2dvxbrqJnTUBSZo2bZo+++wzL8e65ZZb/vs/b9++Xb169dKMGTO8HHtfmjdvrlmzZqmgoCCSz6uqjz/+WJ07d1ZxcXEknzdkyBANHz48ks/aX9dcc42efvppr8csKyvTE0884fWYQLb66jM4KO4rAAAAINFqWxcAAACqrK51AchqUyQtsy7CQDVJ11kXgQOWp3S/xPyFPyozvIG9Y2cq6XrrAhBIc0l9rIsw9LykaH4JFQCAKmgo++1xCIlVjjzySOdLRUWFa9u2rfmaCIlDbrvtNm/31hFHHPGN40+bNs3b8fdl+fLlrrCw0Lynu6dt27Zu9erVkfXh/vvvN1/znvLee+95W+ef//xn8/UQEoecdtpp3u6rbdu2uXr16pmviZCYZYeA5DlJ9vdWHHJI0EYCQBZaKfvnLyGEEEKqlnECghki++vYImvFjg3Z6irZXz/WKZfULGgjU2S27M+ZddoF7iKs3Cv768cypwZvIXBAPpT99R911nrpHEyw4wYAM4sWLdKrr77q5Vg5OTlef5kayGajR49WRUWFl2NVtptN7969I9t54/DDD4/lzhsfffSRunTpotWrV0fyeXHdeeOII47Qt771LW/He/TRR70dC8hmv/rVr7wd67HHHtOmTZu8HQ8AAABA7NSwLgAAAFQZf24jqNGStloXYaCBpO9bF4EDcrN1ATHwN0nLrYvIIvdbFxAD7LqRnfIkDbQuwtA8SW9ZFwEAwFex4wYhleSCCy7w9ovSzjnXvHlz8zUREoeMHTvWyz21detWd8ghh3zj+DVq1HDTp0/38hlVUVRU5AoKCsz7unvatWvnVq1aFVkfhg8fbr7mr2bkyJHe1vb++++br4eQOOTEE0/0dl+Vl5e7Zs2ama+JkBiGHTeQROy4kQk7bgBIow2yf/4SQgghpGqZJiC4UbK/li0y10fzEKmzZH/dxCHHBW1kylSTtEz2580y25UZWEN2uUb2145lfhC8hcABY8cNZBV23ABgasKECSouLvZ2PHbdADJGjBjh5Ti1a9fWDTfc8I3//c6dO3X++edHtvNGs2bNNGfOnNjtvLFw4UJ17do1sp03rr/++tjsvNG0aVNdffXV3o43cuRIb8cCstkvfvELb8caN26cli/nR5wAAACAhOOXuwEAyB78uQ0fHrQuwMgJkk61LgL7ZYh1ATHwhqR/WReRZSok/c66CGNp37khW6V5p5QSSWOtiwAAYHfsuEHIHnLLLbd4+2Vp55w7/PDDzddESBzyzjvveLmn1q9f7+rUqbPHz5kyZYqXz6mKoqIi17JlS/Pe7p727dtHuvPGvffea77m+++/39t6NmzYsNdrjJC0pE2bNq6iosLbvdWxY0fzNRES07DjBpKIHTcyYccNAGlUJvvnLyGEEEKqljcE+PGK7K9nizzlo3mIRKEyL+BbXzPWuSBoI1MqX9Im2Z8/y5RIyg3aSETmTNlfM5a5LXgLgUDYcQNZhR03AJh7+OGHtXnzZm/Hu/nmm70dC8hmDzzwgJfjHHzwwbrxxhv3+H/v27dvpDtvzJ49O3Y7b3z44YeR7rxx0003me680ahRI/34xz/2drxRo0Zpy5Yt3o4HZKvbb79dOTk5Xo41e/ZsvfPOO16OBQAAACDWaloXAAAAqow/t+FLWnfduFRSA+siUCX/T5Kff/DIXp9Kesm6iCy1VdIfrYsw1ljSJdZFoMp+al2AoTJJI62LAACgMuy4Qche8tvf/tbbr0uXlZW5Ro0ama+JEOvk5ua64uJiL/fVli1bXMOGDff4WTVq1HDTp0/38llVUVRU5AoKCsx7vHvatWvn1q5dG1kfhg0bZrLOYcOGeVvDzp073aGHHmp+7gixTkFBgSsvL/d2b/Xt29d8TYTEOOy4gSRix41M2HEDQNpUk/2zlxBCCCFVz1wBflST9Lnsr2mL/MJD/xCuBpJKZX+tWOfaoI1MueaSymV/Hi0zL3AXEYW0X6ujg7cQCIwdN5BV2HEDQCz8/ve/144dft6fqlmzpoYOHerlWEA227Vrlx5++GEvxzrooIN066237vH/vnPnTp1//vmR7rwxZ86c2O28sXDhQnXr1k3r1q2L5PNuueUWDRs2LJLP+kLjxo01ePBgb8f7y1/+EtlOJUCc3XbbbapWzc9/nn366aeaMGGCl2MBAAAAiLVc6wIAAMB+YccN+FKh9O66MVi86xR3AyXlWxdhbL2kJ6yLyHJFksZZF2Gsg6RvWxeBffqZ0v3n0u+sCwAAYE/YcYOQfeTRRx/19ivT27ZtY9cNQiTXqFEjt3XrVi/3VVlZmTvssMP2+nnsvJHJsccem9idNx5++GFvdVdUVLijjjrK/HwRYp2WLVt6u6+cc+6aa64xXxMhMQ87biCJ2HEjE3bcAJA2B8n+2UsIIYSQqucjAf7Uk7Rd9te1Rb7noX8IR66kEtlfI9a5O2gjIUnqJPtzaZ2/Be4iwpQnaaPsrxOrvB68hYAX7LgBoFIMbhCyj7Rq1cqVl5d7e2lxxIgR5msiJA554IEHvN1Xf/zjH/f5eQxvZJLE4Y2WLVu6Xbt2eat54sSJ5ueJkDjkmWee8XZfrVu3ztWsWdN8TYTEPAxuIIkY3MiEwQ0AaZMn+2cvIYQQQqqeTwX49Zjsr2uL8KJofPWT/fVhnZ2SGgdtJP7rH7I/p5Ypl9Q8cBcRlmtkf41Y5oLgLQS8YHADQKUY3CCkChk7dqy3FxfLyspcixYtzNdEiHWaNm3qysrKvN1bVd0hYfLkyd4+c1+Kiopcy5YtzXu9e6Ie3rj77rtDXc+zzz7rtd4uXbqYnyNCrHPCCSd4va/uuOMO8zURkgVhcANJxOBGJgxuAEgj62cvIYQQQqqeIgF+HS3769oqR3voH/ybJ/trwzpPBO4ivupi2Z9T69wXuIsIywLZXx9WWSapWvAWAl4wuAGgUgxuEFKF+H558fHHHzdfEyFxyKhRo7zdVy+88EKVPzfq4Y3WrVub93r3dOjQwa1bty6yPtx1112hrOOkk07yWuecOXPMzw0hccisWbO83luNGjUyXxMhWRAGN5BEDG5kwuAGgDTaJfvnLyGEEEKqllUC/Jsp+2vbIqN8NA9edZH9dRGHtA3aSHxNNWVeELc+r5bZJCk/aCPhXXfZXxuWuSF4CwFvGNxAVsmxLiBFGkpaY10EkA1eeukl9enTx8uxKioqdMwxx2jhwoVejgdkq4KCAn388ceqWbOml+Oddtppeuutt/b5/1ejRg1NnjxZ55xzjpfP3Zfly5fr9NNP12effRbJ51XVscceq5kzZ6pBgwaRfN4999yjoUOHej3mnDlz9O1vf9vb8c466yy99tpr3o4HZKPevXtrwoQJ3o53//3368Ybb/R2PCDBdkry86UIiI+TJL1rXUQMNJC03roIAIjYNkm1rIsw8rikMdZFAACwH3ZKmmNdBBLne5Kety7CwFZJTZV5oRnx8IKk71oXYWyGpHOti0igGyT93roIY4MlPWRdBL5mvKS+1kUY2SrpMEmbrQsB/uNDSe2si4jYOmXeSQewF+y4QUgVc8IJJ7iKigpvvzy9P7sDEJLkjBgxwtt9NXfu3P36bHbekDv++OPdxo0bI+uDz503vvOd73itbebMmebngxDrVK9e3X3yySfe7qstW7a4Bg0amK+LkCwJO24gidhxIxN23ACQRptk//y1ym889A8AACDbVZP0uey/m1nkpx76Bz+aSyqX/TVhnfOCNhKVqiupVPbn1zKLxQ90x0nan3kPBm8h4BU7bgCoFIMbhOxHxo0b5+1FRuecO/nkk83XRIh1GjZs6LZt2+btvvrRj35U5c+uUaOGmz59urfP3peioiJXUFBg3vPdc+KJJ7oNGzZE1odhw4YFrtn3y+XOOXfKKaeYnwtCrHPNNdd4va98DmsRkoIwuIEkYnAjEwY3AKTRGtk/f60ywkP/AAAAkmCo7L+bWWSReJE5LkbI/nqwzsLAXcTeDJf9ObZO78BdhC/3yf56sEqFpMLgLQS8YnADQKUY3CBkP/Ktb33L68uMb7zxhvmaCIlDhg0b5u2+WrVqlcvPz6/yZzO8kUm2DW8MGTLEaz3Tpk0zPweEWCc/P9+tWrXK2321YcMGV79+ffN1EZJFYXADScTgRiYMbgBIo5Wyf/5a5TEP/QMAAEiCBpK2y/77mUXO9dA/BMNuCJlcFbSR2Ku073DgJL0auIvwIV/SRtlfD1aZHLyFgHcMbgCoFIMbhOxnxo4d6+2FRuecu+SSS8zXRIh16tev73Vo4I477tivz7cY3igsLDTv++6Jenjj9ttvP6A6DznkELdp0yavtXTo0MG8/4RY5/bbb/d6X916663mayIky8LgBpKIwY1MGNwAkEafy/75a5WnPPQPAAAgKR6X/fczi0zw0TwEcoPsrwPrlEiqGbSR2Kdxsj/X1mkXuIsIaqDsrwPLMDCJOGJwA0ClGNwgZD9z9NFHu4qKCm8vNa5YsWK/dgcgJKn5xS9+4e2+2rp1q2vRosV+1zBx4kRvNezLihUr3JFHHmne991z8sknu40bN0bWh9tuu22/axw1apTXGsaPH2/ed0Ks07RpU7d161Zv99WqVavcQQcdZL4uQrIsDG4giRjcyITBDQBptEj2z1+rvOChfwAAAElxguy/n1mkQlILD/3DgakmaZnsrwPr3Ba0kaiS02V/rq3zeOAuIqgFsr8OrLLAQ/+AMDC4AaBSDG4QcgD561//6u3FRuec+/Wvf22+JkKsU6dOHbd69Wpv99W4ceMOqA6GN+I9vHHsscd6//xjjjnGvOeEWOe5557zel8NGTLEfE2EZGEY3EASMbiRCYMbANIojf8w+UWmeegfAABAksyW/Xc0i9zro3k4IBfJ/vxbp0z8nVSU5sn+nFtmu6QGgbuIA9Vd9teAZX4cvIVAKNL496MMbgBVwOAGIQeQgoICt2PHDm8vN27fvt0dccQR5usixDpDhgzxdl8559x55513QHVMmTLFax17U1JSEsvhjY4dO0Y6vHHrrbdWqa6ZM2d6/dzRo0eb95oQ63Tr1s3rfVVcXOxq1Khhvi5CsjAMbiCJGNzIhH8kB5BG/5L989cqszz0DwAAIEkulf13NItslJTnoX/Yf3Nkf/6tMzJwF7E/LpP9ObfO7YG7iAM1Xvbn3yqbJOUHbyEQCgY3AFSKwQ1CDjD33Xef15ccx48fb74mQqxTs2ZNt3LlSm/31eLFi11eXt5+11GjRg03ffp0b3XsS3FxsSssLDTv/+458cQT3ebNmyPrwy233LLXeq688kqvn7d9+3Z3+OGHm/eZEMvk5eW5JUuWeL23Bg4caL4uQrI0DG4giRjcyITBDQBp9K7sn79WeddD/wAAAJIkV1Kx7L+nWaS/h/5h/3SQ/Xm3ToWkVkEbif1STdIy2Z97y5Qo87xHtJpLKpf9+bfKb4O3EAgNgxsAKsXgBiEHmHr16rnVq1d7fdHxnHPOMV8XIdYZOHCg1/vql7/85QHVwfBGJp06dYrF8EbDhg3dmjVrvH7WXXfdZd5fQqxz5513er2vli1b5qpXr26+LkKyNAxuIIkY3MiEwQ0AafR32T9/rbLAQ/8AAACS5jbZf0+zyFwfzcN+eUb25906LwXuIg7ETbI/99b5UeAuYn/9Tvbn3SrlygyuAHHF4AaASjG4QUiAXHfddV5fdiwqKnK1a9c2Xxch1lm4cKG3+2rbtm2uoKDggGuZOHGit1r2ZcWKFe7II4807//u6dSpk9uyZUtkfRg6dOg3anjyySe9fkZJSYmrU6eOeW8JsUzbtm293lfOOXf55Zebr4uQLA6DG0giBjcyYXADQBqNl/3z1ypLPfQPAAAgaRpI2in772oWOc1D/1A1zZXe6+yr6Rq0kTggdSWVyv78W+bDwF3E/siXtFH2590qfwveQiBUDG4AqBSDG4QESPXq1d0nn3zi9YXHP/zhD+brIsQ63bt393pfTZkyJVA9U6ZM8VrP3pSUlMRyeOPUU081G94488wzvR9/0KBB5j0lxDqvv/661/vqnXfeMV8TIVkeBjeQRAxuZMLgBoA0+rPsn79WWe+hfwAAAEn0F9l/V7PI0z6ahyr5rezPt3XmB+4igviD7K8B63QL3EVU1UDZn2/LdA7eQiBUDG4AqBSDG4QEzPnnn+/1pceKigrXqVMn83URYp1x48Z5vbeC/Ap8jRo13PTp073WszfFxcWusLDQ/Bzsnk6dOrnNmzdH1odbbrnF1axZ03366adej/vJJ5+46tWrm/eTEMtcfvnlXu+riooKd+yxx5qvi5AsD4MbSCIGNzJhcANAGg2X/fPXMjnBWwgAAJA4J8j+e5pFdiqz4wjClS9pk+zPt3UuC9pIBFIoqUL214FlXgrcRVTVAtmfb6u856F/QNgY3ABQKQY3CPEQ3y90f/TRR+ZrIsQ6LVq08HpfrVu3zh122GGBapowYYLXmvZmxYoVrk2bNubnYfecdtppke688c9//tP7MXv16mXeR0Isc/DBB7s1a9Z4va9Gjhxpvi5CEhAGN5BEDG5kwuAGgDT6leyfv5ZpGryFAAAAifSW7L+rWeSXPpqHvbpO9ufZOkWSqgVtJAJ7UfbXgmUqlBlgQbjOkv25tswVwVsIhI7BDQCVYnCDEA9p166d27Fjh9cXIO+66y7zdRFinV/+8pde76tJkyYFqoedNzLp1KmTKy0tjawPPr3yyivm/SPEOo899pjX+2r16tXu4IMPNl8XIQkIgxtIIgY3MmFwA0AaDZb989cyxwVvIQAAQCL1k/13NYsUixfqw5QjabHsz7N1bgzaSHjRVfbXgnUeCNxF7MtLsj/PVimWlBu8hUDoGNwAUCkGNwjxlHvvvdfrS5DOOXf88cebr4sQy+Tl5bnPP//c6311+eWXB6qJ4Y1MOnfunHXDGzt27IhlLwmJMmeffbb3e+vqq682XxchCQmDG0giBjcyYXADQBpdLvvnr2XOCt5CAACARMpV5oVL6+9rFrnYQ/9Qud6yP7/W2SSpbtBGwpt5sr8mLFMqrscwNVdmZxPr82yV24O3EIgEgxsAKsXgBiGekp+f71asWOH1RciFCxe6WrVqma+NEMv06tXL6321YcMG17hx40A1MbyRSbYNb9xzzz3mPSPEMo0aNXKrV6/2el+988475usiJEFhcANJxOBGJgxuAEij82X//LXMZcFbCAAAkFj/K/vvaxb5u4/moVKvyf78Wuf3gbsIn9K6u9BXc0PgLmJPfif782uVnZKaBG8hEAkGNwBUisENQjzmsssu8/oypHPOPfLII+brIsQ6U6dO9XpfTZ482UtdkydP9lrX3pSUlLg2bdqYn4vd06VLF7d169bI+nCgVqxY4fLz8837RYhlZsyY4fW+qqiocMcee6z5ughJUBjcQBIxuJEJgxsA0uh02T9/LfOT4C0EAABIrCbKvHhp/Z3NIkd76B++roPsz6t1yiU1C9pIeJUrqUT214ZllkmqFrSR+IZ8SRtlf36t8mTwFgKRYXADQKUY3CDEc2bPnu31pUjnnOvdu7f5ugixTGFhoduxY4fX++qaa64JXBc7b2SSDTtv9OvXz7xPhFjmJz/5iff7atSoUebrIiRhYXADScTgRiYMbgBIo6Nl//y1zB3BWwgAAJBof5X9dzaLPOKjefiaP8v+vFrn2cBdRBhukf21YZ3vBe4idvdj2Z9XyxwfvIVAZBjcAFApBjcI8Zx27dq5Xbt2eX0xct26da5p06bmayPEMnfddZfX+2rbtm1ehiAY3sgkzsMb//znP837Q4hljjrqKLdt2zav99X69evdwQcfbL42QhIWBjeQRAxuZMLgBoA0air7569lRgZvIQAAQKKdJvvvbBYplVTPQ/+Q0Vjp3b3lqzkuaCMRirrK3PPW14dl3gjcRexugezPK9cTUDUMbiCrsE0WgKy1cOFCDR8+3OsxDznkEI0ZM8brMYFsc/fdd6uoqMjb8WrVqqXnnnsu8HF27typc889VxMnTvRQ1b41adJEs2fPVps2bSL5vKqaPXu2evbsqW3btlmX8g39+/e3LgEwU7NmTY0bN061atXyetybbrpJGzZs8HpMAAAAAImy3roAY4daFwAAABBz/5D0nnURBvIl8Q9X/vxEUq51EcbekPQv6yJQqc3K7AiTZp0ldbAuIkHOktTeughDD1gXAACAD+y4QUgIyc/Pd59++qnXX7Z2zrmbb77ZfG2EWKZv377e76s777zTW30TJkzwXt+elJSUuDZt2pifk93TvXv3yHpQFb/+9a/Ne0KIZe677z7v99WsWbPM10VIQsOOG0gidtzIhB03AKRVmn9ZdI6H/gEAACTdFbL/3maRRZJyPPQv7fKU+VVn6/Npnb5BG4lQFUqqkP11YpmnAncRX3hJ9ufTKsvEj8Ej+7DjBoBKMbhBSEjp3Lmz9xcld+7c6Tp27Gi+NkIs89RTT3m9r8rLy92pp57qpbbc3Fw3adIkr/XtTXFxsSssLDQ/J7une/fubtu2bZH1YU8++eQTl5uba94PQqzStWtXV1FR4fW+2rJlizviiCPM10ZIQsPgBpKIwY1MGNwAkFYfyP4ZbBV/28YCAAAkV5pfvO/hoX9p9z+yP4/WWSKGgLLBBNlfK5bZKalx4C6iudI9BHRT8BYCkWNwA0ClGNwgJMQ88sgjXl+WdM65oqIid/DBB5uvjRCr1KtXzxUVFXm9r5YuXer1vop6542jjjrK/LzsnrPOOiuyHuwJg24kzWncuLErKSnxfl8NGDDAfG2EJDgMbiCJGNzIhMENAGn1suyfwVapkJQbvIUAAACJd5fsv7tZZJKP5qVcGl+G3D3XBu4ionCm7K8V69wduIv4vezPo1VKJdUN3kIgcmn8rsLgBlAFDG4QEmLq1Knj/QVz55ybOnWq+doIsUz37t2931cvv/yyt/rYeePL82S188bw4cPN10+IVapXr+7+8Y9/eL+vpk2bZr42QhIeBjeQRAxuZMLgBoC0Gi37Z7BlWgVvIQAAQOI1kVQu++9uUadCUgsP/Uurc2V/Dq2zTlLtoI1EZObJ/pqxzFpldlnCgcmXtFH259Eqo4K3EDDB4AaASjG4QUjICetX52+++WbztRFimYcfftj7fXXrrbd6q4/hjUwshjeWLl3qateubb52QqwyYsQI7/fVunXr3KGHHmq+NkISHgY3kEQMbmTC4AaAtLpD9s9gy3QL3kIAAIBUGCv7724Wuc9H81JqquzPn3XuCtxFROkK2V8z1hkQuIvp9WPZnz/LFAZvIWCCwQ0AlWJwg5AI8sQTT3h/gXLnzp2uY8eO5msjxCq1atVyixYt8npflZeXu27dunmrkeGNTKIe3ujcubP5mgmxyoUXXhjKfdW3b1/ztRGSgjC4gSRicCMTBjcApNX/yP4ZbJkrg7cQAAAgFTrL/rubRTaKX6A/EO1kf+6ss1NS46CNRKRyJZXI/tqxzIeBu5heC2R//qzysof+AVYY3ABQKQY3CIkg9evXd0VFRd5foly+fLlr2rSp+foIsUrHjh1deXm51/tqzZo1rlmzZt5qZHgjk+7du7uysrLQ1//ggw+ar5UQq7Rr186VlpZ6v6+efvpp87URkpIwuIEkYnAjEwY3AKRVD9k/gy3zq+AtBAAASI0PZP/9zSJX+2heyjwq+/NmnScCdxEWfiH7a8c65wbuYvqcLfvzZpnvBG8hYIbBDQCVYnCDkIjStWtXV1FR4f1lyrlz57q8vDzz9RFild/85jfe76t3333X1ahRw1uNDG9k0qNHj1CHNz766CNXq1Yt83USYpE6dep434XIOedWrFjh6tWrZ74+QlISBjeQRAxuZMLgBoC0+pbsn8GWGR28hQAAAKnRX/bf3yzygY/mpUgDSdtlf96s0zZoI2GC61eaGriL6TNB9ufNKosl5QRvIWCGwQ0AlWJwg5AIc/fdd3t/odI555599lnztRFimfnz53u/r0aPHu29zhdffNF7nXuycuVKd9RRR5mfm91z6623hrbmY445xnx9hFglrOGwbt26ma+NkBSFwQ0kEYMbmTC4ASCtDpb9M9gyrwRvIQAAQGrkKfOil/V3OIuc7qF/acGOBdLLgbsIS4/I/hqyTIWkwsBdTI/myvTM+rxZ5brgLQRMMbgBoFIMbhASYXJzc93cuXNDebHy5ptvNl8fIVZp3759KDs53HDDDV7rTPvOG61atXIbN24MZa0/+9nPzNdHiFWGDh0ayn318MMPm6+NkJSFwQ0kEYMbmTC4ASDNSmX/HLbKxx76BwAAkCb3yP47nEWe8dG8FMiVVCL782Wd84I2EqYKle4X8Z2kUYG7mB6/l/35ssomSfnBWwiYYnADQKUY3CAk4rRq1cpt2bLF+8uV5eXlrmfPnubrI8QqP//5z0O5r3r16uW1zrQOb9SpU8d99NFHoaxxxowZ5usjxCrnn39+KPfVggULXO3dWsvSAAAgAElEQVTatc3XR0jKwuAGkojBjUwY3ACQZmn8B8ovsktS9eAtBAAASI0Wkspl/z0u6uyU1MRD/5Luh7I/V9ZZGLiLiIPJsr+WLLNdUoPAXUy+fEkbZX++rPL74C0EzKXx70UZ3ACqgMENQgzy/e9/P5SXLLds2eLat29vvj5CrPL66697v69KS0vd8ccf773WF1980Xute7Jy5UrXtm1b03MzceLEUNa2Zs0a16RJE/NrjxCLnHDCCW7btm3e76vS0lJ35JFHmq+PkBSGwQ0kEYMbmTC4ASDNZsj+OWyZ9sFbCAAAkCrjZP8dziK3+2hews2T/XmyzlWBu4g4OFv215J1bgncxeQbJPvzZJVySc2DtxAwx+AGgEoxuEGIUcaMGeP9RUvnnFu2bJlr1KiR+foIsUiTJk3cihUrvN9XxcXFrlmzZt7rfemll7zXuiclJSVmwxt33nlnaOvq0aOH+XVHiEVat27t1qxZE8p9ddFFF5mvj5CUhsENJBGDG5kwuAEgzR6V/XPYMt8L3kIAAIBU6Sb773AWKZaU66F/SZXW6+KrKZFUM2gjERtpfJl39+uZZ97eLZb9ebLKix76B8RBGp/1DG4AVcDgBiFGyc/Pdx9++GEoL1y+8847Li8vz3yNhFika9euodxX8+fPdwcddJD3eqPeeSPqX9G/+OKLQ1vPHXfcYX69EWKRhg0bus8++yyU+2rkyJHm6yMkxWFwA0nE4EYmDG4ASLPrZf8ctswvg7cQAAAgdT6Q/fc4i1zio3kJ9ZLsz491fhG4i4iTq2R/TVnn+4G7mFznyP78WOaM4C0EYoHBDQCVYnCDEMO0bt3abd68OZQXL59//nmXk5NjvkZCLHLzzTeHcl+9+uqrrnr16l5rzc3NdZMmTQql3soUFxe7wsLCSM5D165dXVlZWSjrmDFjBs84ksrUqlXLzZ07N5T7av78+a5GjRrmayQkxWFwA0nE4EYmDG4ASLMesn8OW+aZ4C0EAABInWtk/z3OIrN8NC+BCiVVyP78WGar+PulpMlTZtcJ62vLMvMCdzG5Jsj+/FhlgYf+AXHB4AaASjG4QYhxzj///FBevnTOud/+9rfm6yPEKi+//HIo99WYMWO815rE4Y2TTjrJlZaWhlL/Z5995urXr29+jRESdapXr+6mTp0ayn21fv16V1BQYL5GQlIeBjeQRAxuZMI/rANIswLZP4ctMz94CwEAAFInT9JG2X+Xs8jRHvqXNA/K/rxYZ2TgLiKOfiX7a8s63w7cxeRprnQPq10VvIVAbDC4AaBSDG4QEoPcfffdobyE6ZxzV111lfn6CLHIwQcf7JYuXRrKfXX33Xd7rzdJwxvt27d3GzZsCKXu7du3u2OPPdb8+iLEImPGjAnlvnLOuXPPPdd8fYQQBjeQSAxuZMLgBoC02y77Z7FVtkuqHryFAAAAqfM72X+Xs8hjPpqXIHUllcr+vFimQlKroI1ELDVQuv972UkaG7iLyXO/7M+LVdYqM7wJJAWDGwAqxeAGITFItWrV3IwZM0J5EXPXrl2uV69e5mskxCLHHXec2759eyj31tVXX+293iQMb7Rp08atWrUqtJp/8IMfmF9XhFjkV7/6VWj3FTt0ERKbMLiBJGJwIxMGNwCk3VzZP4stc1TwFgIAAKROC6XzF8e3S6rnoX9JcZPsz4l1xgfuIuLsj7K/xixTrswOE8jIV3p3nHKS7gzeQiBWGNwAUCkGNwiJSerXr+8+++yzUF7ILCsrc926dTNfIyEWGTBgQCj3lXPO9enTJ5SaX3zxxdBq3l1JSYk76qijvNTdokULt3LlytBqfeihh8yvJ0IsMmjQoNDuqzfffNNVq1bNfI2EEDkxuIFkYnAjEwY3AKTd07J/FlvmguAtBAAASKWXZP9dziI3+GheAlSTtEz258M6XYM2ErHWTvbXmHXuC9zF5LhW9ufDKjslNQneQiBWGNwAUCkGNwiJUTp06OC2bdsWyouZmzdvdh07djRfIyEW+ctf/hLKfbVt2zZ31llnhVLzuHHjQqm5MitXrnRt27YNVG/Dhg3dRx99FFqNr732mvl1RIhF+vfvH9p9tWbNGtekSRPzNRJC/hsGN5BEDG5kwuAGgLT7peyfxZa5PXgLAQAAUuls2X+Xs8jnknI89C/bXSr7c2Gd+YG7iGwwTfbXmmU2KbPTBKTFsj8fVnnaQ/+AuGFwA0ClGNwgJGa54IILQntBc/369d5+WZ+QbEpeXp5bsGBBKPfV9u3b3TnnnOO95tzcXDdp0qRQaq5McXHxAQ9v1K1b182bNy+02pYsWeIOOeQQ8+uIkKjTr18/V1FREcp9tW3bNnfKKaeYr5EQ8rUwuIEkYnAjEwY3AKTdRbJ/FltmcvAWAgAApNYi2X+fs0hPH83Lcm/J/jxY57LAXUQ2OE/215p1rgvcxex3juzPg2WOD95CIHYY3ABQKQY3CIlh/vd//zeUlzSdc2758uWuRYsW5mskJOoceeSRbtOmTaHdW3369Aml7ih33igpKXHt2rXbr/pq1arlZs2aFVpNmzdvdu3btze/fgiJOhdddJErLy8P5b4qLy93PXr0MF8jIeQbYXADScTgRiYMbgBIu2/J/llsmZLgLQQAAEita2X/fc4iaR/+PU3258A6RZKqBW0kskYaX+79ahaLnYYmyv48WOVND/0D4iiNz3YGN4AqYHCDkJjm+eefD+VlTeecW7x4sWvWrJn5GgmJOp07d3Y7d+4M5b7auXOn++53v+u95qh33li9enWVd96oXr26e/nll0OrpaKiwp133nnm1w0hUadPnz5u165dod1bV199tfkaCSGVhsENJBGDG5kwuAEg7fIk7ZL989gyBYG7CAAAkE75kjbK/vtc1KmQ1MJD/7LVWNmfA+vcGLiLyCb/I/trzjq9AncxexUq89y3PgdWuTR4C4FYYnADQKUY3CAkpqldu7b797//HdpLm0uXLnUFBQXm6yQk6nz/+98P7b5yzrlLL700lLrHjx8fat1ftWbNmirtvPHMM8+EWsfPf/5z8+uFkKjTo0eP0AbMnHNu2LBh5mskhOwxDG4giRjcyITBDQCQPpD989gyFwVvIQAAQGoNl/33OYv83kfzslBzSeWy779lNkmqG7SRyCp5yrzsan3tWebVwF3MXmn9c85JKpaUG7yFQCwxuAGgUgxuEBLjtGjRwq1atSq0lzeLiopcYWGh+ToJiTo33nhjaPeVc85dfvnlodQ9bty4UOv+qpKSkr0Ob7zwwguhfv5TTz1lfp0QEnW6d+/uysrKQruvxo4da75GQshew+AGkojBjUwY3AAA6UnZP48tc2/wFgIAAKRWa6Xzl8g3KvMyd9r8Tva9t05ah3bS7g7ZX3vWaRe4i9knrTtLfZGhwVsIxBaDGwAqxeAGITHPqaeeGtoLnM5lXs5u06aN+ToJiToPPfRQaPdVeXm569+/v/eac3Nz3aRJk0Kre3erV692bdu2/VoNtWvXdq+99lqon/vGG2+4mjVrml8jhESZs846K9T76rXXXjNfIyFkn2FwA0nE4EYmDG4AgDRY9s9jy7wevIUAAACpNln23+ksMsBH87JIvjK7TVj33TLlkpoFbSSyUmNJ22V/DVpmdOAuZp9rZd93q2yX1CB4C4HYYnADQKUY3CAkC9KnTx9XXl4e2sucxcXF33g5m5CkJycnx7300kuh3VcVFRWJG944+OCD3dtvvx3q5/373/92devWNb8+CIkyffv2dTt27OC+IoQwuIEkYnAjEwY3AED6tuyfx5bZGryFAAAAqdZD9t/pLPKBj+ZlkZ/KvufWeTZwF5HNHpf9NWiZNL7Iv1j2fbfKHz30D4gzBjcAVIrBDUKyJP379w/thU7nnFu1apU7/vjjzddJSNR54403Qr23BgwYEErdzz//fKh1f1VJSYnr0qWLmz9/fqif8+mnn7rDDjvM/JogJMr079/fVVRUhHZfLV++3DVp0sR8nYSQKoXBDSQRgxuZMLgBAJlfzi2X/TPZMu0DdxEAACC9ciQtkv13Oot08dC/bJCjdL/A/EWOC9pIZLV2sr8GrfOrwF3MHufKvt+W4e9JkHQMbgCoFIMbhGRR7rjjjtBe7HTOudLSUnfGGWeYr5OQKFO3bl23cOHCUO+tQYMGea876p03wrZ+/XrXunVr8+uBkChz5513hnpfbdq0iR21CMmuMLiBJGJwIxMGNwAg41+yfyZb5orgLQQAAEi1tO7GkJYdGC6Qfa+tMytwF5EEM2R/LVqmRFJu4C5mh4my77dVXvHQPyDuGNwAUCkGNwjJsowZMybUlzx37NjhLr74YvN1EhJlmjdv7lasWBHqvXXjjTeGUvuLL74Yat1ROeWUU8yvA0KiSk5Ojhs9enSo91Rpaak79dRTzddKCNmvMLiBJGJwIxMGNwAg43HZP5Mt81jwFgIAAKRavqRS2X+vizo7JTXx0L+4+7vse22dvoG7iCT4juyvRetcGbiL8VcoqUL2vbZK7+AtBGKPwQ0AlWJwg5AsS/Xq1d3UqVNDfdnTuXB2CCAkzmnbtq3btGlTqPfVY4895qpVq+a17mzfeWPXrl2uR48e5uefkKhSo0YNN378+FDvq23btrmuXbuar5UQst9hcANJxOBGJgxuAEDGtbJ/JltmUfAWAgAApN6Dsv9eZ5H/9dG8GOsg+x5bZ4mknKCNRCLkSFos+2vSMvMCdzH+hsu+z1ZZLJ53SAcGNwBUisENQrIwtWrVcrNnzw71pU/nnLv33nvN10pIlOnatavbunVrqPfV1KlTXZ06dbzXnq07b1xyySXm552QqJKfn+9mzpwZ6j1VVlbmzj77bPO1EkIOKAxuIIkY3MiEwQ0AyDhF9s9k6xwWuIsAAADp1lrp/IXyYkm5HvoXV2Nk32PrXBu4i0iSgbK/Jq3TLXAX4ytf0kbZ99gqPwveQiArMLgBoFIMbhCSpalTp4579913Q3350znnxo4d6/Ly8szXS0hU6dy5systLQ31vvrggw9cs2bNvNadbTtvlJeXu4suusj8fBMSVRo3buzmzp0b+r3Vs2dP87USQg44DG4giRjcyITBDQDIqCGpXPbPZcv8KHAXAQAA8LLsv9dZ5DIfzYuhxpJ2yr6/llknqXbQRiJR8pR5+dX62rTM+MBdjK/rZN9fq5QqM7gCpAGDGwAqxeAGIVmc+vXrRzK88eabb7r69eubr5eQqBLF8EZxcbE77rjjvNadm5vrXnjhhVDr9qG8vNz169fP/DwTElW+9a1vueXLl4d6X+3atctdcMEF5mslhAQKgxtIIgY3MmFwAwC+NFf2z2XL/CV4CwEAAFKvl+y/11lkto/mxdDdsu+tde4K3EUk0V2yvzYtUyGpMHAX42mx7PtrlREe+gdkCwY3AFSKwQ1Csjz169d38+fPD/VlUOecW7hwoSsoKDBfLyFRpXPnzm7r1q2h3lelpaWhvGg9duzYUOsOqn///ubnl5Co8p3vfCf0QbDy8nJ36aWXmq+VEBI4DG4giRjcyITBDQD40h9l/1y2zMrgLQQAAEi9HEmfy/67nUWO9tC/OGFXgcxuI42DNhKJxG400gOBuxg/58q+r1ZJ8jAOUBkGNwBUisENQhKQBg0auAULFoT6Uqhzzq1atcqdfPLJ5uslJKpEsfNGRUWFu+2227zWXb169VjuvFFRUcHQBklVbr31VldRURH6ffXDH/7QfK2EEC9hcANJxOBGJgxuAMCXfiT757J12gTuIgAAAIbI/nudRf7ko3kxMlD2PbXOE4G7iCR7UvbXqGVKJdUN3MV4mST7vlplgof+AdmEwQ0AlWJwg5CEpHHjxu7jjz8O9eVQ5zI7BPTu3dt8vYRElc6dO7vNmzeHfm/97W9/c7Vr1/Zae9x23hg0aJD5+SQkitSsWTOy+2/AgAHm6yWEeAuDG0giBjcyYXADAL50mOyfy9YZGLiLAAAAqKfMC73W3+2izvb/rD0JciQtln1PrdM2aCORaB1kf41aZ0jgLsZHoTK7Tlj31CpnBW8hkFUY3ABQKQY3CElQDjvsMPfBBx9E8qLovffea75eQqJKp06dIhnemDt3rjv88MO91R2XnTfKy8vdZZddZn4eCYkijRo1cm+++WYk99bgwYPN10sI8RoGN5BEDG5kwuAGAHxd2l/Oei54CwEAACBplOy/21nkRh/Ni4Gesu+ldV4O3EWkwWuyv1Yts0xStcBdjIcRsu+nVRZ46B+QbRjcAFApBjcISVgaNmzo5s+fH8kLo3PmzHHNmjUzXzMhUSSq4Y2SkhLXsWNHb3VbD2/s2LHD9erVy/z8ERJF2rVr5z7//PPQ76vy8nJ35ZVXmq+XEOI9DG4giRjcyITBDQD4uj/K/tlsmQ2SqgfuIgAAAI6W/Xc7i3yuzG4V2W667HtpnXMDdxFp0Fv216p1LgzcRXv5kjbKvpdWGRC8hUDWYXADQKUY3CAkgalXr577xz/+EfqLo845t3btWnf22Webr5mQKBLV8Mb27dvdj3/8Y291Ww1vbNmyxZ155pnm542QKPK9733Pbdq0KZJ764ILLjBfLyEklDC4gSRicCMTBjcA4Ot+IPtns3W6Be4iAAAAJOlV2X+3s8j5PppnqJ3se2idhYG7iLTIETtXzgrcRXvXyb6PVlkrKS94C4Gsw+AGgEoxuEFIQlO7dm33yiuvRPICaUVFhbvzzjtdtWrVzNdNSNjp1KmT27BhQyT31vPPP+/q1q3rrfaongnOObd+/Xp3yimnmJ8vQsJOXl6eGzVqVCT31ZYtW9zpp59uvmZCSGhhcANJxOBGJgxuAMDXHSb7Z7N17g/cRQAAAEhSX9l/t7PIVB/NM/Qn2ffQOlcF7iLS5FrZX7PW6RC4i3bSPnzzm+AtBLISgxsAKsXgBiEJTo0aNdz48eMjeZnUOefeeOMN17RpU/N1ExJ22rZt65YtWxbJffXxxx+7Y489NnDNN910k9uxY0ckNZeUlLh27dqZnydCwk7r1q3d+++/H8l9tWbNGnfCCSeYr5kQEmoY3EASMbiRCYMbAPBNafyHy69mSfAWAgAAQFI1SZ/L/vtd1KmQ1NpD/yw0kLRd9j20TImk3KCNRKrkS9ok+2vXMmMCd9HOebLvn1XKJTUJ3kIgK6Xx7z8Z3ACqgMENQlKQv/zlL5G8VOqcc2vXrnW9evUyXzMhYadp06Zu/vz5kd1bAwcOPKA6GzVq5KZOnRpZnYsWLXKtWrUyPz+EhJ1LLrnElZaWRnJfff755+7II480XzMhJPQwuIEkYnAjEwY3AOCbRsr++WydYwJ3EQAAAJJ0k+y/21lkuI/mGfiV7HtnnV8E7iLSaJjsr13L7JTUOHAXbUyWff+s8qyH/gHZisENAJVicIOQlOSuu+6K5OXSLzzwwAOuRo0a5usmJMzUrVvXvfrqq5HdV0899ZSrW7dulevr3r27Kykpiay+//u//3OHHnqo+XkhJMzUqlXLPf7445HdV5988gm7WRGSnjC4gSRicCMTBjcA4Jsukv3z2Tq3Bu4iAAAAJKme0rmDw0ZlfoU/m+Qps9uEde8ss1X8XREOTGNlhhesr2HL3BW4i9ErVGaXJOveWeW04C0EshaDGwAqxeAGISlK//793a5duyJ72XTevHmudevW5usmJOw8+eSTkd1XRUVF7qyzztpnTffcc09kNTnn3PTp012dOnXMzwUhYaZt27Zu4cKFkd1Xc+fOdQ0bNjRfNyEksjC4gSRicCMT/jEeAL6pgeyfz9Z5K3AXAQAA8IU/yv77nUWu8dG8CP1I9j2zzsjAXUSaPSX7a9gya5UZAMsmI2TfN6u856F/QDZjcANApRjcICRlOffcc93mzZsje+l08+bNbtCgQebrJiTs3HnnnZHdVxUVFe7hhx92tWvX/kYdBQUFbu7cuZHV4pxzY8eOddWrVzc/B4SEmWuuuSbS++qVV15xBx10kPm6CSGRhsENJBGDG5kwuAEAlZsv+2e0dRoF7iIAAAAk6WjZf7ezyAc+mhehNL7A+NVUSGoVuItIsw6yv46tMyBwF6OTr8zuSNY9s0q/4C0Esloav/cwuAFUAYMbhKQwxxxzjFu5cmWkL6C+/vrr7vDDDzdfOyFhpn///q68vDyy++rTTz91nTp1+u/n/+hHP3KbNm2K7POdc+6+++4z7zshYaagoMDNmjUr0vvq8ccfd7m5ueZrJ4REHgY3kEQMbmTC4AYAVO5e2T+jrZNNL5wAAADE3UzZf7+zSFcfzYtAd9n3yjrjA3cRkP4u+2vZMh8Gb2FkfiL7flmlWFJu8BYCWY3BDQCVYnCDkJSmefPm7v3334/0RdSNGze6/v37m6+dkDBz/vnnuy1btkR6b913333u2WefjfQznXNu8ODB5v0mJKzk5OS4wYMHR3o/79q1y/30pz81XzshxCwMbiCJGNzIhMENAKhcZ9k/o60zI3AXAQAA8IXvyf77nUXG+mheBCbJvlfW6RK4i4B0geyvZeucE7iL4cuRtFj2vbLKbcFbCGQ9BjcAVIrBDUJSnIMOOshNnDgxshdSvzBjxgzXpEkT8/UTElaOP/54t2rVqsjvrahs2LDBnXHGGeZ9JiSsFBYWun/84x+R3lfr1q3jviKEMLiBJGJwIxMGNwCgcjmSNsj+OW2ZCkmNgzYSAAAAkqRqyvzCt/V3vKhTLqmJh/6FqVCZ777WvbLM/MBdBDLSPhDgJE0J3MXwnSf7Plllu6QGwVsIZD0GN5BVqlkXAABpUFpaqt69e+u226IddD777LO1cOFCDRw4MNLPBaIyb948dezYUQsWLLAuxbu5c+fquOOO09///nfrUgDvqlWrpptuuknvv/++Tj311Mg+d9GiRTrxxBO5rwAAAACkjZM0wboIYzmSrrAuAgAAICEqJD1gXYSBapKusy5iH/6fMt9902yYdQFIDCdphHURxnooMxAWZz+1LsDQXyWtsy4CAIC4YscNQoiT5M477zy3ZcuWSH9d3Dnn3n77bXfccceZr5+QMHLQQQe5cePGRX5fheXpp592eXl55n0lJIy0adPGvffee5HfVzNmzHD16tUzXz8hJBZhxw0kETtuZMKOGwCwZxfJ/jltnXmBuwgAAIAvNFDml76tv+NFnbWScj30Lwx1JZXKvkeWKRI/Ygy/8iVtkv21bZlRgbsYnrTvMtQ+eAuBRGDHDWQVvqwCQMRefvllnXTSSVq8eHGkn3vKKado7ty5Gj58uOrUqRPpZwNhKy0t1fe+9z1df/312rVrl3U5B2zHjh269tpr1a9fP5WVlVmXA3iVn5+vu+66Sx9//LGOP/74SD/73nvv1TnnnKNNmzZF+rkAAAAAECNTJJVbF2Gsg6SjrYsAAABIiHWSnrEuwkADSZdYF7EH1ynzknma3a/MS9yAL1slPWJdhLErlBkMi6OfKb27DP1dmZfVAQDAHrDjBiHka6lXr56bNm1a5L847pxzRUVF7qKLLjLvASFh5Nvf/rYrLi42ubeCWL58uTv55JPN+0dIGOnXr58rKiqK/L4qKytz/fr1M18/ISR2YccNJBE7bmTCjhsAsHcvy/5ZbZ3fBu4iAAAAvnCC7L/fWWSOj+Z5liupRPa9scwmxfflcmS35sr8EIL1NW6Znwfuon/5SvcuQ98N3kIgMdhxA0ClGNwg5P+zd+fhVpV1/8ffDCIeBRJQQBkScMhSwuFxyCDLTM0ptMzKnl+mpmb6ZGmWTfZoNiioKORIiZY5p6DigPOUpoKGIJMyiECgzCBw1u+PhTwOBzicPXzXWvv9uq7PddAgP/s+e6+zOef+rtt8JM2aNUt+8pOfJCtXrqz6ZtYkSZKHHnoo6dWrV/g6GFPudOnSJXn66adDXldN8cgjjyRbbbVV+LoZU+7stttuyTPPPBPyupo1a1ay5557hq+BMSaTcXBDReTgRhoHNyRp/U4j/lodnenU7t04JUmSKuEJ4t/jRSRrJ7l9g/g1ic7FJa+itG5/I/45HpnppANiWVLL3+OYDjQvfQmlwnBwQ1KDHNwwxqwze++9dzJt2rSQja0rVqxILrjggqSuri58HYwpZ1q2bJkMGjQo5HXVWPX19cn555+fNG/ePHy9jClntt566+S6665L6uvrQ15bo0aNSjp27Bi+DsaYzMbBDRWRgxtpHNyQpPXbhvhrdRayf6kLKUmSpLWOIf79XUSuLcfildFLxK9JZFYD25a8itK69SH+eR6dr5e8iuXTDJhM/JpE5czSl1AqFAc3JDXIwQ1jzHrTrl27ZMSIESEbXJMkSd54441kwIAB4etgTLlzzDHHJEuXLg17ba3LO++8kxx88MHh62NMObPJJpskZ599drJw4cKQ19W7776bnHXWWeHrYIzJfBzcUBE5uJHGwQ1J2rAxxF+vo3NdyasoSdoYnwY2jy4hqWJaAm8R/x6v2lkOtC3D+pXDfsSvR3T+VvIqShtWqycMvZeXSl/CsjmI+PWIyhKgTelLKBWKgxuSGuTghjGmUTn99NNDNru+54EHHkh22mmn8HUwppz55Cc/mUyaNCn0tfV+Y8eOTbp37x6+LsaUM0cffXQyZcqUsNfV66+/nuy5557h62CMyUUc3FARObiRxsENSdqw84m/XkdnCVBX6kJKkhplR2AlMBs4Ddgkto6kCvkF8e/xInJWORavDG4jfi2is2vJqyht2ADin+vR2afkVSyPe4hfi6hcXob1k4rGwQ1JDXJwwxjT6PTp0yeZOHFi2ObXJEmS4cOHJ7179w5fC2PKlbZt2ybPPfdc6OsqSZJk5MiR4WthTDlz5JFHJi+99FLo6+qOO+5Itthii/C1MMbkJg5uqIgc3Ejj4IYkbdinib9eZyGnlbqQkqRGeYoPXn+nAN8CmkWWklR27UmHtKLf41U704i/nnUFVhO/Ftc5MtIAACAASURBVJF5rORVlBqnOTCd+Od8ZP5e8iqWridQT/xaRKR+zeOX9EEObkhqkIMbxpiNSl1dXTJs2LDQjbArV65Mrr32Wk8GMLlP3759kxEjRoS+nt6zevXq5Kabbkp23nnn8HUxppQcdthhyb/+9a/Q19PSpUuTk046KXwtjDG5i4MbKiIHN9I4uCFJjfMK8dfs6EwseRUlSRvybdZ9HR4LHBpXTVIFXE/8e7yIHFaOxSvBIOLXIDpHlLyKUuP9D/HP+cisJh0Yi3Qp8esQlXvKsH5SETm4IalBDm4YY5qUr33ta8k777wTujH23XffTa688spk2223DV8PYzYmu+yyS3LnnXeGvn7Wpb6+Prn55puTXXbZJXydjNmYHHLIIck///nP6JdQMn78+GTHHXcMXw9jTC7j4IaKyMGNNA5uSFLj/JT4a3YWsn+pCylJWqePAf9hw9fiJ4DPBHWUVF59iX9/F5FR5Vi8JmoDLFxHr1rJFOJPPVFtqcPX3R9KXsWmqwOWrKNXLeRLpS+hVEgObkhqkIMbxpgmp1u3bsnTTz8dvUc2effdd5Nhw4a5UdZkPjvvvHNy6623JvX19dEvmw2qr69Pbr31Vgc4TOZz4IEHZuJrUZIkyVVXXZW0bt06fE2MMbmNgxsqIgc30ji4IUmN0434a3YWcmupCylJWqer2bhr8t3Ap0KaSiqnZ4h/j1ft1AO9yrF4TfDDRnYsck4peRWljXcx8c/9yCwkHaCI8INGdixiJpdh/aSicnBDUoMc3DDGlJQWLVokv/rVr5JVq1ZF75dN6uvrkxEjRiT9+vULXxdj3p9PfvKTyS233BL9Emmy22+/Penbt2/4Ohrz/nzta19LnnrqqeiXR5IkSTJjxozkoIMOCl8TY0zu4+CGisjBjTQObkhS4z1O/HU7OquBzqUupCTpI/ah6dfl4cDHq19ZUpl8k/j3eBG5pByLt5GaA9Ob2LcomQ9sVupCSk3QlfR9S/RrIDLfL3kVN14z0uGF6McelZNLX0KpsBzckNQgBzeMMWXJvvvum0ycODF67+xaL774YnLssceGr4up3TRr1iw57LDDkgceeCD65VA2d955pwMcJjRt27ZNzjzzzGTq1KnRL4ckSZJk1apVycCBA5PNN988fG2MMYWIgxsqIgc30ji4IUmNdzLx1+0s5LxSF1KS9AEtgPGUdm1eAVwGbFXl7pJK1xJ4i/j3eNXOAqp/9/mjytQ9zzm/5FWUmu5m4l8DkZlMOkhRTQeVqXseE3nKiZQHDm5IapCDG8aYsqVVq1bJeeedl6xYsSJ6L+1akyZNSr7//e8ndXV14etjaiObb755cvrpp2dqkKncHn744eSrX/1q0rJly/D1NrWRHj16JJdcckmycOHC6Kf/Wi+++GLy6U9/OnxtjDGFioMbKiIHN9I4uCFJjbcl6fui6Gt3dGaRbjCUJJXH2ZTvGr0I+A3QpqqPQFKpziP+PV5Eqn0n9CfK2D2PWQlsXfIqSk23N/Gvg+h8ueRV3Dj3lLF73vKHMqyfVGQObkhqkIMbxpiyZ/vtt08ee+yx6D21HzBv3rzkggsuSDp37hy+PqaY6datWzJo0KBkwYIF0U/3qpk5c2by61//2teVqVj69euX3HHHHcnq1aujn+5rLVmyJPnxj3+cNG/ePHx9jDGFi4MbKiIHN9I4uCFJG+cu4q/dWci3S11ISRIAXYGllP86PRf4IdCqeg9FUgk6kW6qj36PV+38uxyL10h9Kvg48pLrSl5FqXTPEP9aiMyDpS9ho/UE6iv0OLKe1aTvsyWtm4Mbkhrk4IYxpmI5/vjjk3nz5kXvsf2AFStWJMOGDUt23nnn8PUxxcihhx6a3HnnndFP7XA333xz8vnPfz7882Hyn7q6uuT4449PXnzxxein9Ufce++9SY8ePcLXyBhT2Di4oSJycCONgxuStHGOIf7anYVMAJqVuJaSJLiPyl6v3wC+AzSv1gOS1GR/Jf49XkQ+V47Fa4RaXd/3Z8eSV1Eq3VeJfy1EZ6eSV7FxLqviY8pabi3D+klF5+CGpAY5uGGMqWg6duyY3HjjjdF7bRv01FNPJSeccELSrl278HUy+cq2226bnHfeecn06dOjn8aZM27cuOS0005L2rRpE/55MvnKfvvtl1x33XXJokWLop/GHzF79uzkG9/4RvgaGWMKHwc3VEQObqRxcEOSNs5mwELir99ZyJElrqUk1bqvUL1r9rg1/z1J2bUP8e/vIlKNzbVdqc0TTd6fUSWvolQezYHpxL8mInNtyau4YXXAkqDHl4V8tvQllArPwQ1JDXJwwxhTlfTr1y8ZP3589N7bBi1fvjy55ZZbksMOOyxp2bJl+FqZ7Oaoo45K7rnnnuinbC4sWbIkGTp0aLL33nuHf95MdtO5c+fknHPOSSZNmhT9lF2nIUOGOOBnjKlWHNxQETm4kcbBDUnaeH8h/vqdhTxX6kJKUg3bAphNzLW7fxUen6SmeYH493jVzmqgUzkWbz1+l4HHGZ0DS15FqXzOJP41EZnlQPuSV3H9fpCBxxmVF8uwflItcHBDUoMc3DDGVDXnnntu9B7c9Zo/f34ycODAZI899ghfK5ON9O3bN/ntb3+bzJkzJ/rpuU7z589Pli5dGl1jnaZOnZr88pe/THr27Bn++TTZyNFHH52MHDkyWbVqVfTTc50eeeSR5BOf+ET4WhljaioObqiIHNxI4+CGJG28/sRfv7OSL5S4lpJUq64m9vp9H/Dpij9KSRvrv4l/fxeR/y3H4q1DHZ6YN77kVZTKqw21fRpEAvyi5FVct2bA5Aw8xqh8u/QllGqCgxuSGuTghjGm6unWrVty3333Re/J3aBXX301Offcc5Nu3bqFr5mpbvr27ZtccMEFyWuvvRb9NNygwYMHJ+3bt0+6dOmSXH/99Ul9fX10pfV64oknku9973vJlltuGf55NtXNFltskXz729/O/PX/tddeSw455JDw9TLG1GQc3FARObiRxsENSWqaicRfw7OQh0pdSEmqQfsRf/1OgHrgJqBXZR+upI2wKemGsujrQ7UzD2hZhvVryKkZeHzR+U7JqyiV3yXEvzYiM5vKXfcOzsDji0olv55IRePghqQGObhhjAnL4Ycfnrz++uvRe3Q3qL6+PnnssceSE088MWnXrl34upnKZPfdd08uvPDCZNKkSdFPuUa55557kp122qnBx/HMM89E19ugFStWJLfffnvyla98JWnVqlX4599UJq1atUqOPPLI5Oabb870qTBJkiRz5sxJTjnllKRFixbh62aMqdk4uKEicnAjjYMbktQ0pxN/Dc9K9ihxLSWplmwGvE78tfv9WQkMBTpV8HFLarzzib8uROSb5Vi8D6n1u84nVHZzuFSKrsBq4l8jkanUyRD3ZuCxReXXZVg/qVY4uCGpQQ5uGGNCs+mmmyY//vGPk3nz5kXv2W2Ud999Nxk9enRy1llnJbvsskv4+pnScsABByQDBw5MpkyZEv3UarTx48cnBx544AYf2ze/+c1k1qxZ0XUbZcGCBclVV12VHHHEEckWW2wR/rwwpWXzzTdPjjjiiOSaa65JFixYEP302qDly5cnv//975M2bdqEr50xpubj4IaKyMGNNA5uSFLTtAWWE38dz0LuKHEtJamWZPnu0kuAC0m/xkmK04na3Mz8dDkW70MOzcDjis65Ja+iVDm3Ef8aicxLpS/hR/QkPVUt+rFFZCUOIksbw8ENSQ1ycMMYk4m0bds2+c1vfpMsWrQoeg/vRpk+fXpy9dVXJwMGDEjatm0bvo5m/enYsWPy3e9+N7ntttuSxYsXRz99Nsr8+fOTU089daMeb11dXXLOOeckCxcujK6/UZ588snkvPPOS/r16xf+nDGNyy677JKcddZZyYMPPhj99NkoN910U9KtW7fw9TPGmDVxcENF5OBGGgc3JKnpriP+Op6F1AM7lLiWklQL/ot8bKSbD5wNtK7MMkhqhJuJvxZEpG85Fu99HsrAY4rMUvy+j7LtM8S/TqLTv+RV/KDLMvCYonJ9GdZPqiUObkhqkIMbxphMpWPHjsmgQYOS5cuXR+/n3WgrV65MHn300eRnP/tZsttuuyXNmjULX09DssceeyQ///nPkyeffDL6KdJkl112WfKxj32syWuw5ZZbJhdddFGybNmy6Iey0ZYsWZKMHDky+eEPf5jsuuuu4c8nk6Zdu3bJUUcdlVxzzTXJ9OnTo58mG+3RRx9N9tlnn/B1NMaYD8XBDRWRgxtp/AG+JDXdfxF/Hc9KbilxLSWp6FoBE4m/Xm9MZgInAS0rsB6S1u+zxF8DIjKsHIu3xk4ZeDzRGVLyKkqV9xLxr5XIlPMEyzrSE9SiH1NUPl36Eko1xcENSQ1ycMMYk8l069Ytue6666L39pZk3rx5yU033ZR8/etfT9q3bx++prWQzTbbLPnCF76Q/PKXv0wefPDB3J2q8WHDhg1LevbsWbb16dSpU3LZZZdFP6ySzJ07N7npppuSk046KenTp0/4c65W0r59++Too49OLrnkkmTMmDHRT4Mme/jhh5O99947fD2NMWYdcXBDReTgRhoHNySpNK8Qfy3PSvYocS0lqcguIP463dRMAL4KNCv7qkhan38T//qvdpYD7cuxeKRDINGPJzL1wHYlr6JUeV8n/vUSmdVAz5JXMXV6Bh5PVB4vw/pJtcbBDUkNcnDDGJPpdO/ePRkyZEguT+B4v/r6+mTChAnJDTfckJxxxhnJvvvum7Ru3Tp8ffOerl27JkceeWRy8cUXJ//85z+jP81lc8UVVyRdu3at6OvqmmuuiX6YZbF48eLk4YcfTi644ILk0EMPTTp06BD+vCxCevXqlRx11FHJ4MGDk3HjxkV/mks2evRoBzaMMXmIgxsqIgc30ji4IUmlOZH4a3lW4kYJSWrYp4FVxF+nS83zwBfLvDaS1u144l/3EflJGdZua2BlBh5LZO4seRWl6mgJTCf+NROZS0pexXTAdnIGHktUji59CaWa4+CGcsU7SVRPB+A/0SUkaUM6derE2Wefzamnnkrr1q2j65TN2LFjee6553jppZd45ZVXGDNmDG+//XZ0rUzq0KEDe++9N3vsscfadO7cObpW2SxevJihQ4dy8cUXM3v27Kr8N7t06cLZZ5/NSSedRF1dXVX+m9UwdepUnnnmGZ599lmeeeYZXnjhBVauXBldK5Pq6uro06cPu+6669qPu+66K23atImuVhajR4/m3HPP5ZlnnomuIkmNsRJoFV1CKrPdSTce1br2gH/Rk6SmqwPmrvkoOAwYEV1CkjKkBTAW2Dm6SBk9CvwY/z4lVdqmwJuU7wSKvJgOfJz0xIimOg/4ZXnq5FY/HKxWfpwF/CG6RKClQGdgUQn/H4cAI8tTJ3dmAD0o7euGVIteBXaKLlFl80n3pCuHHNyoHgc3JOVKhw4dOOusszjllFNo27ZtdJ2KmDNnDi+//DLjxo3jlVdeYdy4cUyZMoU333wzulpV1NXVsdNOO7H99tuzww47sMcee7DbbrvRtWvX6GoVsWDBAgYOHMjll1/O/PnzQzp07NiR008/nTPOOKOwr6vXXnuNSZMm8e9//5tJkybx2muvMWHCBGbNmhVdrSo6d+7MDjvswA477EDv3r351Kc+xU477USvXr2iq1XEQw89xM9//nMHNiTljYMbKiIHN1IObkhS6S4Hvh9dIiMmkG5OdsOEJKV+DfwqukSF3Ab8DHgtuohUYL+jPCdQ5M0RwF1N/LO1OvDyfmOBPtElpI3QBniL2r4hwpnAoBL+/L3AQWXqkjc/obYHf6SmcnBDueLgRvU4uCEpl9q0acOJJ57IGWecQffu3aPrVMWyZcuYOnUqU6ZMYeLEibz++utMnDiRN998kzfffJO5c+dGV2y0Ll260K1bN+rq6th3333p3bs3vXr1Yscdd6RTp07R9api9uzZXHTRRQwdOpQlS5ZE1wHS19XJJ5/Mj370o5r5PCxdupRXXnmFyZMnM378eCZOnMjUqVOZO3cuc+bMYdGiUm66UV29e/emW7du9OjRgx49erDDDjvQq1cvPvWpT7H55ptH16uKBx98kJ/+9Kc8/7z7QyXlkoMbKiIHN1IObkhS6T4JvBJdIkOOB4ZFl5CkDNgNeA5oHl2kglYDfya9s31t3OFLqq5uwOsU+zrSkAeAA5v4Z78LXFPGLnl0LHBTdAlpI10G/CC6RKBSTo3oCUyiNve0luO0EqlWObihXKnFL3JRHNyQlHtHH300P/zhD9l3332jq4SbPn06M2fO5K233mLWrFm89dZbvP322x/IO++8w9tvv13ySQN1dXUfyWabbcYWW2xBp06d6NChAx06dGCrrbaiY8eOdOjQge7du7PddtuV6dHm07PPPsvQoUP5y1/+El1lvU4++WTOOussevbsGV0l1PLly9cOccyZM4e5c+fy5ptvMn/+fObMmcOsWbNYvHgxS5cuZcmSJSxZsoSlS5fyzjvvlPTfbdeu3Xqz5ZZb0rNnT7p370737t3p3LlzmR5x/ixdupS//vWvXHbZZbz88svRdSSpFA5uqIgc3Eg5uCFJ5fEg8IXoEhkxA9geWB5dRJICtQb+TbqRrhYsB64ALsC/X0jldjvwlegSAXoDk5vw52pxE+L7zQS64wl4yp9aHj54zwDgjib8ucHAaWXukhdXAidHl5ByqhbfMzm4kWO1/Aah2hzckFQYffv25cwzz+SYY45hk002ia4jfcCwYcO4/PLLeeGFF6KrbJSvf/3rnHvuuXzqU5+KrpJLCxYsWDvQsWTJEhYvXkzz5s3ZdNNNad269Uc+tmnTJrpybkycOJGhQ4dy7bXXsnDhwug6klQODm6oiBzcSDm4IUnl8UXg/ugSGXIO8PvoEpIU6Arg1OgSARYAfwQuAbJxnLeUf/sDo6NLBBgMnL6Rf8b35PAjYGB0CamJ7gSOiC4R6HGg30b+mbbALKCu/HVyYWfSzeeSNp6DG8oVBzeqx8ENSYXTuXNnTj75ZE4++WQ6deoUXUc1bNq0aVx++eVce+21zJ8/P7pOSQ499FBOOeUUDjnkkOgqqmH19fWMGDGCIUOGcP/995MkSXQlSSonBzdURA5upBzckKTyGQPsGl0iIxYBOwBvRReRpAD9gUeiSwSbDfwvcBXp9xQklebfpJtTa8lSYKs1HxvrHuDgytTJhUXAtms+SnnUD3g0ukSwT5N+b6GxziAdmK1F9wNfii4h5ZiDG8oVBzeqx8ENSYXVokULDj74YE466SQOOeQQWrRoEV1JNSBJEkaNGsUVV1zByJEjC7exvHPnzhx//PF85zvfoXfv3tF1VCPmzp3Ltddey5AhQ5g+fXp0HUmqFAc3VEQObqQc3JCk8jkGuCm6RIbcBBwbXUKSqmxL0g3WXaKLZMQU4BfA34Bi/UBCqq6TgCujSwT4PjCkkb93J2Actb2nayDpiRtSnr0E9IkuEWg48O1G/t5mwCSgZ+XqZNqXSQf2JDWNgxvKlVp+k19tDm5IqgmdO3fmxBNP5Lvf/S49evSIrqMCmjFjBn/5y18YNmwYkydPjq5TFf369eOEE07gq1/9Kq1bt46uowJ66qmnGDJkCDfeeGN0FUmqBgc3VEQObqQc3JCk8mlOumliu+giGfJ54OHoEpJURXcBh0WXyJgZpBsKPXlDaro6YBbQNrpIlU0GGnuntj8B36tgl6yrB7oDM6OLSCX6JnBDdIlAq0hPzpnTiN97CDCysnUyawrp1wcHg6Wmc3BDueLgRvU4uCGp5hx88MEcd9xxHHusN6NTad555x1uueUWhg8fzhNPPFG40zUaq02bNhx77LEcf/zx7LXXXtF1lHOvv/46w4cPZ9iwYUydOjW6jiRVk4MbKiIHN1IObkhSeZ1C4+8KXAumkP4Q2M26kmpBrW80XJcTgGujS0gFcBG1eZpCYwaB2wNvAptWvk5medqdiqIl6QDS1tFFAp1PemLZhtwHfKnCXbLqB8Dl0SWknHNwQ7ni4Eb1OLghqWZtscUWDBgwgG9961t8/vOfp0WLFtGVlAMrV67knnvu4YYbbuCuu+7i3Xffja6UKTvuuCMnnHACxx13HJ06dYquo5xYuHAht9xyC9dffz2PP/54zQ5BSap5Dm6oiBzcSDm4IUnl1QqYTm1vMvmwX5BuPJGkIusCjKf27oa/IVOB7YHV0UWkAugGvEHt7Vm6HThqA7/nXHy/2QcYG11CKpNzgAujSwSaD2wDrFjP7+lJeuJnrX1NAFgEdAaWRheRcs7BDeVKLX7Bi+LghiQBW2+9Nd/4xjf41re+xe677x5dRxn07LPPcsMNN3DjjTfy9tvuuWqMI444ggEDBnDkkUfStq0/S9MHrV69mvvvv5/rr7+eO+64gxUr1vd9MUmqCQ5uqIgc3Eg5uCFJ5efGsQ9aQbppd3p0EUmqoEeA/tElMuhY0rvASyqPu4DDoktUWT3pBubZ6/jfvTs/PA70iy4hlVF70r8/1kUXCXQicM16/vfBwGlV6pI1g4Azo0tIBeDghnLFwY3qcXBDkj5khx124Gtf+xoDBgygb9++0XUUaPTo0dx9993cfvvtTJs2LbpOrvXr14/DDz+co446io9//OPRdRTowQcfZNSoUQwfPpzZs9f1MwBJqkkObqiIHNxIObghSeW3Jenmsc2ii2TIvcAh0SUkqULOBn4fXSKDJlB7G4GkSjsAeCC6RIDfkg5HN+Q44PoqdsmiI4F/RJeQyuwK4NToEoHGA59Yx//WFphFbQ621AM9gBnRRaQCcHBDueLgRvU4uCFJ69G9e3e+8pWvMGDAAPbbbz+aN28eXUkVtHjxYu69915GjhzJHXfcwcKFC6MrFdKOO+7IYYcdxmGHHUa/ft6cpuiWLVvGfffdxx133MFdd93FggULoitJUlY5uKEicnAj5eCGJFXGxXgHyA/zruuSimhP4CnSO77rg44gPR1AUnlNAnpFl6iy+UAnYFUD/9tLQJ/q1smUqaTPhyS6iFRmPUmvd7W8T/NAGh7WOwO4pMpdsuJO4CvRJaSCcHBDuVLLbwiqzcENSWqkjh07csQRR3DUUUfRv39/6upqcbi+eGbOnMndd9/NnXfeyahRo6Lr1Jx27dpx0EEHMWDAAA466CDatm0bXUllMHv2bO6//35uu+02Ro0axfLly6MrSVIeOLihInJwI+XghiRVRmfSTVSto4tkyHzSO4bOiS4iSWXyMeAVYNvoIhn0POlQi6TyO5X0TvS15tvA8A/9u/7AIwFdsuRUYGh0CalC7gYOjS4R6B7gyx/6d81IB1p6Vr9OJuyP132pXBzcUK44uFE9Dm5IUhO0bNmSPfbYg8997nPsv//+fOYzn2HzzTePrqVGWLZsGU8++SSjR4/mwQcf5LnnnouupPfp168fhxxyCAcccAC77757dB010uzZs3nkkUfWZvz48dGVJCmPHNxQETm4kXJwQ5Iq5yLgR9ElMmYktb3xRlKx3AscFF0iow4AHoouIRVUHTALqLW7jf0T2OtD/+5O0tN9atXbpMODy6KLSBWyPzA6ukSgBOgNTHnfv/syMCKmTrhXgZ2jS0gF4uCGcsXBjepxcEOSymSfffZh//33p1+/fvTv35/Wrb3ZX1Y89thjPPzwwzz88MM8+uij0XXUSO3ataN///588YtfpH///uyyyy7RlbTGjBkzePLJJx3UkKTycnBDReTgRsrBDUmqnA7AG4B3VPmg44AboktIUolOBy6NLpFRTwCfjS4hFdwlwBnRJQLsBry45tc9Se86X8t7uC4Afh5dQqqwl4A+0SUCDSU9Wec99wFfCuoS7bvAddElpAJxcEO5Ustv+qvNwQ1JqoAWLVqw55570r9/f/r3789+++1HmzZtomvVjOeee46HHnqI0aNH88QTT7BsmTdBKYKtt96a/v37s/fee7PPPvuwzz77RFeqCUuWLOH555/n6aefXpu5c+dG15KkInJwQ0Xk4EbKwQ1JqqzzgXOjS2TMAmAHYE50EUlqoj7Ac8Am0UUyak/8u5ZUab2AidTe/qW/AP9vza8vA34Q2CXaKtLTNnxPraL7Nulrv1YtI32tvw1sD7wWWyfMfGAbYEV0EalAHNxQrtTaX3wiObghSVXyX//1X/Tv35/Pfvaz7LHHHnTp0iW6Uu4tW7aMF198keeff55x48YxZswYXnrpJZYvXx5dTVWy1157sddee7Hvvvuy2267sf3220dXyrX3XlP/+te/ePnll3n22WcZO3ZsdC1JqhUObqiIHNxIObghSZXVjvTUjXbRRTJmJHBodAlJaoI2wFjg49FFMsrru1Q9I4FDoktU2QrSjbsrgbeAutg6oYYBx0eXkKqgJTAT2Dq6SKBzgN8DlwPfD+4SxROGpPJzcEO54uBG9Ti4IUlBttxyS3bbbTf69OlDnz592HXXXdl5551p1cr9eg2ZNm3a2sGMMWPGMGbMGCZPnkySJNHVlCGtW7dm1113Xfuaeu9ju3bu3Xi/JEmYOnUqY8eOZcyYMWs/TpkyxdeUJMVxcENF5OBGysENSaq8c0lP3tAH/T9q+86pkvLpTuCI6BIZtivwcnQJqUZ8CbgvukSAc4DVwB+jiwTbCZgQXUKqkp+RbtyvVTOAXUgHWGp1YK0zMDu6hFQwDm4oVxzcqB4HNyQpY/r27UvPnj3p0aPH2nTv3p0ePXrQvn376HoVU19fz/Tp05k8eTKTJ09m0qRJa389ceJElixZEl1ROdalSxe23357evfuzfbbb782vXv3pq6uuN97WbBgAa+99hoTJkzgtddeW/vrCRMmsGzZsuh6kqQPcnBDReTgRsrBDUmqvM1JT93wB4MftAD4JOnmE0nKg5OAK6NLZNgNwHHRJaQaMwHYIbpElb1Bum+re3SRTbSfQAAAIABJREFUQPcBB0eXkKqoAzAd2Cy6SKCHgf2jSwS5Gzg8uoRUQA5uKFcc3KgeBzckKUdat25Nr1696Nq1K9ttt93aj927d1+bLJs5cybTpk1j2rRpvP7668ycOZNJkyYxdepUxo8fH11PNWqrrbaia9eudO7cmR49erDNNtvQrVu3tR+33XZb2rZtG12zQUuWLGHatGm88cYba19X06dPZ+rUqUyaNInZs70phiTliIMbKiIHN1IObkhSdfwIuCi6RAY9CfQD6qOLSNIG9AWeBjaNLpJRK4DtgFnRRaQaczpwaXQJVd2XgPujS0hV9ifge9ElFOIA4KHoElIBvUJ6Q5Va4uBGjjm4UT0ObkhSwXTv3p1u3brRoUMH2rVrt85stlnTb5aQJAnLly9n6dKlH8iyZctYsGAB8+bN4z//+Q9z585l/vz5a38t5VVdXR3du3dn2223pWvXrmyzzTZrX0cNpXnz5k3+b9XX17No0SIWLFjAggULmD9/PosXL177z//5z3+YP38+06ZNY968eWV8lJKkYA5uqIgc3Eg5uCFJ1dEamAp0ji6SQecDv4guIUnr0Z50U0uX6CIZdh7w6+gSUg2qA+au+ajaMIHauzu2BOnzfhzu26w1rwI7R5eQCsoTN5QrvgGoHgc3JEmSJEmK5+CGisjBjZSDG5JUPd8HLo8ukUEJ8AXg4egiktSAFsAjwH7RRTJsFulpGyuii0g16nLS95mqDd8B/hxdQgoyEjgkuoSq6iTg6ugSUkE5uKFcafotiiVJkiRJkiRJklSLrgamR5fIoGbALUCn6CKS1IBBOLSxIT/BoQ0p0qDoAqqaOcAN0SWkQF7vast84ProEpKkbHBwQ5IkSZIkSZIkSRvjXeCn0SUyqgNwG/4MTlK2HAP8ILpExr0EDI8uIdW4ycD90SVUFZcBq6JLSIEeBMZHl1DVXIXDwZKkNfymsSRJkiRJkiRJkjbWjcAz0SUy6jPAb6NLSNIafYG/RJfIgZOjC0gCYHB0AVXcMmBIdAkpA/4QXUBVUQ9cEl1CkpQdDm5IkiRJkiRJkiSpKU6NLpBhPwEOii4hqea1B0YCm0YXybi/A89Gl5AEpNes6dElVFHDgLejS0gZ8FdgTnQJVdytwOzoEpKk7HBwQ5IkSZIkSZIkSU3xIvDn6BIZ9ndgu+gSkmpWC+AfQJfoIhm3Ajg7uoSktRK8M3mRJcBF0SWkjFgBXBFdQhV3aXQBSVK2OLghSZIkSZIkSZKkpjobWBpdIqPaAvet+ShJ1XYtsF90iRy4GJgWXULSB1yD7y+L6i5ganQJKUMuJx3gUDG9BDwVXUKSlC0ObkiSJEmSJEmSJKmp5gK/iS6RYTsAd+LP5CRV17nAf0eXyIG5wAXRJSR9xELg+ugSqoiLowtIGTMfGB5dQhXjNU+S9BF+k1iSJEmSJEmSJEmlGAi8EV0iw/YHBkWXkFQzjgHOjy6RE+fgXf2lrBocXUBlNxZ4PLqElEFu7i+m2cBN0SUkSdnj4IYkSZIkSZIkSZJKsRI4I7pExp0OfCu6hKTC64d3bW6sF4Fh0SUkrdM4YHR0CZXVhdEFpIwaD4yKLqGyGwKsii4hScoeBzckSZIkSZIkSZJUqn8Aj0aXyLjrgM9El5BUWDsBdwObRBfJgdXAcUASXUTSennqRnHMBG6OLiFlmCc0FssK4PLoEpKkbHJwQ5IkSZIkSZIkSeVwKulmWDVsE9JN1d2ii0gqnI7Ag0Db6CI5cRHw7+gSkjboLmB6dAmVxUCgPrqElGGjSE/eUDH8DZgfXUKSlE0ObkiSJEmSJEmSJKkcxgGXRJfIuC2BB4AO0UUkFcZmpJv9to0ukhOvA+dFl5DUKPV46kYRLAKuji4h5cDF0QVUNpdGF5AkZZeDG5IkSZIkSZIkSSqXXwAzoktk3I6kwxubRxeRlHutSO9Iv1t0kRz5b2BZdAlJjXYlsCK6hEpyFenwhqT1G46nNBTBY8BL0SUkSdnl4IYkSZIkSZIkSZLKZRlwQnSJHOhLutm6VXQRSbnVErgDOCC6SI7cRLqZTlJ+LCTdzKx8qgcGRZeQcmIFcHl0CZXM0zYkSevl4IYkSZIkSZIkSZLKaRRwQ3SJHPg8cAv+vE7SxmtOev04JLpIjiwATosuIalJ3PifXzcDM6NLSDlyBZ4ylGczgDujS0iSss1vBEuSJEmSJEmSJKnc/geYF10iBw4HroouISlXmgF/Bo6MLpIzZ+PXJSmvxuFpOXl1YXQBKWfmAH+NLqEmu5T0pCFJktbJwQ1JkiRJkiRJkiSV2zzgh9ElcuK7wG+jS0jKjSuB46JL5MyzOCQn5d3g6ALaaI8BY6NLSDn0h+gCapKlpO/TJUlaLwc3JEmSJEmSJEmSVAnDgUeiS+TET4HvR5eQlHmDgROjS+TMKhx0kYrgdmB2dAltlIHRBaScGg88GF1CG+0vwKLoEpKk7HNwQ5IkSZIkSZIkSZVyPLAsukROXE66XpLUkF8Bp0WXyKHfAxOjS0gqWT1waXQJNdpU4K7oElKODYouoI2SABdFl5Ak5YODG5IkSZIkSZIkSaqUqaSbjdU41+DwhqSPuhD4dXSJHJoA/Ca6hKSyuRJYEV1CjfJH0o3MkprmXmBKdAk12v34+ZIkNZKDG5IkSZIkSZIkSaqkgcAr0SVyohnp8MY3o4tIyoTmwA3AOdFFcmgV8FXg3egikspmPvC36BLaoLeBP0eXkHIuAf4QXUKN5olQkqRGc3BDkiRJkiRJkiRJlbSadBDBzbON0wwYDpwYXURSqE2BETjI1VS/Bl6OLiGp7C6LLqANGgIsiy4hFcCfSQfWlG1TgPuiS0iS8sPBDUmSJEmSJEmSJFXaWODn0SVypBlwFXBadBFJIdoADwMHRxfJqReAC6NLSKqIF4Gnoktond7F4RqpXFYAQ6NLaIMGkp6QIklSozi4IUmSJEmSJEmSpGq4CDfabazBwF+jS0iqqq2Ap4F9oovk1HLgq0B9dBFJFeNgQHbdCMyJLiEVyGXAqugSWqdFwLDoEpKkfHFwQ5IkSZIkSZIkSdWQAMcCC6OL5MyxwCOkd+CXVGw7Av8EPhldJMd+BEyJLiGpom4DZkeXUIN+H11AKpg5OMifZVcDS6NLSJLyxcENSZIkSZIkSZIkVcs04AfRJXKoP+kd+DtHF5FUMQcDzwEfjy6SY48CQ6JLSKq4VcAV0SX0EaOACdElpAIaGF1ADaoHBkWXkCTlj4MbkiRJkiRJkiRJqqbrgX9El8ihT5Ju6u4VXURSWTUHfgfcgyfrlGIh6QlFkmrDFaQDHMoON5dLlTEGeDi6hD7iH8CM6BKSpPxxcEOSJEmSJEmSJEnV9h1gbnSJHOoK/BPYI7qIpLJoD4wGfhJdpABOBmZFl5BUNfOBm6JLaK0JwP3RJaQC82SH7Lk0uoAkKZ8c3JAkSZIkSZIkSVK1vQ0cF10ip9oDjwMHRxeRVJK+wFigf3SRArgb+Ft0CUlV5wkP2fG76AJSwY0ApkSX0FqvAo9Gl5Ak5ZODG5IkSZIkSZIkSYowChgSXSKnWpNu3jk+uoikJjkFeAbYNrpIAbwBfDu6hKQQLwLPRpcQc4AboktIBZcAF0eX0Fp/jC4gScovBzckSZIkSZIkSZIU5UfA5OgSOdUcuBb4dXQRSY22KXAj6dBaq+AuRbASOBx4J7qIpDCDowuIy4BV0SWkGvBnYFF0CTEf+Gt0CUlSfjm4IUmSJEmSJEmSpCjLgaPWfFTT/Ir0Lsf+3E/Ktu7Ac8A3oosUyJnA2OgSkkL9HZgdXaKGLcMT9KRqWQpcEV1CDAFWRJeQJOWX38CVJEmSJEmSJElSpDHAGdElcu6bwAigdXQRSQ06gHTAYJfoIgVyN3B5dAlJ4VYBV0aXqGHDgLejS0g1ZBCecBNpFb7/lCSVyMENSZIkSZIkSZIkRbsKuDm6RM4dDDwOtI8uImmtZsBvgPuBdsFdimQSnlwi6f8MwY3MERLgougSUo2ZQ3rSkGLcjKc8SZJK5OCGJEmSJEmSJEmSsuA7pJtx1XR7AC8Be0cXkUQ70oGNX5AOcKg8VgCHA4uji0jKjNnALdElatBdwNToElIN+mN0gRrm2kuSSubghiRJkiRJkiRJkrJgKXDEmo9qum6kJ2/8DH8WKEUZAIwDDoguUkA/AF6NLiEpcwZHF6hBF0cXkGrUGOCx6BI16BnSmyRIklQSv1krSZIkSZIkSZKkrBhHevKGStMSuAB4FOgU3EWqJV2AEcBtwDbBXYroVuDq6BKSMulp4MXoEjVkLOmgsKQYg6IL1KBLowtIkorBwQ1JkiRJkiRJkiRlyc3AVdElCmI/4BXgwOgiUsE1A04FxgNfDu5SVJOA/44uISnT3FRbPb+NLiDVuH8AU6JL1JDZpAPEkiSVzMENSZIkSZIkSZIkZc0ZwJjoEgXRERgFDAQ2Ce4iFdEngKeAK4C2wV2Kailw+JqPkrQuNwHzo0vUgJnALdElpBqXAJdEl6ghlwGroktIkorBwQ1JkiRJkiRJkiRlzXLgSGBRdJEC+SHwHNAruohUEK2A3wAvAXsHdym6Y4BXo0tIyrwVwJ+iS9SAgUB9dAlJXIt/X64Gv7ZIksrKwQ1JkiRJkiRJkiRl0evAcdElCqYP6SZz11Uqzd7AK8AvSAc4VDm/AEZEl5CUG5fhUEElLQKuji4hCUhPInOgoPJuwNOcJEll5OCGJEmSJEmSJEmSsuofwO+iSxTMFsD1wN/X/FpS47UDrgSeArYP7lILbgPOjy4hKVdmk147VBlX4R3+pSxxWK3yLo4uIEkqFgc3JEmSJEmSJEmSlGU/A+6NLlFAXwNeJj2FQ9KGHQ28CpwENAvuUgueB74ZXUJSLg2OLlBQ9cCg6BKSPmAGcHN0iQIbTfr+X5KksnFwQ5IkSZIkSZIkSVmWkA4ZTIguUkAfB54DzowuImVYF2AEcMuaX6vyZgAHAyuii0jKpceBcdElCuhmYGZ0CUkf4QmVlXNpdAFJUvE4uCFJkiRJkiRJkqSsWwwcAsyPLlJAmwAXA8/g6RvS+30MuBCYCHw5uEstWQIcCPwnuoikXBsYXaCALowuIKlBY4Ano0sU0Azg7ugSkqTicXBDkiRJkiRJkiRJeTAFOAJYHV2koPYCXgD+BLQP7iJF2gL4FfAGcA6weWydmlIPfAV4NbqIpNy7AQd+y+kxYGx0CUnrNCi6QAFdTHr6pyRJZeXghiRJkiRJkiRJkvLiCeDU6BIF1hz4HjAJ+D7QIraOVFWbAWcDrwO/BtrG1qlJZwEPRJeQVAgrgKujSxTIxdEFJK3XHaQnRKg8lgLXRpeQJBWTgxuSJEmSJEmSJEnKk6uAodElCm5L4HLgFeAzwV2kSmsFnE56qs/vgQ6xdWrWMGBgdAlJhXIF6Uk+Ks1U4O7oEpLWqx4HrMrpWmBRdAlJUjE5uCFJkiRJkiRJkqS8+QHp6RuqrJ1I1/lvQJfgLlK5tQROJD1h5lKgc2ydmnY/6edCksppOvCP6BIF8EcgiS4haYOuwmGDckiAS6JLSJKKy8ENSZIkSZIkSZIk5c1q4AjSO+Sr8r5Ourn9Z8CmwV2kUjUHjgPGk25w6xZbp+Y9RXo9Xx1dRFIhDY4ukHNvA3+OLiGpUZYCV0eXKIB78PsMkqQKcnBDkiRJkiRJkiRJeTQfOAzvKlotdcAFwKukm6ylPBoAvAJcD/QK7iIYAxwELI8uIqmwHgbGRZfIsSuAZdElJDXaIKA+ukTOXRpdQJJUbA5uSJIkSZIkSZIkKa/G4abfatsOuBN4ENg+uIvUWF8GXgBuAz4R3EWpKcAXcPhOUuVdFl0gp97FE0ukvJlB+n5XTfMq8EB0CUlSsTm4IUmSJEmSJEmSpDx7ivQEiFXRRWrMF0gHZ64HdgzuIjVkM+BkYCwwAugbW0fv8ybwOWBedBFJNWE4sDC6RA7dCMyJLiFpow2MLpBjnrYhSao4BzckSZIkSZIkSZKUd/cDXwfqo4vUmJbAccB4YCTw2dg6EpCeBHMpMAsYCuwSW0cfMg/YH5geXURSzVgKXB1dIod+H11AUpM8AzwbXSKHFgF/ji4hSSo+BzckSZIkSZIkSZJUBLcB340uUcMOAR4DniY9AaVZbB3VmBbAV4AHgAnA6UC70EZqyFLS03peiy4iqeZcCiTRJXJkFOnXU0n55KkbG28osCK6hCSp+BzckCRJkiRJkiRJUlH8Gfif6BI1bm/gTmAc8B1gk9g6KriOwLnAVOB24AAcGsqqd4EvA2Oii0iqSdOBEdElcsRN31K+3QrMiC6RI/XA4OgSkqTa4OCGJEmSJEmSJEmSiuRS4LfRJcROwHXA68CPgS1i66hg9gVuBGYC5wPdYutoA1YDRwGPRBeRVNPclNs4E4D7o0tIKkk9cEl0iRy5HQddJElV4uCGJEmSJEmSJEmSiuZc4E/RJQTANsAfSTfC/BbYKraOcqw1cALwAvAk8A2gVWgjNcYq0qEN73QvKdoDwOToEjnwu+gCksriKmBpdImcuDS6gCSpdji4IUmSJEmSJEmSpCI6FfhbdAmt1Q74KTAHuBboHVtHObIT6V3S3wKuBvrG1tFGWAEcDvwjuogkrTEwukDGzQFuiC4hqSwWkb531vq9BDwRXUKSVDsc3JAkSZIkSZIkSVIRJcBxeJf3LDoeeA14BPge0D62jjKoL/C/wL+BV4HTSId/lB/LgC8C90YXkaT3+TOwMLpEhl1KelKSpGK4CKiPLpFxDvRJkqrKwQ1JkiRJkiRJkiQV1WrgKOCp6CL6iGZAf+BPwGzgHtJBmzaRpRRqb+CPwGTgBeDnwM6hjdRUC4HPA49HF5GkD1kKDIsukVHLgKHRJSSV1QzgzugSGTYbT+mUJFWZgxuSJEmSJEmSJEkqsneBg4Ax0UW0Ti2Bg4HrgTnAraQDN60jS6nimgOfAwaTbip7Gvgx0DOylEr2DvBZ4JnoIpK0DoNJT2bTBw0D3o4uIansPFFi3YbiKUOSpCprFl2ghnQA/hNdQpIkSZKkGrcSaBVdQiqz3YHno0tIUoU9AuwfXUK514H05I0doouo0RaR3iH2b8ADuKmmCFoCBwADgCOBrWLrqMzmkH69HhddRJI24B7SoVGlEqAXMDW6iKSKeAnoE10iY1YBXUlP3ZCUb68CO0WXqLL5pN/nVA554oYkSZIkSZIkSZJqwTzSDcXTo4uo0doAx5FurnwL+BPQH3/GmTebkg5pXA/MBe4FTsShjaJ5E9gbhzYk5cPg6AIZ8w8c2pCK7HfRBTLorzi0IUkK4Ikb1eOJG5IkSZIkxfPEDRWRJ25IqgWeuKFy6gk8DWwdXURN9ibwd9KTOJ4L7qKPagt8BthvTf4LaB3aSJU2FfgcMC26iCQ1UjNgIukpE4J+wOPRJSRVTEvS92tdo4tkSF/Sk0gk5Z8nbihXvBuNJEmSJEmSJEmSaskUYF/gjegiarJtgB8C/yS9S+odwFmkwwKbBvaqVdsAxwJXAGOAt0lPSfkZ6UZQhzaK7V/APji0ISlfEuCy6BIZMRaHNqSiW4UnDb3fEzi0IUkK4okb1eOJG5IkSZIkxfPEDRWRJ25IqgWeuKFK2Aq4H/h0dBGV1bvAC8BTa/Ik8FZoo2JpBnyK/ztNYz+ge2gjRRoBfBVYHl1EkpqgLTALqIsuEuzrpCeZSSq2NqR/L6r1ax6k719vjS4hqWw8cUO54uBG9Ti4IUmSJElSPAc3VEQObkiqBQ5uqFLqgH8AB0QXUUW9zv8NcjxFemfp1aGN8mNTYE/SAY3Pkp5W87HQRsqKgcCPSe9aL0l5dTnw/egSgWaSDmDWRxeRVBWDgdOiSwSbAfTA655UJA5uKFdaRheQJEmSJEmSJEmSgiwFDgL+RnrXTRXTx9fkG2v+eQUwGZi4Jq+979dvUnsb0VuQrs/270vvNR8/jj9T1getBk4Bro4uIkllMIjaHtwYiJuXpVry3jWvlm/2PRive5KkQH6TTZIkSZIkSZIkSbVsNfA14HfAT4K7qDo2BXZekw9bCkyi4aGO2dUqWAHNSe8s++HBjO2B7YBN4qopRxYDhwMPRxeRpDKZDNwPHBhdJMAiHMKTas0U4C7giOgiQZYCQ6NLSJJqm4MbkiRJkiRJkiRJEpwDvAFcQW3fgbTW1QG7rsmHLaLhgY6JwLxqFVyPZkB3PjiU8V56Aq3iqqkAZpJubB4XXUSSymwwtTm4cRXpextJtWUgtTu4MRyve5KkYA5uSJIkSZIkSZKkrKuPLqCaMRT4D3BzdBFlUhtgtzVpyDukJxIsWfNx0Zpfv/fPi4GFwLL3/fN7v38psAWw+YeyGdC2gX//4bz3Z6VKGEu6qTnPp85I0rqMBKYD3aKLVFE9MCi6hKQQjwFjgD7RRQJcGl1AkiQHNyRJkiRJkiRJUtY1jy6gmnILsC8winSjvtRYH1sTqUhGAMeQDhdJUhElwCXAxdFFquhm0pOUJNWmPwI3RJeosgeAV6NLSJLkDzokSZIkSZIkSZKkD3oa2Ad4K7qIJAUaBByOQxuSiu8aautad2F0AUmh/g7MiS5RZZ62IUnKBAc3JEmSJEmSJEmSpI/6N7AnMCG6iCRV2TLgm8CZpHeil6SiWwgMjy5RJY8BY6NLSAq1inRAt1ZMAe6JLiFJEji4IUmSJEmSJEmSJK3LDGAv0hM4JKkWTAR2B/4aXUSSquyy6AJVcnF0AUmZcBW1c9LQIBxGliRlhIMbkiT9//buPdb2s67z+BuiTmQijjc0UrkHC1GUi2LGwngbNI4JzkTB6B/6h86ETCJeiBovHZABsfTCOaelVUFggCpQJbTxUq1SVBCJ2hYtbbm0Iq29ALuU2pZz6Tnzx2+f9HjsZV/WWs9aa79eyS9rn52znudzTk5+Jyv793m+AAAAAAAP7I7q26t3jQ4CMGcXVU+vrhkdBGCAD1V/PjrEnN1QXTI6BLAUNqo3jQ6xAHdWvz06BAAcp7gBAAAAAAAAD+5g9d+r/1MdHZwFYNYOVy+ufrC6a3AWgJEOjA4wZ6/OqfPAfc5s/e8Jr2vvTBYBYAUobgAAAAAAAMBDO1b9avUd1S2DswDMyk3VadX+0UEAlsDF1SdGh5iT26vXjw4BLJXrqz8YHWKOjlVnjw4BACdS3AAAAAAAAICte0/1tM1XgFV2WdP97AOjgwAsiaPVuaNDzMl51aHRIYCls87FhourG0eHAIATKW4AAAAAAADA9nyyafLGy5oe8ANYJUer06vnVRuDswAsmwuqg6NDzNih6sDoEMBSend11egQc7JvdAAAOJniBgAAAAAAAGzf0eqlTQWOTw7OArBVx4tnL6+ODc4CsIw+W715dIgZe2t12+gQwNJax6kb1zSVUgBgqShuAAAAAAAAwM69p3ra5ivAMntf7lcAW3HO6AAz9uujAwBL7cLWr9x11ugAAHB/FDcAAAAAAABgd27pvhPsjw7OAnCyQ9WvVM9pul8B8OA+VP3F6BAzcml13egQwFI7Uu0fHWKGNqq3jA4BAPdHcQMAAAAAAAB272h1evXd1ScHZwE47qrqGdX/TbEMYDsOjA4wI06dB7bi/Org6BAzckHr82cBYM0obgAAAAAAAMDsXFY9rXrf6CDAnna4emn1rOrqwVkAVtHvV7eODrFL11V/OjoEsBI2qjeODjED6zY9BIA1o7gBAAAAAAAAs3VL9dzqFdWxwVmAvefq6unVy5oeXgNg+462+g//vmp0AGClvKbV//x6UatfugNgjSluAAAAAAAAwOzdW/1y9bym00sB5u1I9fKm0oYpGwC7d0F1cHSIHbqtesvoEMBKubb649Ehdmnf6AAA8GAUNwAAAAAAAGB+LqueUl04Ogiw1q6unlWdXh0enAVgXWxUvzM6xA7ty9QlYPvOHh1gF66s3j86BAA8GMUNAAAAAAAAmK/bqh+pvrv6+OAswHq5t3pl05SNqwZnAVhH+0cH2IF7qvNHhwBW0mVNkzdW0atHBwCAh6K4AQAAAAAAAIvxJ03TN34tJyADu3dd9ezqlzJlA2BerqjeNzrENr2hun10CGBlnTE6wA7cWr19dAgAeCiKGwAAAAAAALA491S/WD2j+tvBWYDVdHdTWePrq78bnAVgLzgwOsA2HKvOHB0CWGkXNk2NXCUHcjgCACtAcQMAAAAAAAAW7x+qb65eVN0xOAuwOn6velL1ykzZAFiUi5pOc18F76puGB0CWGkHq/NGh9iGg9X5o0MAwFYobgAAAAAAAMAYx6oLqqdU7xicBVhuH6m+rfqB6ubBWQD2miOtzkPMZ40OAKyFc5sKEavgrdXG6BAAsBWKGwAAAAAAADDWzdULqu+rbhycBVgu/1r9QvXU6j2DswDsZec1FTiW2QervxodAlgLG9WbR4fYojNHBwCArVLcAAAAAAAAgOXwB9WpTScl3zs4CzDe26onV7/e8j8sDLDuNqrfHR3iIbxydABgrazCBJ/Lq2tGhwCArVLcAAAAAAAAgOVxV/WS6lnVlYOzAGN8pDqt+qGmiTwALIezRwd4EDdV7xgdAlgr11aXjg7xEPaNDgAA26G4AQAAAAAALLujowPAAFdWT6/+R3Xd4CzAYnyg+p6mKRvvHZwFgH/viqZ79TI6K5+bgNk7Z3SAB3FjdfHoEACwHYobAAAAAADAsvPzDPayd1ZfV72ounVwFmA+rqqeXz275T/VGGCv2z86wP24s3rd6BDAWrq0afLGMjonhTUAVowfdAAAAAAAAMByO1JdUD2xell119g4wIxcU72wabqO04IBVsPbqo3RIU7ym03lDYB5OGt0gPtxd/Vbo0MAwHYpbgAAAAAAAMBquKt6afX4piLHkbFxgB36WPWjTdN03l4dGxsHgG04Up07OsQJjjadOg8wL29u+Qprb0hhDYAVpLgBAAAAAABgD8QvAAAM4ElEQVQAq+WT1YuqJ1evrw6PjQNs0Seq/1WdWv2/podtAVg9r215CrRvq24aHQJYawdbrsLasers0SEAYCcUNwAAAAAAAGA13VD9ePWEpgkch8bGAR7ALdWLqydVv9nyPOwLwM7cWl00OsSmV40OAOwJ5zUVOJbBH1fXjw4BADuhuAEAAAAAAACr7camCRyPqw5UnxsbB9j0qernmspV+1OuAlgnB0YHqP6i+uDoEMCecFt14egQm/aNDgAAO6W4AQAAAAAAAOvh5uonmwocZ1d3j40De9ZnqtOrx1evru4ZGweAOXhfdcXgDGcN3h/YW84YHaBp0salo0MAwE4pbgAAAAAAAMB6ubX62eqU6herm8bGgT3jw9WLq8dUL6/+dWwcAOZs5KnvN1SXDNwf2HuurS4bnOHMwfsDwK4obgAAAAAAAMB6ur36taYJHD9cfWBsHFhLx6o/rL63OrXaX905NBEAi/K71cagvc9o+j8IYJHOGbj3ndWbBu4PALumuAEAAAAAAADr7Uj1O9Wzq/9cvX3ze8DO3dF00vqTqv9W/VEeoAXYaw5WFwzY9/bqtwfsC/BH1fWD9r6gunvQ3gAwE4obAAAAAAAAsHf8dfXC6vFNJzXfPjYOrJxrqv9dPbr6qcY9uAbActhfHV3wnudVhxa8J0BNReUzBux7tOl+CwArTXEDAAAAAAAA9p4bq59vevj8x6r3jo0DS+1odXH1vOqp1Wuru4YmAmBZ3Fr9/gL3O1QdWOB+ACd7Y7Wx4D3f2fQZFgBWmuIGAAAAAAAA7F33VG+qTqtOrc6pPj00ESyP26uzqsdVz6/+dGwcAJbUIk+Bf0t12wL3AzjZwer8Be+5b8H7AcBcKG4AAAAAAAAAVddVP1N9efWC6t1j48AwV1f/s/rq6iXVJ8bGAWDJ/WX1oQXtdcaC9gF4MPurIwva68qm+ywArDzFDQAAAAAAAOBk76i+o3pCdXp17dg4MHcfq15RPbX6uuq3qs8NTQTAKjlzAXv8SVPRFmC026oLF7TXgQXtAwBzp7gBAAAAAAAAPJAbqpdXT6meWZ1V3TQ0EczOzdW+6luqJ1W/XF0zNBEAq+rCamPOe5w95/UBtmMR96SN6q0L2AcAFkJxAwAAAAAAANiKv69eUj2maRrH66rPDE0E2/eZ6vXVd1WnVD9V/c3QRACsg4NN05rm5brq0jmuD7BdV1WXz3mP85vurwCwFhQ3AAAAAAAAgO04Wr27+onqUU0PwL+m+ujIUPAgbqj2V/+16d/sj1d/1vRvGQBm5bzm93/LGXNaF2A3zpnj2keqA3NcHwAW7vNGBwAAAAAAAABW1uGmB+D/rPrp6mur79u8TsvPIxnjaPX+6pLN6+qxcQDYIz5RXVx9/4zXva16y4zXBJiFS6rrqyfMYe2LqlvnsC4ADGPiBgAAAAAAADAr11VnVd9efXn1Q00PGn56ZCj2hDubHu76seorqm+tXpXSBgCLNY/T4c+tDs1hXYDdOtb8pm7sn9O6ADDMw0YH2EO+rPrU6BAAAACwxx2uvmB0CJixZ1Z/OzoEwJxd3vQQOLC6Hl59Q/Vtm9dzqi8Zmoh18E/dN1Xj8qbPfAAw2tXVU2e01qHqq6rbZ7QewKw9orql+qIZrnll9fQZrgesr2uqU0eHWLCNpmfSWUFGEwMAAAAAAADzdrS6YvM6p+mAueNFjv9SPbf60mHpWBUfrv6y+qvN66Nj4wDA/Tq3eu2M1npjShvAcru7+o3qJTNc88wZrgUAS8PEjcUxcQMAAADGM3GDdWTiBrAXmLgB6+9h1dd330SO5+b0wL3u3qaTdo8XNS6vPj00EQBszSOqm6tH7nKdY9VTqut2nQhgvk6pPt40aXG3bt1c78gM1gLWn4kbrBQTNwAAAAAAAIDRjlUf3Lz2b37viU0l1Wec8Goqx3q6t/pQ9XfV32++XlHdMzIUAOzQ3dUbqhfvcp0/TGkDWA03VhdVL5jBWq9NaQOANWXixuKYuAEAAADjmbjBOjJxA9gLTNwAjnts/7bI8czqUUMTsV1Huq+kcfy6svrcyFAAMGNPrD7S7p7N+s7qz2cTB2Dunl29f5drHKm+suk0eYCtMHGDlWLiBgAAAAAAALAqPr55vfOE7z26qcRxYqHj0YuPxv04XF3dfVM0jpc0Do4MBQAL8LHq0up7dvj+D6a0AayWv2kqbnzLLta4MKUNANaY4gYAAAAArLbPVu8ZHQJgzq4YHQBYajdtXpec8L1HNJ10/bgTrsee8LWTCWfnUPVP1UdPuj5WXd90ai4A7EUH2nlx48xZBgFYkHOqt+3y/QCwtnYzjo/t+bLqU6NDAAAAwB53uPqC0SEAAIDhvrCp2HFK9fjN18dVjznhYvLZ6l9OuG6s/rn6cFMx44Zx0QBgqT2saVLY12zzfbc1TQ9TfgRWzcOb7nun7OC9761Om20cYA+4pjp1dIgF28iBJCvLxA0AAAAAAABgr7mn+sfN64F8Tf+2yHH8elT1yOqLN1//41yTzsdGdcfmtVHdUt3cfeWMmzZ/fVPT3xUAsH3Hmk6PP3ub73tNShvAajpa7atevYP37ptxFgBYOiZuLI6JGwAAADCeiRsAAMA8fElTkeN4mePk1y+s/kP1+ZvX5z3A1yf/+kjT55jDJ339QNeh6q6mQsZnuq+cceJ115z+DgCAf++RTWXIR2zx999TfWV159wSAczXFzUVw7d636tpqt9jm4ofANvxTa3mgRq7cbhpShErSHFjcRQ3AAAAYDzFDQAAAABgkb6x+k9b/L23V1fNMQvAInxDU7l9q26prp1TFgBYGoobi6O4AQAAAOMpbgAAAAAAAAAAC/Xw0QEAAAAAAAAAAAAAAADWlYkbi/Ow6otHhwAAAIA97lh1x+gQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC79/8BRAXQpSIoZpkAAAAASUVORK5CYII="
          },
          style: {
            position: 'static',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '152px',
            maxHeight: '65px',
            paddingBottom: '2px',
            paddingLeft: '10px',
            paddingRight: '10px',
            cursor: 'pointer'

          }
        }]
      }]
    }]
  }, {
    attributes: {
      src: {
        set: function (newLogoDataURL, _, node) {
          if ('src' in node) node.src = newLogoDataURL;
        }
      }
    }
  });

  joint.shapes.dwgtemplate.logoBlock2View = joint.dia.ElementView.extend({

    events: {
      'change input': 'onInputChange',
      'click div': 'onLogoClick'
    },

    onInputChange: function (evt) {
      try {
        const file = evt.target.files[0];
        // encode the file using the FileReader API
        const reader = new FileReader();
        reader.onloadend = () => {
          this.model.attr('secondCellImage/src', reader.result);
        };
        reader.readAsDataURL(file);
      }
      catch {
        return;
      }

    },
    onLogoClick: function (evt) {
      document.getElementById('second_Cell_Image_Upload_Label').click()
    }
  });


  joint.shapes.mix = joint.shapes.mix || {}
  joint.shapes.mix.Connector = joint.shapes.standard.Link.define('mix.Connector', {
    z: 0,
    attrs: {
      line: {
        sourceMarker: {
          'type': 'circle',
          'r': 4,
          'stroke': '#333333'
        },
        targetMarker: {
          'type': 'circle',
          'r': 4,
          'stroke': '#333333'
        }
      }
    }
  }, {

  }, {
    create: function (source, target) {
      var connector = new this();
      if (Array.isArray(source)) {
        connector.source(source[0], {
          anchor: {
            name: 'center',
            args: {
              dy: source[1]
            }
          }
        });
      } else {
        connector.source(source, { selector: source.isLink() ? 'root' : 'body' });
      }
      if (Array.isArray(target)) {
        connector.target(target[0], {
          priority: true,
          anchor: {
            name: 'center',
            args: {
              dy: target[1]
            }
          }
        });
      } else {
        connector.target(target, { selector: target.isLink() ? 'root' : 'body' });
      }
      return connector;
    }
  });
}

